var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonetizationImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 184,
    viewBox: "0 0 243 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5893 22.5815H23.9508C23.026 22.5815 22.2764 23.3321 22.2764 24.2581V49.7897C22.2764 50.7156 23.026 51.4662 23.9508 51.4662H93.5893C94.514 51.4662 95.2637 50.7156 95.2637 49.7897V24.2581C95.2637 23.3321 94.514 22.5815 93.5893 22.5815Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6958 36.5411L34.6579 30.6829C32.9341 30.6943 31.1761 31.3748 29.8282 32.5685C28.2411 33.9713 27.2236 36.085 27.5008 38.6358C27.5311 38.9134 27.5767 39.1985 27.6374 39.4874C27.6374 39.495 27.6374 39.5026 27.6412 39.5064L34.692 37.9173V36.5411H34.6958Z",
    fill: "#A9EBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9631 34.7353C40.9759 32.6748 39.0357 31.0249 36.2716 30.7474C36.1994 30.7398 36.1235 30.7322 36.0476 30.7284C36.002 30.7284 35.9526 30.7208 35.9071 30.717C35.7666 30.7094 35.6261 30.7056 35.4818 30.7056C35.4742 30.7056 35.4704 30.7056 35.4628 30.7056C35.4628 30.7056 35.4514 30.7056 35.4438 30.7056L35.4818 36.5677L35.4894 37.9438L42.544 39.4835H42.5516C42.6579 38.9893 42.7111 38.4799 42.7073 37.9629C42.7035 36.8642 42.4453 35.7503 41.9593 34.7353H41.9631Z",
    fill: "#33A68F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0718 38.6472L28.021 40.2363C28.7462 43.4677 31.6242 45.8855 35.0718 45.8855C38.5194 45.8855 41.4278 43.4449 42.134 40.1907L35.0794 38.651",
    fill: "#30CFB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3686 32.4316H47.4307V34.0549H88.3686V32.4316Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3686 36.7161H47.4307V38.3393H88.3686V36.7161Z",
    fill: "#E1E1E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9053 41.4526H47.4307V43.0759H71.9053V41.4526Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.714 73.447H93.0652V91.2652H96.714V73.447Z",
    fill: "#30CFB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4953 64.5361H94.2803V73.4471H95.4953V64.5361Z",
    fill: "#A9EBDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4953 91.2654H94.2803V100.176H95.4953V91.2654Z",
    fill: "#A9EBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3495 68.9917H84.7007V86.8099H88.3495V68.9917Z",
    fill: "#30CFB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1308 60.0808H85.9158V68.9918H87.1308V60.0808Z",
    fill: "#A9EBDB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1308 86.8101H85.9158V95.721H87.1308V86.8101Z",
    fill: "#A9EBDB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.075 75.3289H101.426V93.147H105.075V75.3289Z",
    fill: "#30CFB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.86 66.418H102.645V75.329H103.86V66.418Z",
    fill: "#A9EBDB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.86 93.1472H102.645V102.058H103.86V93.1472Z",
    fill: "#A9EBDB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.439 64.8975H109.791V82.7156H113.439V64.8975Z",
    fill: "#30CFB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.224 55.9902H111.009V64.9012H112.224V55.9902Z",
    fill: "#A9EBDB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.224 82.7195H111.009V91.6305H112.224V82.7195Z",
    fill: "#A9EBDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.987 63.293H168.338V81.1111H171.987V63.293Z",
    fill: "#30CFB0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.772 54.3821H169.557V63.2931H170.772V54.3821Z",
    fill: "#A9EBDB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.772 81.1113H169.557V90.0223H170.772V81.1113Z",
    fill: "#A9EBDB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M163.626 58.8374H159.978V76.6556H163.626V58.8374Z",
    fill: "#30CFB0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162.408 49.9265H161.193V58.8375H162.408V49.9265Z",
    fill: "#A9EBDB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.408 76.6558H161.193V85.5667H162.408V76.6558Z",
    fill: "#A9EBDB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.351 65.175H176.703V82.9932H180.351V65.175Z",
    fill: "#30CFB0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M179.136 56.2678H177.921V65.1788H179.136V56.2678Z",
    fill: "#A9EBDB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.136 82.9971H177.921V91.9081H179.136V82.9971Z",
    fill: "#A9EBDB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.081 53.2756H193.432V71.0938H197.081V53.2756Z",
    fill: "#30CFB0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M195.862 44.3647H194.647V53.2757H195.862V44.3647Z",
    fill: "#A9EBDB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.862 71.094H194.647V80.005H195.862V71.094Z",
    fill: "#A9EBDB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205.445 45.0718H201.796V62.8899H205.445V45.0718Z",
    fill: "#30CFB0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M204.226 36.1609H203.011V45.0719H204.226V36.1609Z",
    fill: "#A9EBDB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M204.226 62.8901H203.011V71.8011H204.226V62.8901Z",
    fill: "#A9EBDB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M188.716 49.9268H185.067V67.7449H188.716V49.9268Z",
    fill: "#30CFB0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M187.497 41.0195H186.282V49.9305H187.497V41.0195Z",
    fill: "#A9EBDB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M187.497 67.7488H186.282V76.6598H187.497V67.7488Z",
    fill: "#A9EBDB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M222.174 48.98H218.525V66.7981H222.174V48.98Z",
    fill: "#30CFB0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M220.955 40.0691H219.74V48.9801H220.955V40.0691Z",
    fill: "#A9EBDB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M220.955 66.7983H219.74V75.7093H220.955V66.7983Z",
    fill: "#A9EBDB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M230.535 38.6624H226.886V56.4805H230.535V38.6624Z",
    fill: "#30CFB0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M229.32 29.7515H228.105V38.6624H229.32V29.7515Z",
    fill: "#A9EBDB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M229.32 56.4807H228.105V65.3917H229.32V56.4807Z",
    fill: "#A9EBDB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M213.81 54.6101H210.161V72.4283H213.81V54.6101Z",
    fill: "#30CFB0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M212.591 45.6992H211.376V54.6102H212.591V45.6992Z",
    fill: "#A9EBDB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M212.591 72.4285H211.376V81.3394H212.591V72.4285Z",
    fill: "#A9EBDB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M121.804 55.6252H118.155V73.4434H121.804V55.6252Z",
    fill: "#30CFB0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M120.589 46.718H119.374V55.629H120.589V46.718Z",
    fill: "#A9EBDB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M120.589 73.4473H119.374V82.3582H120.589V73.4473Z",
    fill: "#A9EBDB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.168 49.459H126.52V67.2771H130.168V49.459Z",
    fill: "#30CFB0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M128.95 40.5481H127.735V49.4591H128.95V40.5481Z",
    fill: "#A9EBDB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M128.95 67.2773H127.735V76.1883H128.95V67.2773Z",
    fill: "#A9EBDB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M138.533 53.9106H134.884V71.7288H138.533V53.9106Z",
    fill: "#30CFB0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M137.314 45.0034H136.099V53.9144H137.314V45.0034Z",
    fill: "#A9EBDB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M137.314 71.7327H136.099V80.6436H137.314V71.7327Z",
    fill: "#A9EBDB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M146.897 57.5107H143.249V75.3289H146.897V57.5107Z",
    fill: "#30CFB0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M145.679 48.5999H144.464V57.5108H145.679V48.5999Z",
    fill: "#A9EBDB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M145.679 75.3291H144.464V84.2401H145.679V75.3291Z",
    fill: "#A9EBDB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M46.527 85.7949H42.8782V103.613H46.527V85.7949Z",
    fill: "#30CFB0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3119 76.8877H44.0969V85.7987H45.3119V76.8877Z",
    fill: "#A9EBDB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3119 103.617H44.0969V112.528H45.3119V103.617Z",
    fill: "#A9EBDB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8915 94.1582H51.2427V111.976H54.8915V94.1582Z",
    fill: "#30CFB0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6764 85.2473H52.4614V94.1583H53.6764V85.2473Z",
    fill: "#A9EBDB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6764 111.977H52.4614V120.888H53.6764V111.977Z",
    fill: "#A9EBDB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.256 87.9885H59.6072V105.807H63.256V87.9885Z",
    fill: "#30CFB0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0409 79.0813H60.8259V87.9923H62.0409V79.0813Z",
    fill: "#A9EBDB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0409 105.811H60.8259V114.722H62.0409V105.811Z",
    fill: "#A9EBDB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6205 77.5149H67.9717V95.3331H71.6205V77.5149Z",
    fill: "#30CFB0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4018 68.6077H69.1868V77.5186H70.4018V68.6077Z",
    fill: "#A9EBDB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4018 95.3369H69.1868V104.248H70.4018V95.3369Z",
    fill: "#A9EBDB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M79.985 81.115H76.3362V98.9331H79.985V81.115Z",
    fill: "#30CFB0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7663 72.2041H77.5513V81.1151H78.7663V72.2041Z",
    fill: "#A9EBDB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7663 98.9333H77.5513V107.844H78.7663V98.9333Z",
    fill: "#A9EBDB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8016 109.619H26.1528V127.438H29.8016V109.619Z",
    fill: "#30CFB0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5829 100.708H27.3679V109.619H28.5829V100.708Z",
    fill: "#A9EBDB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5829 127.438H27.3679V136.349H28.5829V127.438Z",
    fill: "#A9EBDB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1661 96.2568H34.5173V114.075H38.1661V96.2568Z",
    fill: "#30CFB0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 87.3459H35.7324V96.2569H36.9474V87.3459Z",
    fill: "#A9EBDB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 114.075H35.7324V122.986H36.9474V114.075Z",
    fill: "#A9EBDB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0726 116.303H9.42383V134.121H13.0726V116.303Z",
    fill: "#30CFB0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8539 107.392H10.6389V116.303H11.8539V107.392Z",
    fill: "#A9EBDB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8539 134.121H10.6389V143.032H11.8539V134.121Z",
    fill: "#A9EBDB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4371 102.936H17.7883V120.754H21.4371V102.936Z",
    fill: "#30CFB0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2184 94.0291H19.0034V102.94H20.2184V94.0291Z",
    fill: "#A9EBDB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2184 120.758H19.0034V129.669H20.2184V120.758Z",
    fill: "#A9EBDB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M155.262 46.718H151.613V64.5362H155.262V46.718Z",
    fill: "#30CFB0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M154.043 37.8071H152.828V46.7181H154.043V37.8071Z",
    fill: "#A9EBDB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M154.043 64.5364H152.828V73.4474H154.043V64.5364Z",
    fill: "#A9EBDB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69531 4.68188H237.305C240.173 4.68188 242.5 7.0105 242.5 9.8843V174.114C242.5 176.988 240.173 179.316 237.305 179.316H5.69531C2.82661 179.316 0.5 176.988 0.5 174.114V9.8843C0.5 7.0105 2.82661 4.68188 5.69531 4.68188Z",
    stroke: "#849A9F",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1078 153.262L40.824 152.962L43.6565 147.077L43.0565 143.648C43.0565 143.648 45.6802 143.02 46.1548 147.567C46.6294 152.114 46.7661 150.913 46.7661 150.913C46.7661 150.913 52.4045 149.947 52.9588 150.354C53.3613 150.65 54.4965 156.227 55.085 159.253C55.3812 160.778 54.694 162.363 53.3347 162.975C53.141 163.063 52.9436 163.127 52.7424 163.161C51.3375 163.409 43.9564 163.523 43.9564 163.523L40.991 164.043L39.104 153.262H39.1078Z",
    fill: "#F0F0F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0276 153.182L37.141 164.751L40.0798 164.234L38.0637 152.719L34.0276 153.182Z",
    fill: "#F0F0F0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M121.853 169.506C157.529 169.506 186.45 140.549 186.45 104.829C186.45 69.1094 157.529 40.1526 121.853 40.1526C86.1778 40.1526 57.2571 69.1094 57.2571 104.829C57.2571 140.549 86.1778 169.506 121.853 169.506Z",
    fill: "#CCEDE8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35_119664",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 40,
    width: 130,
    height: 130
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M121.853 169.506C157.529 169.506 186.45 140.549 186.45 104.829C186.45 69.1094 157.529 40.1526 121.853 40.1526C86.1778 40.1526 57.2571 69.1094 57.2571 104.829C57.2571 140.549 86.1778 169.506 121.853 169.506Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35_119664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 38.1376V44.5623L59.63 43.8438H59.6337V37.4153L56.5431 35.6323L55.3015 36.3508L58.3884 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 45.9766V39.5481L53.46 40.2666L53.4524 40.2704V46.6951L56.543 48.4819L57.7884 47.7634L54.6978 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 38.841V45.2695L56.5431 45.6307L57.162 45.2733L57.1658 45.2695V38.841L56.5431 38.4836L55.9432 38.8296L55.9204 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 30.6486L62.1019 32.4353V38.8601L62.0981 38.8563V45.2696L59.0112 47.0563L57.7659 46.334L60.8565 44.5473V38.1225V31.713L63.9472 29.9263V29.9301H63.9548L65.1926 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 38.8449V32.4202L63.3283 33.1349L63.3245 33.1387V39.5672L66.4151 41.3502L67.6605 40.6317L64.5698 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 31.7129V38.1338L69.502 39.5632V45.9879L68.2566 45.2695L68.2604 39.567V38.8409L70.7246 37.4191V30.9944L71.9699 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 38.1376V44.5623L76.8985 43.8438H76.9061V37.4153L73.8154 35.6323L72.5701 36.3508L75.6607 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 45.9766V39.5481L70.7284 40.2666L70.7246 40.2704V46.6951L73.8153 48.4819L75.0606 47.7634L71.97 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 38.841V45.2695L73.8153 45.6307L74.4304 45.2733L74.438 45.2695V38.841L73.8153 38.4836L73.2154 38.8296L73.1926 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 30.6486L79.3701 32.4353V45.2696L76.2832 47.0563H76.2794L75.0378 46.334L78.1285 44.5473V31.713L81.2192 29.9263V29.9301H81.223L82.4607 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 38.8449V32.4202L80.6004 33.1349L80.5928 33.1387V39.5672L83.6834 41.3502L84.9288 40.6317L81.8381 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 31.7129V38.1376L86.7741 39.5632V45.9879L85.5249 45.2695L85.5287 39.5632V38.8409L87.9967 37.4191V30.9944L89.2382 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 38.1376V44.5623L94.1702 43.8438H94.1778V37.4153L91.0872 35.6323L89.8418 36.3508L92.9286 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 45.9766V39.5481L88.0004 40.2666L87.9966 40.2704V46.6951L91.0872 48.4819L92.3326 47.7634L89.242 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 38.841V45.2695L91.0872 45.6307L91.7023 45.2733L91.7099 45.2695V38.841L91.0872 38.4836L90.4835 38.8296L90.4607 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 30.6486L96.6419 32.4353V38.8601V38.8563V45.2696L93.5513 47.0563L92.3059 46.334L95.3966 44.5473V38.1225L95.4004 31.713L98.4872 29.9263L98.491 29.9301H98.4948L99.7326 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 38.8449V32.4202L97.8721 33.1349L97.8645 33.1387V39.5672L100.955 41.3502L102.201 40.6317L99.1099 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 31.7129V38.1338L104.042 39.5632V45.9879L102.797 45.2695L102.8 39.567V38.8409L105.268 37.4191V30.9944L106.51 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 38.1376V44.5623L111.442 43.8438H111.446V37.4153L108.355 35.6323L107.114 36.3508L110.201 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 45.9766V39.5481L105.272 40.2666L105.265 40.2704V46.6951L108.355 48.4819L109.601 47.7634L106.51 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 38.841V45.2695L108.355 45.6307L108.974 45.2733L108.978 45.2695V38.841L108.355 38.4836L107.755 38.8296L107.733 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 30.6486L113.914 32.4353V45.2696L110.823 47.0563L109.574 46.334L112.665 44.5473V38.1225L112.669 31.713L115.756 29.9263L115.759 29.9301H115.763L117.005 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 38.8449V32.4202L115.141 33.1349L115.137 33.1387V39.5672L118.227 41.3502L119.473 40.6317L116.382 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 31.7129V38.1376L121.314 39.5632V45.9879L120.069 45.2695V39.5632V38.8409L122.537 37.4191V30.9944L123.782 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 38.1376V44.5623L128.711 43.8438H128.718V37.4153L125.627 35.6323L124.382 36.3508L127.473 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 45.9766V39.5481L122.541 40.2666L122.537 40.2704V46.6951L125.628 48.4819L126.873 47.7634L123.782 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 38.841V45.2695L125.628 45.6307L126.243 45.2733L126.25 45.2695V38.841L125.628 38.4836L125.028 38.8296L125.005 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 30.6486L131.186 32.4353V38.8601L131.182 38.8563V45.2696L128.095 47.0563L126.846 46.334L129.937 44.5473V38.1225L129.941 31.713L133.028 29.9263L133.031 29.9301H133.035L134.277 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 38.8449V32.4202L132.412 33.1349L132.405 33.1387V39.5672L135.495 41.3502L136.741 40.6317L133.65 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 31.7129V38.1338L138.586 39.5632V45.9879L137.341 45.2695V39.567V38.8409L139.809 37.4191V30.9944L141.054 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 38.1376V44.5623L145.982 43.8438H145.99V37.4153L142.899 35.6323L141.654 36.3508L144.741 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 45.9766V39.5481L139.813 40.2666L139.809 40.2704V46.6951L142.899 48.4819L144.145 47.7634L141.054 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 38.841V45.2695L142.896 45.6307L143.515 45.2733L143.522 45.2695V38.841L142.896 38.4836L142.296 38.8296L142.273 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 30.6486L148.454 32.4353V45.2696L145.367 47.0563H145.364L144.118 46.334L147.209 44.5473V38.1225V31.713L150.299 29.9263V29.9301H150.307L151.545 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 38.8449V32.4202L149.681 33.1349L149.677 33.1387V39.5672L152.767 41.3502L154.013 40.6317L150.922 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 31.7129V38.1376L155.854 39.5632V45.9879L154.609 45.2695L154.613 39.5632V38.8409L157.077 37.4191V30.9944L158.322 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 38.1376V44.5623L163.251 43.8438H163.258V37.4153L160.168 35.6323L158.926 36.3508L162.013 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 45.9766V39.5481L157.084 40.2666L157.077 40.2704V46.6951L160.168 48.4819L161.413 47.7634L158.322 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 38.841V45.2695L160.168 45.6307L160.786 45.2733L160.79 45.2695V38.841L160.168 38.4836L159.568 38.8296L159.545 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 30.6486L165.726 32.4353V38.8601L165.722 38.8563V45.2696L162.636 47.0563L161.39 46.334L164.481 44.5473V38.1225V31.713L167.571 29.9263V29.9301H167.579L168.817 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 38.8449V32.4202L166.953 33.1349L166.949 33.1387V39.5672L170.039 41.3502L171.285 40.6317L168.194 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 31.7129V38.1338L173.126 39.5632V45.9879L171.881 45.2695V38.8409L174.349 37.4191V30.9944L175.594 31.7129Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 38.1376V44.5623L180.523 43.8438H180.53V37.4153L177.439 35.6323L176.194 36.3508L179.285 38.1376Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 45.9766V39.5481L174.353 40.2666L174.349 40.2704V46.6951L177.44 48.4819L178.685 47.7634L175.594 45.9766Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 38.841V45.2695L177.44 45.6307L178.055 45.2733L178.062 45.2695V38.841L177.44 38.4836L176.84 38.8296L176.817 38.841Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 30.6486L182.994 32.4353V45.2696L179.907 47.0563H179.904L178.658 46.334L181.749 44.5473V38.1225L181.753 31.713L184.84 29.9263L184.843 29.9301H184.847L186.085 30.6486Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 38.8449V32.4202L184.224 33.1349L184.217 33.1387V39.5672L187.307 41.3502L188.553 40.6317L185.462 38.8449Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 55.2641V61.6888L59.63 60.9741L59.6337 60.9703V54.5456L56.5431 52.7588L55.3015 53.4773L58.3884 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 63.1031V56.6746L53.46 57.3931L53.4524 57.3969V63.8216L56.543 65.6084L57.7884 64.8898L54.6978 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 55.9713V62.396L56.5431 62.7571L57.162 62.3998L57.1658 62.396V55.9713L56.5431 55.6101L55.9432 55.9561L55.9204 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 47.7751L62.1019 49.5618V55.9865L62.0981 55.9827V62.3961L59.0112 64.1828L57.7659 63.4605L60.8565 61.6737V55.249V48.8433L63.9472 47.0527V47.0565H63.9548L65.1926 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 48.1361V54.5608L69.4981 53.8423L69.5057 53.8385V47.4138L66.4151 45.6309L65.1697 46.3494L68.2565 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 55.9714V49.5466L63.3283 50.2613L63.3245 50.2651V56.6937L66.4151 58.4766L67.6605 57.7581L64.5698 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 48.8432V55.2603L69.502 56.6897V63.1144L68.2566 62.3959L68.2604 56.6935V55.9712L70.7246 54.5456V48.1208L71.9699 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 55.2603V55.2679L69.502 56.6973",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 48.8395V55.2681L66.4152 55.6254L67.0303 55.2681H67.0379V48.8395L66.4152 48.4822L65.8115 48.8281L65.7925 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 54.5457L68.2605 55.9713",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 55.2641V61.6888L76.8985 60.9741L76.9061 60.9703V54.5456L73.8154 52.7588L72.5701 53.4773L75.6607 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 63.1031V56.6746L70.7284 57.3931L70.7246 57.3969V63.8216L73.8153 65.6084L75.0606 64.8898L71.97 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 55.9713V62.396L73.8153 62.7571L74.4304 62.3998L74.438 62.396V55.9713L73.8153 55.6101L73.2154 55.9561L73.1926 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 47.7751L79.3701 49.5618V62.3961L76.2832 64.1828H76.2794L75.0378 63.4605L78.1285 61.6737V48.8433L81.2192 47.0527V47.0565H81.223L82.4607 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 48.1361V54.5608L86.7701 53.8423L86.7739 53.8385V47.4138L83.6832 45.6309L82.4417 46.3494L85.5285 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 55.9714V49.5466L80.6004 50.2613L80.5928 50.2651V56.6937L83.6834 58.4766L84.9288 57.7581L81.8381 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 48.8432V55.2641L86.7741 56.6897V63.1144L85.5249 62.3959L85.5287 56.6897V55.9712L87.9967 54.5456V48.1208L89.2382 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 55.2642V55.268L86.7739 56.6974",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 48.8395V55.2681L83.6832 55.6254L84.3021 55.2681H84.3059V48.8395L83.6832 48.4822L83.0833 48.8281L83.0605 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 54.5457L85.5286 55.9713",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 55.2641V61.6888L94.1702 60.9741L94.1778 60.9703V54.5456L91.0872 52.7588L89.8418 53.4773L92.9286 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 63.1031V56.6746L88.0004 57.3931L87.9966 57.3969V63.8216L91.0872 65.6084L92.3326 64.8898L89.242 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 55.9713V62.396L91.0872 62.7571L91.7023 62.3998L91.7099 62.396V55.9713L91.0872 55.6101L90.4835 55.9561L90.4607 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 47.7751L96.6419 49.5618V55.9865V55.9827V62.3961L93.5513 64.1828L92.3059 63.4605L95.3966 61.6737V55.249L95.4004 48.8433L98.4872 47.0527L98.491 47.0565H98.4948L99.7326 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 48.1361V54.5608L104.038 53.8423L104.046 53.8385V47.4138L100.955 45.6309L99.7097 46.3494L102.8 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 55.9714V49.5466L97.8721 50.2613L97.8645 50.2651V56.6937L100.955 58.4766L102.201 57.7581L99.1099 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 48.8432V55.2603L104.042 56.6897V63.1144L102.797 62.3959L102.8 56.6935V55.9712L105.268 54.5456V48.1208L106.51 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 55.2603V55.2679L104.042 56.6973",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 48.8395V55.2681L100.955 55.6254L101.57 55.2681H101.578V48.8395L100.955 48.4822L100.355 48.8281L100.333 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 54.5457L102.801 55.9713",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 55.2641V61.6888L111.442 60.9741L111.446 60.9703V54.5456L108.355 52.7588L107.114 53.4773L110.201 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 63.1031V56.6746L105.272 57.3931L105.265 57.3969V63.8216L108.355 65.6084L109.601 64.8898L106.51 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 55.9713V62.396L108.355 62.7571L108.974 62.3998L108.978 62.396V55.9713L108.355 55.6101L107.755 55.9561L107.733 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 47.7751L113.914 49.5618V62.3961L110.823 64.1828L109.574 63.4605L112.665 61.6737V55.249L112.669 48.8433L115.756 47.0527L115.759 47.0565H115.763L117.005 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 48.1361V54.5608L121.31 53.8423L121.318 53.8385V47.4138L118.227 45.6309L116.982 46.3494L120.069 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 55.9714V49.5466L115.141 50.2613L115.137 50.2651V56.6937L118.227 58.4766L119.473 57.7581L116.382 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 48.8432V55.2641L121.314 56.6897V63.1144L120.069 62.3959V56.6897V55.9712L122.537 54.5456V48.1208L123.782 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 55.2642V55.268L121.314 56.6974",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 48.8395V55.2681L118.227 55.6254L118.842 55.2681H118.85V48.8395L118.227 48.4822L117.624 48.8281L117.601 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 54.5457L120.069 55.9713",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 55.2641V61.6888L128.711 60.9741L128.718 60.9703V54.5456L125.627 52.7588L124.382 53.4773L127.473 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 63.1031V56.6746L122.541 57.3931L122.537 57.3969V63.8216L125.628 65.6084L126.873 64.8898L123.782 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 55.9713V62.396L125.628 62.7571L126.243 62.3998L126.25 62.396V55.9713L125.628 55.6101L125.028 55.9561L125.005 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 47.7751L131.186 49.5618V55.9865L131.182 55.9827V62.3961L128.095 64.1828L126.846 63.4605L129.937 61.6737V55.249L129.941 48.8433L133.028 47.0527L133.031 47.0565H133.035L134.277 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 48.1361V54.5608L138.582 53.8423L138.586 53.8385V47.4138L135.495 45.6309L134.254 46.3494L137.341 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 55.9714V49.5466L132.412 50.2613L132.405 50.2651V56.6937L135.495 58.4766L136.741 57.7581L133.65 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 48.8432V55.2603L138.586 56.6897V63.1144L137.341 62.3959V56.6935V55.9712L139.809 54.5456V48.1208L141.054 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 55.2603V55.2679L138.582 56.6973",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 48.8395V55.2681L135.495 55.6254L136.114 55.2681H136.118V48.8395L135.495 48.4822L134.896 48.8281L134.873 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 54.5457L137.341 55.9713",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 55.2641V61.6888L145.982 60.9741L145.99 60.9703V54.5456L142.899 52.7588L141.654 53.4773L144.741 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 63.1031V56.6746L139.813 57.3931L139.809 57.3969V63.8216L142.899 65.6084L144.145 64.8898L141.054 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 55.9713V62.396L142.896 62.7571L143.515 62.3998L143.522 62.396V55.9713L142.896 55.6101L142.296 55.9561L142.273 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 47.7751L148.454 49.5618V62.3961L145.367 64.1828H145.364L144.118 63.4605L147.209 61.6737V55.249V48.8433L150.299 47.0527V47.0565H150.307L151.545 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 48.1361V54.5608L155.85 53.8423L155.858 53.8385V47.4138L152.767 45.6309L151.522 46.3494L154.613 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 55.9714V49.5466L149.681 50.2613L149.677 50.2651V56.6937L152.767 58.4766L154.013 57.7581L150.922 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 48.8432V55.2641L155.854 56.6897V63.1144L154.609 62.3959L154.613 56.6897V55.9712L157.077 54.5456V48.1208L158.322 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 55.2642V55.268L155.854 56.6936",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 48.8395V55.2681L152.767 55.6254L153.383 55.2681H153.39V48.8395L152.767 48.4822L152.168 48.8281L152.145 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 54.5457L154.613 55.9713",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 55.2641V61.6888L163.251 60.9741L163.258 60.9703V54.5456L160.168 52.7588L158.926 53.4773L162.013 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 63.1031V56.6746L157.084 57.3931L157.077 57.3969V63.8216L160.168 65.6084L161.413 64.8898L158.322 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 55.9713V62.396L160.168 62.7571L160.786 62.3998L160.79 62.396V55.9713L160.168 55.6101L159.568 55.9561L159.545 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 47.7751L165.726 49.5618V55.9865L165.722 55.9827V62.3961L162.636 64.1828L161.39 63.4605L164.481 61.6737V55.249V48.8433L167.571 47.0527V47.0565H167.579L168.817 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 48.1361V54.5608L173.122 53.8423L173.13 53.8385V47.4138L170.039 45.6309L168.794 46.3494L171.881 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 55.9714V49.5466L166.953 50.2613L166.949 50.2651V56.6937L170.039 58.4766L171.285 57.7581L168.194 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 48.8432V55.2603L173.126 56.6897V63.1144L171.881 62.3959V55.9712L174.349 54.5456V48.1208L175.594 48.8432Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 55.2603V55.2679L173.126 56.6973",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 48.8395V55.2681L170.039 55.6254L170.654 55.2681H170.662V48.8395L170.039 48.4822L169.436 48.8281L169.413 48.8395Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 54.5417L171.881 55.9712",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 55.2641V61.6888L180.523 60.9741L180.53 60.9703V54.5456L177.439 52.7588L176.194 53.4773L179.285 55.2641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 63.1031V56.6746L174.353 57.3931L174.349 57.3969V63.8216L177.44 65.6084L178.685 64.8898L175.594 63.1031Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 55.9713V62.396L177.44 62.7571L178.055 62.3998L178.062 62.396V55.9713L177.44 55.6101L176.84 55.9561L176.817 55.9713Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 47.7751L182.994 49.5618V62.3961L179.907 64.1828H179.904L178.658 63.4605L181.749 61.6737V55.249L181.753 48.8433L184.84 47.0527L184.843 47.0565H184.847L186.085 47.7751Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 48.1361V54.5608L190.394 53.8423L190.398 53.8385V47.4138L187.308 45.6309L186.066 46.3494L189.153 48.1361Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 55.9714V49.5466L184.224 50.2613L184.217 50.2651V56.6937L187.307 58.4766L188.553 57.7581L185.462 55.9714Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 72.3903V78.815L59.63 78.1003L59.6337 78.0965V71.6718L56.5431 69.885L55.3015 70.6073L58.3884 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 80.2292V73.8044L53.46 74.5191L53.4524 74.5229V80.9477L56.543 82.7344L57.7884 82.0159L54.6978 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 73.0975V79.5222L56.5431 79.8834L57.162 79.526L57.1658 79.5222V73.0975L56.5431 72.7363L55.9432 73.0823L55.9204 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 64.9013L62.1019 66.688V73.1127L62.0981 73.1089V79.5223L59.0112 81.309L57.7659 80.5867L60.8565 78.8038V72.3752V65.9695L63.9472 64.179V64.1828L63.9548 64.1866L65.1926 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 65.2623V71.6871L69.4981 70.9686L69.5057 70.9648V64.54L66.4151 62.7571L65.1697 63.4756L68.2565 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 73.0976V66.6729L63.3283 67.3914L63.3245 67.3952V73.8199L66.4151 75.6066L67.6605 74.8881L64.5698 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 65.9694V72.3903L69.502 73.8159V80.2444L68.2566 79.5221L68.2604 73.8197V73.0974L70.7246 71.6756V65.2471L71.9699 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 72.3904V72.3942L69.502 73.8236",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 65.9657V72.3943L66.4152 72.7554L67.0303 72.3981L67.0379 72.3943V65.9657L66.4152 65.6084L65.8115 65.9543L65.7925 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 71.6719L68.2605 73.0975",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 72.3903V78.815L76.8985 78.1003L76.9061 78.0965V71.6718L73.8154 69.885L72.5701 70.6073L75.6607 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 80.2292V73.8044L70.7284 74.5191L70.7246 74.5229V80.9477L73.8153 82.7344L75.0606 82.0159L71.97 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 73.0975V79.5222L73.8153 79.8834L74.4304 79.526L74.438 79.5222V73.0975L73.8153 72.7363L73.2154 73.0823L73.1926 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 64.9013L79.3701 66.688V79.5223L76.2832 81.309H76.2794L75.0378 80.5867L78.1285 78.8038V65.9695L81.2192 64.179V64.1828L81.223 64.1866L82.4607 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 65.2623V71.6871L86.7701 70.9686L86.7739 70.9648V64.54L83.6832 62.7571L82.4417 63.4756L85.5285 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 73.0976V66.6729L80.6004 67.3914L80.5928 67.3952V73.8199L83.6834 75.6066L84.9288 74.8881L81.8381 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 65.9694V72.3903L86.7741 73.8159V80.2444L85.5249 79.5221L85.5287 73.8197V73.0974L87.9967 71.6756V65.2471L89.2382 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 72.3904V72.3942L86.7739 73.8236",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 65.9657V72.3943L83.6832 72.7554L84.3021 72.3981L84.3059 72.3943V65.9657L83.6832 65.6084L83.0833 65.9543L83.0605 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 71.6719L85.5286 73.0975",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 72.3903V78.815L94.1702 78.1003L94.1778 78.0965V71.6718L91.0872 69.885L89.8418 70.6073L92.9286 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 80.2292V73.8044L88.0004 74.5191L87.9966 74.5229V80.9477L91.0872 82.7344L92.3326 82.0159L89.242 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 73.0975V79.5222L91.0872 79.8834L91.7023 79.526L91.7099 79.5222V73.0975L91.0872 72.7363L90.4835 73.0823L90.4607 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 64.9013L96.6419 66.688V73.1127V73.1089V79.5223L93.5513 81.309L92.3059 80.5867L95.3966 78.8038V72.3752L95.4004 65.9695L98.4872 64.179L98.491 64.1828L98.4948 64.1866L99.7326 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 65.2623V71.6871L104.038 70.9686L104.046 70.9648V64.54L100.955 62.7571L99.7097 63.4756L102.8 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 73.0976V66.6729L97.8721 67.3914L97.8645 67.3952V73.8199L100.955 75.6066L102.201 74.8881L99.1099 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 65.9694V72.3903L104.042 73.8159V80.2444L102.797 79.5221L102.8 73.8197V73.0974L105.268 71.6756V65.2471L106.51 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 72.3904V72.3942L104.042 73.8236",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 65.9657V72.3943L100.955 72.7554L101.57 72.3981L101.578 72.3943V65.9657L100.955 65.6084L100.355 65.9543L100.333 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 71.6719L102.801 73.0975",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 72.3903V78.815L111.442 78.1003L111.446 78.0965V71.6718L108.355 69.885L107.114 70.6073L110.201 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 80.2292V73.8044L105.272 74.5191L105.265 74.5229V80.9477L108.355 82.7344L109.601 82.0159L106.51 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 73.0975V79.5222L108.355 79.8834L108.974 79.526L108.978 79.5222V73.0975L108.355 72.7363L107.755 73.0823L107.733 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 64.9013L113.914 66.688V79.5223L110.823 81.309L109.574 80.5867L112.665 78.8038V72.3752L112.669 65.9695L115.756 64.179L115.759 64.1828L115.763 64.1866L117.005 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 65.2623V71.6871L121.31 70.9686L121.318 70.9648V64.54L118.227 62.7571L116.982 63.4756L120.069 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 73.0976V66.6729L115.141 67.3914L115.137 67.3952V73.8199L118.227 75.6066L119.473 74.8881L116.382 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 65.9694V72.3903L121.314 73.8159V80.2444L120.069 79.5221V73.8197V73.0974L122.537 71.6756V65.2471L123.782 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 72.3904V72.3942L121.314 73.8236",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 65.9657V72.3943L118.227 72.7554L118.842 72.3981L118.85 72.3943V65.9657L118.227 65.6084L117.624 65.9543L117.601 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 71.6719L120.069 73.0975",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 72.3903V78.815L128.711 78.1003L128.718 78.0965V71.6718L125.627 69.885L124.382 70.6073L127.473 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 80.2292V73.8044L122.541 74.5191L122.537 74.5229V80.9477L125.628 82.7344L126.873 82.0159L123.782 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 73.0975V79.5222L125.628 79.8834L126.243 79.526L126.25 79.5222V73.0975L125.628 72.7363L125.028 73.0823L125.005 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 64.9013L131.186 66.688V73.1127L131.182 73.1089V79.5223L128.095 81.309L126.846 80.5867L129.937 78.8038V72.3752L129.941 65.9695L133.028 64.179L133.031 64.1828L133.035 64.1866L134.277 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 65.2623V71.6871L138.582 70.9686L138.586 70.9648V64.54L135.495 62.7571L134.254 63.4756L137.341 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 73.0976V66.6729L132.412 67.3914L132.405 67.3952V73.8199L135.495 75.6066L136.741 74.8881L133.65 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 65.9694V72.3903L138.586 73.8159V80.2444L137.341 79.5221V73.8197V73.0974L139.809 71.6756V65.2471L141.054 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 72.3904V72.3942L138.582 73.8236",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 65.9657V72.3943L135.495 72.7554L136.114 72.3981L136.118 72.3943V65.9657L135.495 65.6084L134.896 65.9543L134.873 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 71.6719L137.341 73.0975",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 72.3903V78.815L145.982 78.1003L145.99 78.0965V71.6718L142.899 69.885L141.654 70.6073L144.741 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 80.2292V73.8044L139.813 74.5191L139.809 74.5229V80.9477L142.899 82.7344L144.145 82.0159L141.054 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 73.0975V79.5222L142.896 79.8834L143.515 79.526L143.522 79.5222V73.0975L142.896 72.7363L142.296 73.0823L142.273 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 64.9013L148.454 66.688V79.5223L145.367 81.309H145.364L144.118 80.5867L147.209 78.8038V72.3752V65.9695L150.299 64.179V64.1828L150.307 64.1866L151.545 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 65.2623V71.6871L155.85 70.9686L155.858 70.9648V64.54L152.767 62.7571L151.522 63.4756L154.613 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 73.0976V66.6729L149.681 67.3914L149.677 67.3952V73.8199L152.767 75.6066L154.013 74.8881L150.922 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 65.9694V72.3903L155.854 73.8159V80.2444L154.609 79.5221L154.613 73.8197V73.0974L157.077 71.6756V65.2471L158.322 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 72.3904V72.3942L155.854 73.8198",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 65.9657V72.3943L152.767 72.7554L153.383 72.3981L153.39 72.3943V65.9657L152.767 65.6084L152.168 65.9543L152.145 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 71.6719L154.613 73.0975",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 72.3903V78.815L163.251 78.1003L163.258 78.0965V71.6718L160.168 69.885L158.926 70.6073L162.013 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 80.2292V73.8044L157.084 74.5191L157.077 74.5229V80.9477L160.168 82.7344L161.413 82.0159L158.322 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 73.0975V79.5222L160.168 79.8834L160.786 79.526L160.79 79.5222V73.0975L160.168 72.7363L159.568 73.0823L159.545 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 64.9013L165.726 66.688V73.1127L165.722 73.1089V79.5223L162.636 81.309L161.39 80.5867L164.481 78.8038V72.3752V65.9695L167.571 64.179V64.1828L167.579 64.1866L168.817 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 65.2623V71.6871L173.122 70.9686L173.13 70.9648V64.54L170.039 62.7571L168.794 63.4756L171.881 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 73.0976V66.6729L166.953 67.3914L166.949 67.3952V73.8199L170.039 75.6066L171.285 74.8881L168.194 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 65.9694V72.3903L173.126 73.8159V80.2444L171.881 79.5221V73.0974L174.349 71.6756V65.2471L175.594 65.9694Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 72.3904V72.3942L173.126 73.8236",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 65.9657V72.3943L170.039 72.7554L170.654 72.3981L170.662 72.3943V65.9657L170.039 65.6084L169.436 65.9543L169.413 65.9657Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 71.668L171.881 73.0974",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 72.3903V78.815L180.523 78.1003L180.53 78.0965V71.6718L177.439 69.885L176.194 70.6073L179.285 72.3903Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 80.2292V73.8044L174.353 74.5191L174.349 74.5229V80.9477L177.44 82.7344L178.685 82.0159L175.594 80.2292Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 73.0975V79.5222L177.44 79.8834L178.055 79.526L178.062 79.5222V73.0975L177.44 72.7363L176.84 73.0823L176.817 73.0975Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 64.9013L182.994 66.688V79.5223L179.907 81.309H179.904L178.658 80.5867L181.749 78.8038V72.3752L181.753 65.9695L184.84 64.179L184.843 64.1828L184.847 64.1866L186.085 64.9013Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 65.2623V71.6871L190.394 70.9686L190.398 70.9648V64.54L187.308 62.7571L186.066 63.4756L189.153 65.2623Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 73.0976V66.6729L184.224 67.3914L184.217 67.3952V73.8199L187.307 75.6066L188.553 74.8881L185.462 73.0976Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 89.5166V95.9451L59.63 95.2266L59.6337 95.2228V88.7981L56.5431 87.0151L55.3015 87.7336L58.3884 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 97.3556V90.9309L53.46 91.6456L53.4524 91.6494V98.0779L56.543 99.8609L57.7884 99.1424L54.6978 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 90.2237V96.6484L56.5431 97.0096L57.162 96.6522L57.1658 96.6484V90.2237L56.5431 89.8625L55.9432 90.2123L55.9204 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 82.0273L62.1019 83.8141V90.2388H62.0981V96.6483L59.0112 98.4351L57.7659 97.7166L60.8565 95.9298V89.5013V83.0956L63.9472 81.3088L63.9548 81.3126L65.1926 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 82.3886V88.8133L69.4981 88.0986L69.5057 88.0948V81.6663L66.4151 79.8833L65.1697 80.6018L68.2565 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 90.2276V83.7991L63.3283 84.5176L63.3245 84.5214V90.9461L66.4151 92.7329L67.6605 92.0144L64.5698 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 83.0956V89.5165L69.502 90.9421V97.3707L68.2566 96.6522L68.2604 90.9459V90.2236L70.7246 88.8018V82.3733L71.9699 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 89.5166V89.5204L69.502 90.9498",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 83.092V89.5205L66.4152 89.8816L67.0303 89.5243L67.0379 89.5205V83.0958L66.4152 82.7346L65.8115 83.0806L65.7925 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 88.7981L68.2605 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 89.5166V95.9451L76.8985 95.2266L76.9061 95.2228V88.7981L73.8154 87.0151L72.5701 87.7336L75.6607 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 97.3556V90.9309L70.7284 91.6456L70.7246 91.6494V98.0779L73.8153 99.8609L75.0606 99.1424L71.97 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 90.2237V96.6484L73.8153 97.0096L74.4304 96.6522L74.438 96.6484V90.2237L73.8153 89.8625L73.2154 90.2123L73.1926 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 82.0273L79.3701 83.8141V96.6483L76.2832 98.4351H76.2794L75.0378 97.7166L78.1285 95.9298V83.0956L81.2192 81.3088L81.223 81.3126L82.4607 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 82.3886V88.8133L86.7701 88.0986L86.7739 88.0948V81.6663L83.6832 79.8833L82.4417 80.6018L85.5285 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 90.2276V83.7991L80.6004 84.5176L80.5928 84.5214V90.9461L83.6834 92.7329L84.9288 92.0144L81.8381 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 83.0956V89.5165L86.7741 90.9421V97.3707L85.5249 96.6522L85.5287 90.9459V90.2236L87.9967 88.8018V82.3733L89.2382 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 89.5166V89.5204L86.7739 90.9498",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 83.092V89.5205L83.6832 89.8816L84.3021 89.5243L84.3059 89.5205V83.0958L83.6832 82.7346L83.0833 83.0806L83.0605 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 88.7981L85.5286 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 89.5166V95.9451L94.1702 95.2266L94.1778 95.2228V88.7981L91.0872 87.0151L89.8418 87.7336L92.9286 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 97.3556V90.9309L88.0004 91.6456L87.9966 91.6494V98.0779L91.0872 99.8609L92.3326 99.1424L89.242 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 90.2237V96.6484L91.0872 97.0096L91.7023 96.6522L91.7099 96.6484V90.2237L91.0872 89.8625L90.4835 90.2123L90.4607 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 82.0273L96.6419 83.8141V90.2388V96.6483L93.5513 98.4351L92.3059 97.7166L95.3966 95.9298V89.5013L95.4004 83.0956L98.4872 81.3088H98.491L98.4948 81.3126L99.7326 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 82.3886V88.8133L104.038 88.0986L104.046 88.0948V81.6663L100.955 79.8833L99.7097 80.6018L102.8 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 90.2276V83.7991L97.8721 84.5176L97.8645 84.5214V90.9461L100.955 92.7329L102.201 92.0144L99.1099 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 83.0956V89.5165L104.042 90.9421V97.3707L102.797 96.6522L102.8 90.9459V90.2236L105.268 88.8018V82.3733L106.51 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 89.5166V89.5204L104.042 90.9498",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 83.092V89.5205L100.955 89.8816L101.57 89.5243L101.578 89.5205V83.0958L100.955 82.7346L100.355 83.0806L100.333 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 88.7981L102.801 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 89.5166V95.9451L111.442 95.2266L111.446 95.2228V88.7981L108.355 87.0151L107.114 87.7336L110.201 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 97.3556V90.9309L105.272 91.6456L105.265 91.6494V98.0779L108.355 99.8609L109.601 99.1424L106.51 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 90.2237V96.6484L108.355 97.0096L108.974 96.6522L108.978 96.6484V90.2237L108.355 89.8625L107.755 90.2123L107.733 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 82.0273L113.914 83.8141V96.6483L110.823 98.4351L109.574 97.7166L112.665 95.9298V89.5013L112.669 83.0956L115.756 81.3088H115.759L115.763 81.3126L117.005 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 82.3886V88.8133L121.31 88.0986L121.318 88.0948V81.6663L118.227 79.8833L116.982 80.6018L120.069 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 90.2276V83.7991L115.141 84.5176L115.137 84.5214V90.9461L118.227 92.7329L119.473 92.0144L116.382 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 83.0956V89.5165L121.314 90.9421V97.3707L120.069 96.6522V90.9459V90.2236L122.537 88.8018V82.3733L123.782 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 89.5166V89.5204L121.314 90.9498",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 83.092V89.5205L118.227 89.8816L118.842 89.5243L118.85 89.5205V83.0958L118.227 82.7346L117.624 83.0806L117.601 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 88.7981L120.069 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 89.5166V95.9451L128.711 95.2266L128.718 95.2228V88.7981L125.627 87.0151L124.382 87.7336L127.473 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 97.3556V90.9309L122.541 91.6456L122.537 91.6494V98.0779L125.628 99.8609L126.873 99.1424L123.782 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 90.2237V96.6484L125.628 97.0096L126.243 96.6522L126.25 96.6484V90.2237L125.628 89.8625L125.028 90.2123L125.005 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 82.0273L131.186 83.8141V90.2388H131.182V96.6483L128.095 98.4351L126.846 97.7166L129.937 95.9298V89.5013L129.941 83.0956L133.028 81.3088H133.031L133.035 81.3126L134.277 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 82.3886V88.8133L138.582 88.0986L138.586 88.0948V81.6663L135.495 79.8833L134.254 80.6018L137.341 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 90.2276V83.7991L132.412 84.5176L132.405 84.5214V90.9461L135.495 92.7329L136.741 92.0144L133.65 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 83.0956V89.5165L138.586 90.9421V97.3707L137.341 96.6522V90.9459V90.2236L139.809 88.8018V82.3733L141.054 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 89.5166V89.5204L138.582 90.9498",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 83.092V89.5205L135.495 89.8816L136.114 89.5243L136.118 89.5205V83.0958L135.495 82.7346L134.896 83.0806L134.873 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 88.7981L137.341 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 89.5166V95.9451L145.982 95.2266L145.99 95.2228V88.7981L142.899 87.0151L141.654 87.7336L144.741 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 97.3556V90.9309L139.813 91.6456L139.809 91.6494V98.0779L142.899 99.8609L144.145 99.1424L141.054 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 90.2237V96.6484L142.896 97.0096L143.515 96.6522L143.522 96.6484V90.2237L142.896 89.8625L142.296 90.2123L142.273 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 82.0273L148.454 83.8141V96.6483L145.367 98.4351H145.364L144.118 97.7166L147.209 95.9298V89.5013V83.0956L150.299 81.3088L150.307 81.3126L151.545 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 82.3886V88.8133L155.85 88.0986L155.858 88.0948V81.6663L152.767 79.8833L151.522 80.6018L154.613 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 90.2276V83.7991L149.681 84.5176L149.677 84.5214V90.9461L152.767 92.7329L154.013 92.0144L150.922 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 83.0956V89.5165L155.854 90.9421V97.3707L154.609 96.6522L154.613 90.9459V90.2236L157.077 88.8018V82.3733L158.322 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 89.5166V89.5204L155.854 90.946",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 83.092V89.5205L152.767 89.8816L153.383 89.5243L153.39 89.5205V83.0958L152.767 82.7346L152.168 83.0806L152.145 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 88.7981L154.613 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 89.5166V95.9451L163.251 95.2266L163.258 95.2228V88.7981L160.168 87.0151L158.926 87.7336L162.013 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 97.3556V90.9309L157.084 91.6456L157.077 91.6494V98.0779L160.168 99.8609L161.413 99.1424L158.322 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 90.2237V96.6484L160.168 97.0096L160.786 96.6522L160.79 96.6484V90.2237L160.168 89.8625L159.568 90.2123L159.545 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 82.0273L165.726 83.8141V90.2388H165.722V96.6483L162.636 98.4351L161.39 97.7166L164.481 95.9298V89.5013V83.0956L167.571 81.3088L167.579 81.3126L168.817 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 82.3886V88.8133L173.122 88.0986L173.13 88.0948V81.6663L170.039 79.8833L168.794 80.6018L171.881 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 90.2276V83.7991L166.953 84.5176L166.949 84.5214V90.9461L170.039 92.7329L171.285 92.0144L168.194 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 83.0956V89.5165L173.126 90.9421V97.3707L171.881 96.6522V90.2236L174.349 88.8018V82.3733L175.594 83.0956Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 89.5166V89.5204L173.126 90.9498",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 83.092V89.5205L170.039 89.8816L170.654 89.5243L170.662 89.5205V83.0958L170.039 82.7346L169.436 83.0806L169.413 83.092Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 88.7981L171.881 90.2237",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 89.5166V95.9451L180.523 95.2266L180.53 95.2228V88.7981L177.439 87.0151L176.194 87.7336L179.285 89.5166Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 97.3556V90.9309L174.353 91.6456L174.349 91.6494V98.0779L177.44 99.8609L178.685 99.1424L175.594 97.3556Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 90.2237V96.6484L177.44 97.0096L178.055 96.6522L178.062 96.6484V90.2237L177.44 89.8625L176.84 90.2123L176.817 90.2237Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 82.0273L182.994 83.8141V96.6483L179.907 98.4351H179.904L178.658 97.7166L181.749 95.9298V89.5013L181.753 83.0956L184.84 81.3088H184.843L184.847 81.3126L186.085 82.0273Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 82.3886V88.8133L190.394 88.0986L190.398 88.0948V81.6663L187.308 79.8833L186.066 80.6018L189.153 82.3886Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 90.2276V83.7991L184.224 84.5176L184.217 84.5214V90.9461L187.307 92.7329L188.553 92.0144L185.462 90.2276Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 106.647V113.071L59.63 112.353L59.6337 112.349V105.924L56.5431 104.141L55.3015 104.86L58.3884 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 114.482V108.057L53.46 108.776H53.4524V115.204L56.543 116.987L57.7884 116.269L54.6978 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 107.35V113.779L56.5431 114.136L57.162 113.782L57.1658 113.779V107.35L56.5431 106.993L55.9432 107.339L55.9204 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 99.1574L62.1019 100.94V107.365H62.0981V113.775L59.0112 115.565L57.7659 114.843L60.8565 113.056V106.628V100.222L63.9472 98.4351L63.9548 98.4389L65.1926 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 99.5148V105.94L69.4981 105.225L69.5057 105.221V98.7963L66.4151 97.0095L65.1697 97.7318L68.2565 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 107.354V100.925L63.3283 101.644L63.3245 101.648V108.072L66.4151 109.859L67.6605 109.141L64.5698 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 100.222V106.643L69.502 108.068V114.497L68.2566 113.778L68.2604 108.076V107.35L70.7246 105.928V99.4995L71.9699 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 106.643V106.647L69.502 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 100.222V106.647L66.4152 107.008L67.0303 106.651L67.0379 106.647V100.222L66.4152 99.8608L65.8115 100.207L65.7925 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 105.924L68.2605 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 106.647V113.071L76.8985 112.353L76.9061 112.349V105.924L73.8154 104.141L72.5701 104.86L75.6607 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 114.482V108.057L70.7284 108.776H70.7246V115.204L73.8153 116.987L75.0606 116.269L71.97 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 107.35V113.779L73.8153 114.136L74.4304 113.782L74.438 113.779V107.35L73.8153 106.993L73.2154 107.339L73.1926 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 99.1574L79.3701 100.94V113.775L76.2832 115.565H76.2794L75.0378 114.843L78.1285 113.056V100.222L81.2192 98.4351L81.223 98.4389L82.4607 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 99.5148V105.94L86.7701 105.225L86.7739 105.221V98.7963L83.6832 97.0095L82.4417 97.7318L85.5285 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 107.354V100.925L80.6004 101.644L80.5928 101.648V108.072L83.6834 109.859L84.9288 109.141L81.8381 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 100.222V106.647L86.7741 108.068V114.497L85.5249 113.778L85.5287 108.072V107.35L87.9967 105.928V99.4995L89.2382 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 106.647L86.7739 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 100.222V106.647L83.6832 107.008L84.3021 106.651L84.3059 106.647V100.222L83.6832 99.8608L83.0833 100.207L83.0605 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 105.924L85.5286 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 106.647V113.071L94.1702 112.353L94.1778 112.349V105.924L91.0872 104.141L89.8418 104.86L92.9286 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 114.482V108.057L88.0004 108.776H87.9966V115.204L91.0872 116.987L92.3326 116.269L89.242 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 107.35V113.779L91.0872 114.136L91.7023 113.782L91.7099 113.779V107.35L91.0872 106.993L90.4835 107.339L90.4607 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 99.1574L96.6419 100.94V107.365V113.775L93.5513 115.565L92.3059 114.843L95.3966 113.056V106.628L95.4004 100.222L98.4872 98.4351H98.491L98.4948 98.4389L99.7326 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 99.5148V105.94L104.038 105.225L104.046 105.221V98.7963L100.955 97.0095L99.7097 97.7318L102.8 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 107.354V100.925L97.8721 101.644L97.8645 101.648V108.072L100.955 109.859L102.201 109.141L99.1099 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 100.222V106.643L104.042 108.068V114.497L102.797 113.778L102.8 108.076V107.35L105.268 105.928V99.4995L106.51 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 106.643V106.647L104.042 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 100.222V106.647L100.955 107.008L101.57 106.651L101.578 106.647V100.222L100.955 99.8608L100.355 100.207L100.333 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 105.924L102.801 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 106.647V113.071L111.442 112.353L111.446 112.349V105.924L108.355 104.141L107.114 104.86L110.201 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 114.482V108.057L105.272 108.776H105.265V115.204L108.355 116.987L109.601 116.269L106.51 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 107.35V113.779L108.355 114.136L108.974 113.782L108.978 113.779V107.35L108.355 106.993L107.755 107.339L107.733 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 99.1574L113.914 100.94V113.775L110.823 115.565L109.574 114.843L112.665 113.056V106.628L112.669 100.222L115.756 98.4351H115.759L115.763 98.4389L117.005 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 99.5148V105.94L121.31 105.225L121.318 105.221V98.7963L118.227 97.0095L116.982 97.7318L120.069 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 107.354V100.925L115.141 101.644L115.137 101.648V108.072L118.227 109.859L119.473 109.141L116.382 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 100.222V106.647L121.314 108.068V114.497L120.069 113.778V108.072V107.35L122.537 105.928V99.4995L123.782 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 106.647L121.314 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 100.222V106.647L118.227 107.008L118.842 106.651L118.85 106.647V100.222L118.227 99.8608L117.624 100.207L117.601 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 105.924L120.069 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 106.647V113.071L128.711 112.353L128.718 112.349V105.924L125.627 104.141L124.382 104.86L127.473 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 114.482V108.057L122.541 108.776H122.537V115.204L125.628 116.987L126.873 116.269L123.782 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 107.35V113.779L125.628 114.136L126.243 113.782L126.25 113.779V107.35L125.628 106.993L125.028 107.339L125.005 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 99.1574L131.186 100.94V107.365H131.182V113.775L128.095 115.565L126.846 114.843L129.937 113.056V106.628L129.941 100.222L133.028 98.4351H133.031L133.035 98.4389L134.277 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 99.5148V105.94L138.582 105.225L138.586 105.221V98.7963L135.495 97.0095L134.254 97.7318L137.341 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 107.354V100.925L132.412 101.644L132.405 101.648V108.072L135.495 109.859L136.741 109.141L133.65 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 100.222V106.643L138.586 108.068V114.497L137.341 113.778V108.076V107.35L139.809 105.928V99.4995L141.054 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 106.643V106.647L138.582 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 100.222V106.647L135.495 107.008L136.114 106.651L136.118 106.647V100.222L135.495 99.8608L134.896 100.207L134.873 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 105.924L137.341 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 106.647V113.071L145.982 112.353L145.99 112.349V105.924L142.899 104.141L141.654 104.86L144.741 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 114.482V108.057L139.813 108.776H139.809V115.204L142.899 116.987L144.145 116.269L141.054 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 107.35V113.779L142.896 114.136L143.515 113.782L143.522 113.779V107.35L142.896 106.993L142.296 107.339L142.273 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 99.1574L148.454 100.94V113.775L145.367 115.565H145.364L144.118 114.843L147.209 113.056V106.628V100.222L150.299 98.4351L150.307 98.4389L151.545 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 99.5148V105.94L155.85 105.225L155.858 105.221V98.7963L152.767 97.0095L151.522 97.7318L154.613 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 107.354V100.925L149.681 101.644L149.677 101.648V108.072L152.767 109.859L154.013 109.141L150.922 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 100.222V106.647L155.854 108.068V114.497L154.609 113.778L154.613 108.072V107.35L157.077 105.928V99.4995L158.322 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 106.647L155.854 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 100.222V106.647L152.767 107.008L153.383 106.651L153.39 106.647V100.222L152.767 99.8608L152.168 100.207L152.145 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 105.924L154.613 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 106.647V113.071L163.251 112.353L163.258 112.349V105.924L160.168 104.141L158.926 104.86L162.013 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 114.482V108.057L157.084 108.776H157.077V115.204L160.168 116.987L161.413 116.269L158.322 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 107.35V113.779L160.168 114.136L160.786 113.782L160.79 113.779V107.35L160.168 106.993L159.568 107.339L159.545 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 99.1574L165.726 100.94V107.365H165.722V113.775L162.636 115.565L161.39 114.843L164.481 113.056V106.628V100.222L167.571 98.4351L167.579 98.4389L168.817 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 99.5148V105.94L173.122 105.225L173.13 105.221V98.7963L170.039 97.0095L168.794 97.7318L171.881 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 107.354V100.925L166.953 101.644L166.949 101.648V108.072L170.039 109.859L171.285 109.141L168.194 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 100.222V106.643L173.126 108.068V114.497L171.881 113.778V107.35L174.349 105.928V99.4995L175.594 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 106.643V106.647L173.126 108.076",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 100.222V106.647L170.039 107.008L170.654 106.651L170.662 106.647V100.222L170.039 99.8608L169.436 100.207L169.413 100.222Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 105.924L171.881 107.35",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 106.647V113.071L180.523 112.353L180.53 112.349V105.924L177.439 104.141L176.194 104.86L179.285 106.647Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 114.482V108.057L174.353 108.776H174.349V115.204L177.44 116.987L178.685 116.269L175.594 114.482Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 107.35V113.779L177.44 114.136L178.055 113.782L178.062 113.779V107.35L177.44 106.993L176.84 107.339L176.817 107.35Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 99.1574L182.994 100.94V113.775L179.907 115.565H179.904L178.658 114.843L181.749 113.056V106.628L181.753 100.222L184.84 98.4351H184.843L184.847 98.4389L186.085 99.1574Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 99.5148V105.94L190.394 105.225L190.398 105.221V98.7963L187.308 97.0095L186.066 97.7318L189.153 99.5148Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 107.354V100.925L184.224 101.644L184.217 101.648V108.072L187.307 109.859L188.553 109.141L185.462 107.354Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 123.773V130.198L59.63 129.479H59.6337V123.051L56.5431 121.268L55.3015 121.986L58.3884 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 131.612V125.183L53.46 125.902L53.4524 125.906V132.33L56.543 134.117L57.7884 133.399L54.6978 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 124.476V130.905L56.5431 131.266L57.162 130.909L57.1658 130.905V124.476L56.5431 124.119L55.9432 124.465L55.9204 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 116.284L62.1019 118.07V124.495L62.0981 124.491V130.901L59.0112 132.691L57.7659 131.969L60.8565 130.182V123.758V117.348L63.9472 115.561V115.565H63.9548L65.1926 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 116.641V123.066L69.4981 122.351L69.5057 122.347V115.923L66.4151 114.136L65.1697 114.858L68.2565 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 124.48V118.055L63.3283 118.77L63.3245 118.774V125.198L66.4151 126.985L67.6605 126.267L64.5698 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 117.348V123.769L69.502 125.198V131.623L68.2566 130.905L68.2604 125.202V124.476L70.7246 123.054V116.63L71.9699 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 123.769V123.773L69.502 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 117.348V123.773L66.4152 124.134L67.0303 123.777L67.0379 123.773V117.348L66.4152 116.987L65.8115 117.337L65.7925 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 123.054L68.2605 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 123.773V130.198L76.8985 129.479H76.9061V123.051L73.8154 121.268L72.5701 121.986L75.6607 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 131.612V125.183L70.7284 125.902L70.7246 125.906V132.33L73.8153 134.117L75.0606 133.399L71.97 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 124.476V130.905L73.8153 131.266L74.4304 130.909L74.438 130.905V124.476L73.8153 124.119L73.2154 124.465L73.1926 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 116.284L79.3701 118.07V130.901L76.2832 132.691H76.2794L75.0378 131.969L78.1285 130.182V117.348L81.2192 115.561V115.565H81.223L82.4607 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 116.641V123.066L86.7701 122.351L86.7739 122.347V115.923L83.6832 114.136L82.4417 114.858L85.5285 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 124.48V118.055L80.6004 118.77L80.5928 118.774V125.198L83.6834 126.985L84.9288 126.267L81.8381 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 117.348V123.773L86.7741 125.198V131.623L85.5249 130.905L85.5287 125.198V124.476L87.9967 123.054V116.63L89.2382 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 123.773L86.7739 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 117.348V123.773L83.6832 124.134L84.3021 123.777L84.3059 123.773V117.348L83.6832 116.987L83.0833 117.337L83.0605 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 123.054L85.5286 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 123.773V130.198L94.1702 129.479H94.1778V123.051L91.0872 121.268L89.8418 121.986L92.9286 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 131.612V125.183L88.0004 125.902L87.9966 125.906V132.33L91.0872 134.117L92.3326 133.399L89.242 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 124.476V130.905L91.0872 131.266L91.7023 130.909L91.7099 130.905V124.476L91.0872 124.119L90.4835 124.465L90.4607 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 116.284L96.6419 118.07V124.495V124.491V130.901L93.5513 132.691L92.3059 131.969L95.3966 130.182V123.758L95.4004 117.348L98.4872 115.561L98.491 115.565H98.4948L99.7326 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 116.641V123.066L104.038 122.351L104.046 122.347V115.923L100.955 114.136L99.7097 114.858L102.8 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 124.48V118.055L97.8721 118.77L97.8645 118.774V125.198L100.955 126.985L102.201 126.267L99.1099 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 117.348V123.769L104.042 125.198V131.623L102.797 130.905L102.8 125.202V124.476L105.268 123.054V116.63L106.51 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 123.769V123.773L104.042 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 117.348V123.773L100.955 124.134L101.57 123.777L101.578 123.773V117.348L100.955 116.987L100.355 117.337L100.333 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 123.054L102.801 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 123.773V130.198L111.442 129.479H111.446V123.051L108.355 121.268L107.114 121.986L110.201 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 131.612V125.183L105.272 125.902L105.265 125.906V132.33L108.355 134.117L109.601 133.399L106.51 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 124.476V130.905L108.355 131.266L108.974 130.909L108.978 130.905V124.476L108.355 124.119L107.755 124.465L107.733 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 116.284L113.914 118.07V130.901L110.823 132.691L109.574 131.969L112.665 130.182V123.758L112.669 117.348L115.756 115.561L115.759 115.565H115.763L117.005 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 116.641V123.066L121.31 122.351L121.318 122.347V115.923L118.227 114.136L116.982 114.858L120.069 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 124.48V118.055L115.141 118.77L115.137 118.774V125.198L118.227 126.985L119.473 126.267L116.382 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 117.348V123.773L121.314 125.198V131.623L120.069 130.905V125.198V124.476L122.537 123.054V116.63L123.782 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 123.773L121.314 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 117.348V123.773L118.227 124.134L118.842 123.777L118.85 123.773V117.348L118.227 116.987L117.624 117.337L117.601 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 123.054L120.069 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 123.773V130.198L128.711 129.479H128.718V123.051L125.627 121.268L124.382 121.986L127.473 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 131.612V125.183L122.541 125.902L122.537 125.906V132.33L125.628 134.117L126.873 133.399L123.782 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 124.476V130.905L125.628 131.266L126.243 130.909L126.25 130.905V124.476L125.628 124.119L125.028 124.465L125.005 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 116.284L131.186 118.07V124.495L131.182 124.491V130.901L128.095 132.691L126.846 131.969L129.937 130.182V123.758L129.941 117.348L133.028 115.561L133.031 115.565H133.035L134.277 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 116.641V123.066L138.582 122.351L138.586 122.347V115.923L135.495 114.136L134.254 114.858L137.341 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 124.48V118.055L132.412 118.77L132.405 118.774V125.198L135.495 126.985L136.741 126.267L133.65 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 117.348V123.769L138.586 125.198V131.623L137.341 130.905V125.202V124.476L139.809 123.054V116.63L141.054 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 123.769V123.773L138.582 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 117.348V123.773L135.495 124.134L136.114 123.777L136.118 123.773V117.348L135.495 116.987L134.896 117.337L134.873 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 123.054L137.341 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 123.773V130.198L145.982 129.479H145.99V123.051L142.899 121.268L141.654 121.986L144.741 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 131.612V125.183L139.813 125.902L139.809 125.906V132.33L142.899 134.117L144.145 133.399L141.054 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 124.476V130.905L142.896 131.266L143.515 130.909L143.522 130.905V124.476L142.896 124.119L142.296 124.465L142.273 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 116.284L148.454 118.07V130.901L145.367 132.691H145.364L144.118 131.969L147.209 130.182V123.758V117.348L150.299 115.561V115.565H150.307L151.545 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 116.641V123.066L155.85 122.351L155.858 122.347V115.923L152.767 114.136L151.522 114.858L154.613 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 124.48V118.055L149.681 118.77L149.677 118.774V125.198L152.767 126.985L154.013 126.267L150.922 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 117.348V123.773L155.854 125.198V131.623L154.609 130.905L154.613 125.198V124.476L157.077 123.054V116.63L158.322 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 123.773L155.854 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 117.348V123.773L152.767 124.134L153.383 123.777L153.39 123.773V117.348L152.767 116.987L152.168 117.337L152.145 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 123.054L154.613 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 123.773V130.198L163.251 129.479H163.258V123.051L160.168 121.268L158.926 121.986L162.013 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 131.612V125.183L157.084 125.902L157.077 125.906V132.33L160.168 134.117L161.413 133.399L158.322 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 124.476V130.905L160.168 131.266L160.786 130.909L160.79 130.905V124.476L160.168 124.119L159.568 124.465L159.545 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 116.284L165.726 118.07V124.495L165.722 124.491V130.901L162.636 132.691L161.39 131.969L164.481 130.182V123.758V117.348L167.571 115.561V115.565H167.579L168.817 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 116.641V123.066L173.122 122.351L173.13 122.347V115.923L170.039 114.136L168.794 114.858L171.881 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 124.48V118.055L166.953 118.77L166.949 118.774V125.198L170.039 126.985L171.285 126.267L168.194 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 117.348V123.769L173.126 125.198V131.623L171.881 130.905V124.476L174.349 123.054V116.63L175.594 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 123.769V123.773L173.126 125.202",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 117.348V123.773L170.039 124.134L170.654 123.777L170.662 123.773V117.348L170.039 116.987L169.436 117.337L169.413 117.348Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 123.051L171.881 124.476",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 123.773V130.198L180.523 129.479H180.53V123.051L177.439 121.268L176.194 121.986L179.285 123.773Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 131.612V125.183L174.353 125.902L174.349 125.906V132.33L177.44 134.117L178.685 133.399L175.594 131.612Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 124.476V130.905L177.44 131.266L178.055 130.909L178.062 130.905V124.476L177.44 124.119L176.84 124.465L176.817 124.476Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 116.284L182.994 118.07V130.901L179.907 132.691H179.904L178.658 131.969L181.749 130.182V123.758L181.753 117.348L184.84 115.561L184.843 115.565H184.847L186.085 116.284Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 116.641V123.066L190.394 122.351L190.398 122.347V115.923L187.308 114.136L186.066 114.858L189.153 116.641Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 124.48V118.055L184.224 118.77L184.217 118.774V125.198L187.307 126.985L188.553 126.267L185.462 124.48Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 140.899V147.324L59.63 146.609L59.6337 146.605V140.181L56.5431 138.394L55.3015 139.112L58.3884 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 148.738V142.31L53.46 143.028L53.4524 143.032V149.457L56.543 151.243L57.7884 150.525L54.6978 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 141.606V148.031L56.5431 148.392L57.162 148.035L57.1658 148.031V141.606L56.5431 141.245L55.9432 141.591L55.9204 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 133.41L62.1019 135.197V141.622L62.0981 141.618V148.031L59.0112 149.818L57.7659 149.096L60.8565 147.309V140.884V134.478L63.9472 132.688V132.692H63.9548L65.1926 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 133.771V140.196L69.4981 139.477L69.5057 139.474V133.049L66.4151 131.266L65.1697 131.984L68.2565 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 141.606V135.182L63.3283 135.896L63.3245 135.9V142.329L66.4151 144.112L67.6605 143.393L64.5698 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 134.478V140.895L69.502 142.325V148.749L68.2566 148.031L68.2604 142.328V141.606L70.7246 140.181V133.756L71.9699 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 140.895V140.903L69.502 142.332",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 134.474V140.899L66.4152 141.26L67.0303 140.903L67.0379 140.899V134.474L66.4152 134.113L65.8115 134.463L65.7925 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 140.181L68.2605 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 140.899V147.324L76.8985 146.609L76.9061 146.605V140.181L73.8154 138.394L72.5701 139.112L75.6607 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 148.738V142.31L70.7284 143.028L70.7246 143.032V149.457L73.8153 151.243L75.0606 150.525L71.97 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 141.606V148.031L73.8153 148.392L74.4304 148.035L74.438 148.031V141.606L73.8153 141.245L73.2154 141.591L73.1926 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 133.41L79.3701 135.197V148.031L76.2832 149.818H76.2794L75.0378 149.096L78.1285 147.309V134.478L81.2192 132.688V132.692H81.223L82.4607 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 133.771V140.196L86.7701 139.477L86.7739 139.474V133.049L83.6832 131.266L82.4417 131.984L85.5285 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 141.606V135.182L80.6004 135.896L80.5928 135.9V142.329L83.6834 144.112L84.9288 143.393L81.8381 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 134.478V140.899L86.7741 142.325V148.749L85.5249 148.031L85.5287 142.325V141.606L87.9967 140.181V133.756L89.2382 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 140.899V140.903L86.7739 142.332",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 134.474V140.899L83.6832 141.26L84.3021 140.903L84.3059 140.899V134.474L83.6832 134.113L83.0833 134.463L83.0605 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 140.181L85.5286 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 140.899V147.324L94.1702 146.609L94.1778 146.605V140.181L91.0872 138.394L89.8418 139.112L92.9286 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 148.738V142.31L88.0004 143.028L87.9966 143.032V149.457L91.0872 151.243L92.3326 150.525L89.242 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 141.606V148.031L91.0872 148.392L91.7023 148.035L91.7099 148.031V141.606L91.0872 141.245L90.4835 141.591L90.4607 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 133.41L96.6419 135.197V141.622V141.618V148.031L93.5513 149.818L92.3059 149.096L95.3966 147.309V140.884L95.4004 134.478L98.4872 132.688L98.491 132.692H98.4948L99.7326 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 133.771V140.196L104.038 139.477L104.046 139.474V133.049L100.955 131.266L99.7097 131.984L102.8 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 141.606V135.182L97.8721 135.896L97.8645 135.9V142.329L100.955 144.112L102.201 143.393L99.1099 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 134.478V140.895L104.042 142.325V148.749L102.797 148.031L102.8 142.328V141.606L105.268 140.181V133.756L106.51 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 140.895V140.903L104.042 142.332",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 134.474V140.899L100.955 141.26L101.57 140.903L101.578 140.899V134.474L100.955 134.113L100.355 134.463L100.333 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 140.181L102.801 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 140.899V147.324L111.442 146.609L111.446 146.605V140.181L108.355 138.394L107.114 139.112L110.201 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 148.738V142.31L105.272 143.028L105.265 143.032V149.457L108.355 151.243L109.601 150.525L106.51 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 141.606V148.031L108.355 148.392L108.974 148.035L108.978 148.031V141.606L108.355 141.245L107.755 141.591L107.733 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 133.41L113.914 135.197V148.031L110.823 149.818L109.574 149.096L112.665 147.309V140.884L112.669 134.478L115.756 132.688L115.759 132.692H115.763L117.005 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 133.771V140.196L121.31 139.477L121.318 139.474V133.049L118.227 131.266L116.982 131.984L120.069 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 141.606V135.182L115.141 135.896L115.137 135.9V142.329L118.227 144.112L119.473 143.393L116.382 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 134.478V140.899L121.314 142.325V148.749L120.069 148.031V142.325V141.606L122.537 140.181V133.756L123.782 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 140.899V140.903L121.314 142.332",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 134.474V140.899L118.227 141.26L118.842 140.903L118.85 140.899V134.474L118.227 134.113L117.624 134.463L117.601 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 140.181L120.069 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 140.899V147.324L128.711 146.609L128.718 146.605V140.181L125.627 138.394L124.382 139.112L127.473 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 148.738V142.31L122.541 143.028L122.537 143.032V149.457L125.628 151.243L126.873 150.525L123.782 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 141.606V148.031L125.628 148.392L126.243 148.035L126.25 148.031V141.606L125.628 141.245L125.028 141.591L125.005 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 133.41L131.186 135.197V141.622L131.182 141.618V148.031L128.095 149.818L126.846 149.096L129.937 147.309V140.884L129.941 134.478L133.028 132.688L133.031 132.692H133.035L134.277 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 133.771V140.196L138.582 139.477L138.586 139.474V133.049L135.495 131.266L134.254 131.984L137.341 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 141.606V135.182L132.412 135.896L132.405 135.9V142.329L135.495 144.112L136.741 143.393L133.65 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 134.478V140.895L138.586 142.325V148.749L137.341 148.031V142.328V141.606L139.809 140.181V133.756L141.054 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 140.895V140.903L138.582 142.332",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 134.474V140.899L135.495 141.26L136.114 140.903L136.118 140.899V134.474L135.495 134.113L134.896 134.463L134.873 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 140.181L137.341 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 140.899V147.324L145.982 146.609L145.99 146.605V140.181L142.899 138.394L141.654 139.112L144.741 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 148.738V142.31L139.813 143.028L139.809 143.032V149.457L142.899 151.243L144.145 150.525L141.054 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 141.606V148.031L142.896 148.392L143.515 148.035L143.522 148.031V141.606L142.896 141.245L142.296 141.591L142.273 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 133.41L148.454 135.197V148.031L145.367 149.818H145.364L144.118 149.096L147.209 147.309V140.884V134.478L150.299 132.688V132.692H150.307L151.545 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 133.771V140.196L155.85 139.477L155.858 139.474V133.049L152.767 131.266L151.522 131.984L154.613 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 141.606V135.182L149.681 135.896L149.677 135.9V142.329L152.767 144.112L154.013 143.393L150.922 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 134.478V140.899L155.854 142.325V148.749L154.609 148.031L154.613 142.325V141.606L157.077 140.181V133.756L158.322 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 140.899V140.903L155.854 142.329",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 134.474V140.899L152.767 141.26L153.383 140.903L153.39 140.899V134.474L152.767 134.113L152.168 134.463L152.145 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 140.181L154.613 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 140.899V147.324L163.251 146.609L163.258 146.605V140.181L160.168 138.394L158.926 139.112L162.013 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 148.738V142.31L157.084 143.028L157.077 143.032V149.457L160.168 151.243L161.413 150.525L158.322 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 141.606V148.031L160.168 148.392L160.786 148.035L160.79 148.031V141.606L160.168 141.245L159.568 141.591L159.545 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 133.41L165.726 135.197V141.622L165.722 141.618V148.031L162.636 149.818L161.39 149.096L164.481 147.309V140.884V134.478L167.571 132.688V132.692H167.579L168.817 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 133.771V140.196L173.122 139.477L173.13 139.474V133.049L170.039 131.266L168.794 131.984L171.881 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 141.606V135.182L166.953 135.896L166.949 135.9V142.329L170.039 144.112L171.285 143.393L168.194 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 134.478V140.895L173.126 142.325V148.749L171.881 148.031V141.606L174.349 140.181V133.756L175.594 134.478Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 140.895V140.903L173.126 142.332",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 134.474V140.899L170.039 141.26L170.654 140.903L170.662 140.899V134.474L170.039 134.113L169.436 134.463L169.413 134.474Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 140.177L171.881 141.606",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 140.899V147.324L180.523 146.609L180.53 146.605V140.181L177.439 138.394L176.194 139.112L179.285 140.899Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 148.738V142.31L174.353 143.028L174.349 143.032V149.457L177.44 151.243L178.685 150.525L175.594 148.738Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 141.606V148.031L177.44 148.392L178.055 148.035L178.062 148.031V141.606L177.44 141.245L176.84 141.591L176.817 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 133.41L182.994 135.197V148.031L179.907 149.818H179.904L178.658 149.096L181.749 147.309V140.884L181.753 134.478L184.84 132.688L184.843 132.692H184.847L186.085 133.41Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 133.771V140.196L190.394 139.477L190.398 139.474V133.049L187.308 131.266L186.066 131.984L189.153 133.771Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 141.606V135.182L184.224 135.896L184.217 135.9V142.329L187.307 144.112L188.553 143.393L185.462 141.606Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3884 158.025V164.45L59.63 163.735L59.6337 163.732V157.307L56.5431 155.52L55.3015 156.242L58.3884 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6978 165.864V159.439L53.46 160.154L53.4524 160.158V166.583L56.543 168.369L57.7884 167.651L54.6978 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9204 158.732V165.157L56.5431 165.518L57.162 165.161L57.1658 165.157V158.732L56.5431 158.371L55.9432 158.717L55.9204 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 150.536L62.1019 152.323V158.748L62.0981 158.744V165.157L59.0112 166.944L57.7659 166.222L60.8565 164.439V158.01V151.605L63.9472 149.814V149.818H63.9548L65.1926 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 150.897V157.322L69.4981 156.604L69.5057 156.6V150.175L66.4151 148.392L65.1697 149.111L68.2565 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 158.733V152.308L63.3283 153.026H63.3245V159.455L66.4151 161.238L67.6605 160.519L64.5698 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 151.604V158.025L69.502 159.451V165.879L68.2566 165.157L68.2604 159.455V158.732L70.7246 157.307V150.882L71.9699 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 158.025V158.029L69.502 159.459",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 151.601V158.029L66.4152 158.39L67.0303 158.033L67.0379 158.029V151.601L66.4152 151.243L65.8115 151.589L65.7925 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7247 157.307L68.2605 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6607 158.025V164.45L76.8985 163.735L76.9061 163.732V157.307L73.8154 155.52L72.5701 156.242L75.6607 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.97 165.864V159.439L70.7284 160.154L70.7246 160.158V166.583L73.8153 168.369L75.0606 167.651L71.97 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1926 158.732V165.157L73.8153 165.518L74.4304 165.161L74.438 165.157V158.732L73.8153 158.371L73.2154 158.717L73.1926 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 150.536L79.3701 152.323V165.157L76.2832 166.944H76.2794L75.0378 166.222L78.1285 164.439V151.605L81.2192 149.814V149.818H81.223L82.4607 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 150.897V157.322L86.7701 156.604L86.7739 156.6V150.175L83.6832 148.392L82.4417 149.111L85.5285 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 158.733V152.308L80.6004 153.026H80.5928V159.455L83.6834 161.238L84.9288 160.519L81.8381 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 151.604V158.025L86.7741 159.451V165.879L85.5249 165.157L85.5287 159.455V158.732L87.9967 157.307V150.882L89.2382 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2381 158.025V158.029L86.7739 159.459",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 151.601V158.029L83.6832 158.39L84.3021 158.033L84.3059 158.029V151.601L83.6832 151.243L83.0833 151.589L83.0605 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9965 157.307L85.5286 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9286 158.025V164.45L94.1702 163.735L94.1778 163.732V157.307L91.0872 155.52L89.8418 156.242L92.9286 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.242 165.864V159.439L88.0004 160.154L87.9966 160.158V166.583L91.0872 168.369L92.3326 167.651L89.242 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4607 158.732V165.157L91.0872 165.518L91.7023 165.161L91.7099 165.157V158.732L91.0872 158.371L90.4835 158.717L90.4607 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 150.536L96.6419 152.323V158.748V158.744V165.157L93.5513 166.944L92.3059 166.222L95.3966 164.439V158.01L95.4004 151.605L98.4872 149.814L98.491 149.818H98.4948L99.7326 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 150.897V157.322L104.038 156.604L104.046 156.6V150.175L100.955 148.392L99.7097 149.111L102.8 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 158.733V152.308L97.8721 153.026H97.8645V159.455L100.955 161.238L102.201 160.519L99.1099 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 151.604V158.025L104.042 159.451V165.879L102.797 165.157L102.8 159.455V158.732L105.268 157.307V150.882L106.51 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 158.025V158.029L104.042 159.459",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 151.601V158.029L100.955 158.39L101.57 158.033L101.578 158.029V151.601L100.955 151.243L100.355 151.589L100.333 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.269 157.307L102.801 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.201 158.025V164.45L111.442 163.735L111.446 163.732V157.307L108.355 155.52L107.114 156.242L110.201 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 165.864V159.439L105.272 160.154L105.265 160.158V166.583L108.355 168.369L109.601 167.651L106.51 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.733 158.732V165.157L108.355 165.518L108.974 165.161L108.978 165.157V158.732L108.355 158.371L107.755 158.717L107.733 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 150.536L113.914 152.323V165.157L110.823 166.944L109.574 166.222L112.665 164.439V158.01L112.669 151.605L115.756 149.814L115.759 149.818H115.763L117.005 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 150.897V157.322L121.31 156.604L121.318 156.6V150.175L118.227 148.392L116.982 149.111L120.069 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 158.733V152.308L115.141 153.026H115.137V159.455L118.227 161.238L119.473 160.519L116.382 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 151.604V158.025L121.314 159.451V165.879L120.069 165.157V159.455V158.732L122.537 157.307V150.882L123.782 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 158.025V158.029L121.314 159.459",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 151.601V158.029L118.227 158.39L118.842 158.033L118.85 158.029V151.601L118.227 151.243L117.624 151.589L117.601 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.537 157.307L120.069 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.473 158.025V164.45L128.711 163.735L128.718 163.732V157.307L125.627 155.52L124.382 156.242L127.473 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 165.864V159.439L122.541 160.154L122.537 160.158V166.583L125.628 168.369L126.873 167.651L123.782 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.005 158.732V165.157L125.628 165.518L126.243 165.161L126.25 165.157V158.732L125.628 158.371L125.028 158.717L125.005 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 150.536L131.186 152.323V158.748L131.182 158.744V165.157L128.095 166.944L126.846 166.222L129.937 164.439V158.01L129.941 151.605L133.028 149.814L133.031 149.818H133.035L134.277 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 150.897V157.322L138.582 156.604L138.586 156.6V150.175L135.495 148.392L134.254 149.111L137.341 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 158.733V152.308L132.412 153.026H132.405V159.455L135.495 161.238L136.741 160.519L133.65 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 151.604V158.025L138.586 159.451V165.879L137.341 165.157V159.455V158.732L139.809 157.307V150.882L141.054 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 158.025V158.029L138.582 159.459",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 151.601V158.029L135.495 158.39L136.114 158.033L136.118 158.029V151.601L135.495 151.243L134.896 151.589L134.873 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.809 157.307L137.341 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.741 158.025V164.45L145.982 163.735L145.99 163.732V157.307L142.899 155.52L141.654 156.242L144.741 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 165.864V159.439L139.813 160.154L139.809 160.158V166.583L142.899 168.369L144.145 167.651L141.054 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.273 158.732V165.157L142.896 165.518L143.515 165.161L143.522 165.157V158.732L142.896 158.371L142.296 158.717L142.273 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 150.536L148.454 152.323V165.157L145.367 166.944H145.364L144.118 166.222L147.209 164.439V158.01V151.605L150.299 149.814V149.818H150.307L151.545 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 150.897V157.322L155.85 156.604L155.858 156.6V150.175L152.767 148.392L151.522 149.111L154.613 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 158.733V152.308L149.681 153.026H149.677V159.455L152.767 161.238L154.013 160.519L150.922 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 151.604V158.025L155.854 159.451V165.879L154.609 165.157L154.613 159.455V158.732L157.077 157.307V150.882L158.322 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 158.025V158.029L155.854 159.455",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 151.601V158.029L152.767 158.39L153.383 158.033L153.39 158.029V151.601L152.767 151.243L152.168 151.589L152.145 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.077 157.307L154.613 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.013 158.025V164.45L163.251 163.735L163.258 163.732V157.307L160.168 155.52L158.926 156.242L162.013 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 165.864V159.439L157.084 160.154L157.077 160.158V166.583L160.168 168.369L161.413 167.651L158.322 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.545 158.732V165.157L160.168 165.518L160.786 165.161L160.79 165.157V158.732L160.168 158.371L159.568 158.717L159.545 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 150.536L165.726 152.323V158.748L165.722 158.744V165.157L162.636 166.944L161.39 166.222L164.481 164.439V158.01V151.605L167.571 149.814V149.818H167.579L168.817 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 150.897V157.322L173.122 156.604L173.13 156.6V150.175L170.039 148.392L168.794 149.111L171.881 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 158.733V152.308L166.953 153.026H166.949V159.455L170.039 161.238L171.285 160.519L168.194 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 151.604V158.025L173.126 159.451V165.879L171.881 165.157V158.732L174.349 157.307V150.882L175.594 151.604Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 158.025V158.029L173.126 159.459",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 151.601V158.029L170.039 158.39L170.654 158.033L170.662 158.029V151.601L170.039 151.243L169.436 151.589L169.413 151.601Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.349 157.303L171.881 158.732",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.285 158.025V164.45L180.523 163.735L180.53 163.732V157.307L177.439 155.52L176.194 156.242L179.285 158.025Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 165.864V159.439L174.353 160.154L174.349 160.158V166.583L177.44 168.369L178.685 167.651L175.594 165.864Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.817 158.732V165.157L177.44 165.518L178.055 165.161L178.062 165.157V158.732L177.44 158.371L176.84 158.717L176.817 158.732Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 150.536L182.994 152.323V165.157L179.907 166.944H179.904L178.658 166.222L181.749 164.439V158.01L181.753 151.605L184.84 149.814L184.843 149.818H184.847L186.085 150.536Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 150.897V157.322L190.394 156.604L190.398 156.6V150.175L187.308 148.392L186.066 149.111L189.153 150.897Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 158.733V152.308L184.224 153.026H184.217V159.455L187.307 161.238L188.553 160.519L185.462 158.733Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1926 167.663L62.1019 169.45V175.874H62.0981V182.284L59.0112 184.071L57.7659 183.352L60.8565 181.565V175.137V168.731L63.9472 166.94V166.944L63.9548 166.948L65.1926 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2565 168.024V174.449L69.4981 173.73H69.5057V167.302L66.4151 165.519L65.1697 166.237L68.2565 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5698 175.863V169.434L63.3283 170.153L63.3245 170.157V176.581L66.4151 178.368L67.6605 177.65L64.5698 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9699 168.731V175.152L69.502 176.577V183.006L68.2566 182.287L68.2604 176.581V175.859L70.7246 174.437V168.009L71.9699 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 168.727V175.156L66.4152 175.517L67.0303 175.16L67.0379 175.156V168.727L66.4152 168.37L65.8115 168.716L65.7925 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4607 167.663L79.3701 169.45V182.284L76.2832 184.071H76.2794L75.0378 183.352L78.1285 181.565V168.731L81.2192 166.94V166.944L81.223 166.948L82.4607 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5285 168.024V174.449L86.7701 173.73H86.7739V167.302L83.6832 165.519L82.4417 166.237L85.5285 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8381 175.863V169.434L80.6004 170.153L80.5928 170.157V176.581L83.6834 178.368L84.9288 177.65L81.8381 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2382 168.731V175.152L86.7741 176.577V183.006L85.5249 182.287L85.5287 176.581V175.859L87.9967 174.437V168.009L89.2382 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0605 168.727V175.156L83.6832 175.517L84.3021 175.16L84.3059 175.156V168.727L83.6832 168.37L83.0833 168.716L83.0605 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7326 167.663L96.6419 169.45V175.874V182.284L93.5513 184.071L92.3059 183.352L95.3966 181.565V175.137L95.4004 168.731L98.4872 166.94L98.491 166.944L98.4948 166.948L99.7326 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 168.024V174.449L104.038 173.73H104.046V167.302L100.955 165.519L99.7097 166.237L102.8 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1099 175.863V169.434L97.8721 170.153L97.8645 170.157V176.581L100.955 178.368L102.201 177.65L99.1099 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51 168.731V175.152L104.042 176.577V183.006L102.797 182.287L102.8 176.581V175.859L105.268 174.437V168.009L106.51 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 168.727V175.156L100.955 175.517L101.57 175.16L101.578 175.156V168.727L100.955 168.37L100.355 168.716L100.333 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.005 167.663L113.914 169.45V182.284L110.823 184.071L109.574 183.352L112.665 181.565V175.137L112.669 168.731L115.756 166.94L115.759 166.944L115.763 166.948L117.005 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.069 168.024V174.449L121.31 173.73H121.318V167.302L118.227 165.519L116.982 166.237L120.069 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.382 175.863V169.434L115.141 170.153L115.137 170.157V176.581L118.227 178.368L119.473 177.65L116.382 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.782 168.731V175.152L121.314 176.577V183.006L120.069 182.287V176.581V175.859L122.537 174.437V168.009L123.782 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.601 168.727V175.156L118.227 175.517L118.842 175.16L118.85 175.156V168.727L118.227 168.37L117.624 168.716L117.601 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.277 167.663L131.186 169.45V175.874H131.182V182.284L128.095 184.071L126.846 183.352L129.937 181.565V175.137L129.941 168.731L133.028 166.94L133.031 166.944L133.035 166.948L134.277 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.341 168.024V174.449L138.582 173.73H138.586V167.302L135.495 165.519L134.254 166.237L137.341 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.65 175.863V169.434L132.412 170.153L132.405 170.157V176.581L135.495 178.368L136.741 177.65L133.65 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.054 168.731V175.152L138.586 176.577V183.006L137.341 182.287V176.581V175.859L139.809 174.437V168.009L141.054 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.873 168.727V175.156L135.495 175.517L136.114 175.16L136.118 175.156V168.727L135.495 168.37L134.896 168.716L134.873 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.545 167.663L148.454 169.45V182.284L145.367 184.071H145.364L144.118 183.352L147.209 181.565V175.137V168.731L150.299 166.94V166.944L150.307 166.948L151.545 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.613 168.024V174.449L155.85 173.73H155.858V167.302L152.767 165.519L151.522 166.237L154.613 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.922 175.863V169.434L149.681 170.153L149.677 170.157V176.581L152.767 178.368L154.013 177.65L150.922 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.322 168.731V175.152L155.854 176.577V183.006L154.609 182.287L154.613 176.581V175.859L157.077 174.437V168.009L158.322 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.145 168.727V175.156L152.767 175.517L153.383 175.16L153.39 175.156V168.727L152.767 168.37L152.168 168.716L152.145 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.817 167.663L165.726 169.45V175.874H165.722V182.284L162.636 184.071L161.39 183.352L164.481 181.565V175.137V168.731L167.571 166.94V166.944L167.579 166.948L168.817 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.881 168.024V174.449L173.122 173.73H173.13V167.302L170.039 165.519L168.794 166.237L171.881 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.194 175.863V169.434L166.953 170.153L166.949 170.157V176.581L170.039 178.368L171.285 177.65L168.194 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.594 168.731V175.152L173.126 176.577V183.006L171.881 182.287V175.859L174.349 174.437V168.009L175.594 168.731Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.413 168.727V175.156L170.039 175.517L170.654 175.16L170.662 175.156V168.727L170.039 168.37L169.436 168.716L169.413 168.727Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.085 167.663L182.994 169.45V182.284L179.907 184.071H179.904L178.658 183.352L181.749 181.565V175.137L181.753 168.731L184.84 166.94L184.843 166.944L184.847 166.948L186.085 167.663Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.153 168.024V174.449L190.394 173.73H190.398V167.302L187.308 165.519L186.066 166.237L189.153 168.024Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.462 175.863V169.434L184.224 170.153L184.217 170.157V176.581L187.307 178.368L188.553 177.65L185.462 175.863Z",
    stroke: "#81C7C4",
    strokeWidth: 0.35,
    strokeMiterlimit: 10
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M122.016 169.396C157.692 169.396 186.613 140.439 186.613 104.719C186.613 68.999 157.692 40.0422 122.016 40.0422C86.3409 40.0422 57.4202 68.999 57.4202 104.719C57.4202 140.439 86.3409 169.396 122.016 169.396Z",
    fill: "url(#paint0_linear_35_119664)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M57.257 101.746C57.3139 101.936 57.5342 101.913 57.9366 101.944C58.0126 101.989 58.024 102.085 58.0505 102.168C58.0695 102.548 58.1303 102.628 58.4074 102.605C58.8289 102.571 59.2086 102.754 59.5959 102.913C60.1084 103.126 59.6756 103.579 60.1958 103.795C62.2081 104.643 61.6804 104.213 62.0031 104.597C62.0638 104.67 62.1246 104.791 62.1891 104.795C62.7397 104.814 63.1953 105.403 63.6775 105.373C63.8863 105.392 64.0952 105.403 64.285 105.544C64.4824 105.863 64.7862 105.894 65.0634 106.008C65.1773 106.088 65.2874 106.08 65.3937 105.989C65.4469 105.97 65.5 105.955 65.5532 105.936C65.6063 105.936 65.6291 105.901 65.6253 105.833C65.8911 105.544 65.6405 105.187 65.8797 104.787C66.0695 104.552 66.0164 104.286 66.1569 103.818C66.2138 103.791 66.2746 103.738 66.2632 103.67C66.1645 103.141 66.4834 102.963 66.7606 102.746C66.8441 102.681 66.9618 102.647 66.9656 102.495C66.9808 102.104 66.5176 102.362 66.529 101.91C67.3909 101.111 67.2959 99.853 68.1844 99.5108C68.4464 99.412 68.6286 99.0128 68.7122 98.6555C68.7843 98.3323 68.9704 98.0092 68.8564 97.6709C69.0425 97.1234 69.202 96.557 69.6728 96.2186C69.8512 96.0894 70.0752 96.0286 70.1626 95.7358C70.398 95.58 70.3069 95.2606 70.4511 95.0592C70.4663 95.0478 70.4739 95.0401 70.4853 95.0287C70.7473 94.9223 70.7397 94.641 70.808 94.4053C70.8498 94.333 70.8916 94.2646 70.9333 94.1924C70.9333 94.1658 70.9447 94.1125 70.9447 94.1125C70.9447 94.1125 70.9371 94.1658 70.9333 94.1924C71.0169 94.1278 71.0738 94.0479 71.0662 93.9301C71.0814 93.9111 71.0966 93.8883 71.108 93.8693C71.1384 93.8769 71.1574 93.8616 71.1687 93.8198C71.1839 93.8084 71.1953 93.7932 71.2029 93.7742C71.2333 93.7666 71.2447 93.7476 71.2409 93.7096C71.2637 93.6716 71.2902 93.6336 71.313 93.5955C71.4725 93.4891 71.5598 93.3256 71.5978 93.1241C71.6699 92.9645 71.799 92.8732 71.9053 92.7554C72.1331 92.7098 72.3382 92.7478 72.5242 92.8656C72.528 92.8466 72.5318 92.8352 72.5356 92.8162C72.604 92.7858 72.7255 92.7136 72.7255 92.7136C72.7255 92.7136 72.604 92.7896 72.5356 92.8162C72.5318 92.8352 72.528 92.8466 72.5242 92.8656C72.7786 92.9607 72.5432 93.3066 72.6381 93.4853C72.6154 93.5613 72.5964 93.6374 72.5736 93.7134C72.4597 93.8046 72.4293 93.9339 72.4331 94.0707C72.4217 94.1049 72.4065 94.1392 72.3837 94.1696C72.2888 94.2152 72.2281 94.2874 72.2243 94.4129C71.9357 94.9413 71.7497 95.542 71.3624 95.9944C71.1953 96.1882 71.3472 96.3631 71.3244 96.5532C71.3168 96.8725 71.1649 97.131 70.9447 97.2489C70.7587 97.3477 70.6789 97.5416 70.5461 97.6861C70.4246 97.6518 70.3106 97.7925 70.2993 97.8723C70.2385 98.3438 69.9082 98.7353 69.9462 99.2257C70.0145 100.115 69.6956 100.792 69.0995 101.241C68.5223 101.674 68.5489 102.852 68.3894 103.202C68.3287 103.377 68.3515 103.312 68.2527 103.582C68.0971 103.571 68.0287 103.468 68.0325 103.271C68.0325 103.16 68.0249 103.043 67.9224 103.016C67.8123 102.989 67.7895 103.134 67.7364 103.21C67.687 103.274 67.6452 103.347 67.6073 103.407C67.6377 103.632 67.8427 103.548 67.8958 103.704C67.7667 104.058 67.4212 103.997 67.2428 104.259C67.1972 104.324 67.1289 104.366 67.0719 104.415C66.6619 104.902 66.3012 105.445 65.8569 105.856C65.8455 105.867 65.8379 105.882 65.8303 105.894C65.5722 106.251 65.5949 106.453 65.9518 106.799C65.8227 106.92 65.6405 106.981 65.6329 107.228C65.1887 107.795 65.0368 108.064 64.509 107.722C63.8939 107.323 63.8598 107.601 63.6206 107.547C63.4079 107.502 63.2371 107.304 63.0434 107.236C62.8574 107.171 62.6599 107.285 62.4435 107.148C62.1853 106.989 61.874 107.095 61.593 106.966C61.3766 106.867 61.1298 106.878 60.9703 106.601C60.8906 106.464 60.7691 106.517 60.6704 106.57C60.5755 106.624 60.5944 106.726 60.6248 106.829C60.7463 107.262 60.4919 107.49 60.7311 107.798C60.883 107.996 60.8261 108.327 60.9324 108.574C61.0729 108.893 61.2323 109.209 61.4146 109.509C62.3372 111.045 62.0866 111.627 63.9737 113.797C64.2812 114.234 64.6419 114.569 65.0748 114.763C65.257 115.056 65.5266 115.208 65.7468 115.443C67.8882 117.743 67.7288 118.26 68.7577 118.929C68.7729 119.009 68.8489 119.169 68.8868 119.253C68.9248 119.367 68.9931 119.447 69.0843 119.504C69.5665 120.819 70.3182 121.674 69.9689 122.032C69.7069 122.298 69.8892 122.807 69.8246 123.172C70.1891 123.693 69.9955 124.088 70.0335 124.529C70.0828 125.13 69.5133 124.632 69.7032 125.514C69.7563 125.765 69.8284 126.019 69.8968 126.27C69.931 126.434 69.9651 126.594 69.9993 126.757C70.0727 126.78 70.0727 126.78 69.9993 126.757C70.0259 126.86 70.0487 126.962 70.0752 127.065C70.1778 127.076 70.1816 127.076 70.0752 127.065C70.136 127.43 70.2689 127.821 70.2157 128.141C70.2005 128.16 70.2043 128.183 70.2271 128.217C70.2461 128.289 70.2651 128.361 70.2841 128.434C70.2993 128.464 70.3106 128.494 70.3182 128.525C70.3334 128.559 70.3448 128.597 70.36 128.631C70.4701 129.023 70.7625 129.274 71.0283 129.544C71.0814 129.684 71.1839 129.779 71.2789 129.882C71.3966 130.045 71.5218 130.182 71.6775 130.258C71.7041 130.273 71.7269 130.285 71.7497 130.289C71.8598 130.464 71.9965 130.555 72.1407 130.627C72.7255 130.92 73.2532 131.376 73.7202 132.03C73.7962 132.136 73.8911 132.254 73.9822 132.319C74.4113 132.631 74.7758 133.06 75.1327 133.505C75.2276 133.779 75.0605 133.9 75.1441 134.163C75.1023 134.258 75.1441 134.394 75.1782 134.528C75.0795 134.554 75.0871 134.668 75.1099 134.801C75.201 135.295 75.3757 135.809 75.5655 136.318C75.6642 136.592 75.8579 136.839 76.1085 137.021C76.7957 137.527 77.145 137.694 77.4184 137.93C77.5665 138.059 77.6956 138.226 77.6614 138.379C77.6234 138.546 77.7259 138.747 77.8171 138.941C78.0829 139.527 78.4549 140.393 79.0397 140.895C79.6699 141.435 79.9509 142.207 81.109 143.385C81.6671 143.952 82.2063 144.564 82.791 145.054C82.9163 145.157 83.0454 145.278 83.1669 145.351C83.5466 145.575 83.9262 145.754 84.3097 146.005C84.6097 146.202 84.8223 146.183 85.0767 146.255C85.4906 146.377 85.9006 146.37 86.3942 146.86C86.4929 146.959 86.5879 146.985 86.6828 147.016C86.9865 147.107 87.2903 147.194 87.6244 147.521C87.7535 147.647 87.8598 147.624 87.9509 147.575C88.1142 147.483 88.2509 147.339 88.4635 147.32C88.5129 147.316 88.5356 147.271 88.5394 147.213C88.5394 147.187 88.5319 147.149 88.5319 147.122C88.5546 146.788 88.4217 146.195 88.2281 145.761C88.2015 145.583 88.2281 145.442 88.2813 145.313C88.399 145.035 88.5356 144.758 88.5281 144.362C88.547 144.195 88.5736 144.035 88.5394 143.838C88.6116 143.834 88.623 143.773 88.5964 143.682C88.7179 143.416 88.8128 143.123 89.0254 142.937C89.1545 142.823 89.2457 142.636 89.2229 142.37C89.333 141.815 89.352 141.207 89.2381 140.526C89.2191 140.405 89.2153 140.276 89.2419 140.181C89.3596 139.793 89.2836 139.318 89.1545 138.85C89.0406 138.439 89.0634 138.143 89.2153 137.896C89.2722 137.804 89.276 137.694 89.2836 137.576C89.4393 137.535 89.4887 137.379 89.5228 137.204C89.5836 136.907 89.6481 136.615 89.7165 136.314C89.8608 135.869 89.9595 135.387 90.2177 135.022C90.3392 134.851 90.3582 134.611 90.305 134.33C90.0316 132.802 90.1076 132.779 89.9974 132.699C89.9595 132.642 89.9253 132.581 89.8873 132.524C89.857 132.368 89.8532 132.216 89.7469 132.132C89.5039 131.558 89.2457 130.114 88.5167 129.703C88.4066 129.426 88.2623 129.171 88.1787 128.875C88.08 128.51 88.0497 128.167 88.1674 127.886C88.2965 127.574 88.3078 127.194 88.4293 126.879C88.6382 126.327 87.9965 126.453 88.2205 125.605C88.7179 123.75 88.7483 123.594 88.7711 123.362C88.8166 122.936 88.9381 122.571 89.1887 122.298C89.538 121.914 89.7355 121.355 90.0962 120.967C90.3278 120.785 90.4683 120.519 90.5214 120.169C90.6201 120.074 90.6581 119.929 90.7189 119.796C90.9505 119.279 90.9543 119.275 90.6125 118.777C90.2556 118.257 90.5138 117.58 90.1189 116.698C89.9139 116.234 89.9177 115.71 89.9747 115.212C90.0734 114.39 90.3354 114.805 90.5176 114.451C90.8897 113.729 91.5807 114.337 92.0364 114.212C92.7236 114.466 92.7844 114.611 93.1754 113.93C93.4716 113.413 93.6235 112.121 94.5917 112.395C94.8043 112.455 95.0169 112.486 95.2257 112.429C95.7573 112.505 96.2965 112.531 96.7673 112.969C96.8128 113.01 96.9571 113.037 97.0065 113.037C97.0407 113.086 97.0786 113.098 97.1204 113.067C97.1963 113.086 97.2685 113.109 97.3444 113.128C97.5988 113.619 98.1987 113.584 98.7417 113.976C98.8973 114.09 99.0568 114.101 99.2239 114.025C100.473 113.44 101.718 113.74 102.941 114.413C103.332 114.626 103.674 114.634 104 114.383C105.663 113.102 106.054 112.201 107.167 111.763C107.357 111.687 107.524 111.509 107.714 111.433C108.158 111.254 107.725 111.037 107.828 110.779C108.074 110.163 108.184 109.46 108.708 109.019C109.054 108.726 109.494 108.593 109.753 108.129C109.779 108.083 109.844 108.049 109.889 108.053C110.356 108.076 110.485 107.528 110.763 107.224C110.857 107.122 110.857 106.951 110.831 106.791C110.725 106.114 110.774 105.434 110.77 104.749C110.793 104.673 110.812 104.597 110.835 104.521C110.865 104.499 110.899 104.483 110.922 104.457C111.275 104.035 111.264 103.955 110.816 103.655C110.801 103.636 110.789 103.609 110.789 103.582C110.789 103.461 110.747 103.373 110.656 103.328C110.55 102.446 110.55 102.035 110.341 101.826C110.083 101.324 110.375 100.955 110.197 100.157C110.216 100.073 110.235 99.9936 110.254 99.91C110.459 99.7351 110.565 99.4576 110.725 99.2333C111.1 98.7011 110.539 98.2829 111.04 97.7127C111.089 97.6557 111.028 97.5568 110.949 97.5378C110.941 97.3553 110.937 97.169 110.93 96.9866C111.002 96.8763 110.987 96.8041 110.876 96.7699C110.869 96.7927 110.865 96.8345 110.865 96.8345C110.865 96.8345 110.865 96.7927 110.876 96.7699C110.857 96.6977 110.842 96.6254 110.823 96.557H110.808C110.808 96.557 110.823 96.5646 110.827 96.5266C110.816 96.5228 110.812 96.519 110.801 96.5152C110.763 96.4734 110.725 96.4315 110.687 96.3897C110.671 96.2453 110.599 96.1768 110.493 96.1502C110.425 96.0666 110.417 95.9525 110.402 95.8423C110.413 95.7853 110.402 95.7472 110.356 95.7282C110.334 95.656 110.311 95.5838 110.288 95.5115C110.33 95.2986 110.231 95.1808 110.109 95.0782C110.091 95.063 110.079 95.0439 110.083 95.0135C110.151 94.5992 109.844 94.7664 109.722 94.3977C109.711 94.2874 109.654 94.238 109.57 94.2266C109.544 94.219 109.525 94.1962 109.513 94.1658C109.498 94.0327 109.437 93.9567 109.327 93.9491C109.156 93.6069 109.213 93.1812 109.054 92.82C108.921 92.5197 108.811 92.2422 108.538 92.1167C108.382 92.0483 108.226 91.9342 108.188 91.7099C107.987 90.5504 107.182 90.5618 106.783 90.4668C106.518 90.1665 106.256 89.8737 105.922 89.6799C105.584 89.4822 105.436 89.045 105.227 88.6915C105.318 87.9007 105.713 87.5092 105.044 86.7868C105.071 86.0645 104.631 85.7946 104.255 85.4753C104.228 85.4525 104.194 85.4487 104.164 85.4373C102.816 85.0533 102.698 83.6885 102.554 83.3388C102.58 83.1715 102.611 83.0042 102.637 82.8332C102.971 82.5937 102.835 82.1223 103.492 81.8257C103.503 81.8257 103.511 81.8257 103.526 81.8257C103.537 81.8219 103.545 81.8181 103.56 81.8143C103.681 81.8371 103.742 81.8523 103.86 81.8752C104.129 82.1147 104.429 81.917 104.714 81.8219C105.075 81.7041 104.615 80.7727 105.272 80.4077C105.447 80.3089 105.455 80.058 105.413 79.8565C105.352 79.5714 104.558 78.4005 105.348 76.4921C105.455 76.2336 105.458 76.0815 105.249 75.9751C104.824 75.7622 104.426 75.5759 103.898 75.7165C103.279 75.8838 102.652 75.7736 102.03 76.0815C102.015 76.0891 101.996 76.0967 101.98 76.0929C101.434 75.8838 100.853 76.2488 100.295 76.2678C99.839 76.283 99.744 76.1575 99.6453 75.5987C99.4479 74.4924 99.8807 73.5876 100.184 73.3709C100.268 73.3101 100.359 73.2151 100.408 73.1124C100.917 72.1012 101.954 72.0632 102.151 71.9567C102.349 71.8465 102.421 71.6222 102.444 71.4131C102.466 71.1774 102.292 71.1698 102.155 71.1926C101.76 71.2534 101.388 71.0368 100.967 71.3713C100.83 71.4777 100.667 71.3865 100.515 71.3675C100.025 71.2991 100.587 70.7554 100.371 70.5578C100.245 70.4437 100.105 70.5616 99.9832 70.6794C99.839 70.8201 99.6871 70.8505 99.5314 70.8847C98.8214 71.052 99.3833 70.5882 98.5746 70.5121C97.8228 70.4399 98.4265 69.6568 97.7431 69.596C97.1584 69.5465 96.7597 69.136 96.3382 68.79C96.2623 68.7254 96.2205 68.6075 96.2281 68.4783C96.2585 67.9689 95.9737 67.8282 95.6548 67.851C95.0815 67.8928 94.5841 67.7065 94.0183 67.7674C93.8779 67.7826 93.7222 67.7332 93.7829 67.5469C93.9234 67.1287 93.8095 66.7295 94.0981 66.3113C94.2651 66.068 94.6069 65.0568 93.8816 65.0682C93.6538 65.072 93.4488 65.0682 93.3235 64.8705C93.2438 64.7451 93.1033 64.7337 92.9514 64.882C92.6249 65.1975 93.0425 65.3495 92.7084 65.6613C92.5983 65.7639 92.4806 65.8514 92.4616 66.0262C92.4388 66.2923 92.5034 66.5547 92.2148 66.8664C92.1161 66.7447 92.3059 66.4976 92.1958 66.3988C92.0895 66.3076 91.9301 66.3836 91.8086 66.357C91.6719 66.3266 91.558 66.2505 91.4137 66.2353C91.2428 66.2163 91.2352 66.0414 91.4023 65.8628C91.6263 65.6233 91.801 65.3305 92.0136 65.0872C92.2642 64.8021 92.4388 64.4904 92.5793 64.1444C92.7426 63.7415 92.7882 63.7263 93.1109 63.6236C93.5703 63.4792 93.8399 63.7148 94.1171 63.9467C94.5575 64.3079 95.4118 64.1482 96.0459 63.559C96.2167 63.5438 96.323 63.4411 96.3534 63.213C96.6116 62.9507 96.7673 62.6466 96.8926 62.2816C97.0482 61.8331 97.2912 61.3997 97.3254 60.9397C97.3482 60.6241 97.1622 60.2136 96.923 60.2212C96.4901 60.2326 96.566 59.9589 96.0952 59.9322C95.3814 59.8904 95.7042 59.2898 94.9372 59.5293C94.6714 59.6129 94.474 59.5825 94.3411 59.3772C94.2196 59.1909 93.9576 59.1833 93.9234 58.8792C93.9006 58.6891 93.3501 58.9932 93.4298 58.499C93.4944 58.0847 93.2893 57.9858 93.0767 57.8946C92.7806 57.7653 92.5565 57.5296 92.2224 57.4764C92.1313 57.4612 92.0554 57.408 92.1389 57.2331C92.3325 56.8073 92.9135 57.0848 93.0312 56.8263C93.0995 56.6781 92.9021 56.6743 92.7957 56.6667C92.7502 56.6629 92.6818 56.6971 92.6553 56.6743C92.4578 56.507 92.1882 56.4766 91.949 56.3929C91.7972 56.3397 91.6833 56.3055 91.4782 56.4766C91.2732 56.6477 91.1403 56.7085 91.0758 56.526C91.0454 56.4424 90.9087 56.469 90.8328 56.4272C90.6201 56.3131 90.3012 56.3929 90.1455 56.1915C90.0962 56.1268 89.9443 56.2181 89.8304 56.2561C89.4051 56.4006 88.9799 56.5526 88.5584 56.7047C88.0345 56.891 88.4711 56.469 88.1863 56.5336C88.1408 56.545 88.0952 56.5526 88.0421 56.5792C87.0245 57.0962 86.6448 56.583 85.9955 57.3814C85.931 57.3814 85.8664 57.3662 85.7563 57.4802C85.6462 57.5943 85.5741 57.6285 85.5399 57.56C85.4488 57.3738 85.1678 57.522 84.921 57.7159C84.4768 58.0657 83.9832 58.2291 83.3415 58.7385C83.3225 58.788 83.2998 58.8374 83.2808 58.8868C83.3605 58.8868 83.4402 58.8792 83.52 58.8754C83.4099 59.0503 83.296 59.1225 83.1821 59.1719C82.9922 59.2556 82.7834 59.3734 82.6315 59.381C82.1759 59.4038 81.8721 60.0577 81.0786 60.3922C79.9623 60.8636 78.417 62.2018 77.24 62.9659C77.1374 63.0344 77.0387 63.1028 76.9248 63.2168C75.9718 64.1787 76.8489 64.0684 77.3387 63.8631C77.9993 63.5856 78.7207 63.1864 79.4535 62.7492C79.7573 62.5706 80.5736 62.0231 80.4977 62.2588C80.4445 62.4223 80.2433 62.5173 80.0458 62.6504C79.7459 62.8595 79.6889 62.9165 79.594 63.2358C79.5333 63.4449 79.3396 63.6122 79.2523 63.7871C79.108 64.0798 78.9675 64.095 78.827 64.1634C78.7055 64.2205 78.5878 64.3345 78.4625 64.441C78.2271 64.6424 77.9993 64.7831 77.7715 64.939C77.5703 65.0758 77.3349 65.11 77.4336 64.8896C77.5665 64.6006 77.8095 64.6538 78.0753 64.3877C78.1512 64.3117 78.2575 64.2395 78.2803 64.1406C78.3183 63.9772 77.9917 64.1026 77.7563 64.3041C77.2817 64.7033 76.8982 64.8401 76.5185 64.996C76.3097 65.0834 76.3249 65.0112 76.5489 64.7261C76.7615 64.4562 76.7615 64.4334 76.6552 64.3953C76.4236 64.3079 76.0401 64.4638 75.7933 64.4258C75.6415 64.3991 75.3301 64.6386 75.0454 64.8591C74.7796 65.0682 74.7036 65.091 74.6998 64.9504C74.696 64.6348 75.2314 64.422 75.239 64.1406C75.2428 63.9696 75.3871 63.7529 75.725 63.4297C74.7378 63.9544 74.4986 64.0532 74.0999 64.4942C73.9594 64.6538 73.9215 64.7375 74.0354 64.6881C74.2252 64.6082 74.3923 64.555 74.529 64.5968C74.21 64.8591 73.9329 65.1367 73.6747 65.2773C73.3557 65.4522 73.0862 65.5738 73.1128 65.3115C73.1128 65.2849 72.809 65.4522 72.7748 65.4712C72.79 65.4104 72.771 65.3914 72.7065 65.418C72.4787 65.4788 72.2281 65.5738 72.0534 65.5814C71.9813 65.5814 71.8826 65.6119 71.7573 65.6879C71.4725 65.859 71.2485 65.9426 70.9979 66.0795C71.0283 65.9578 70.9333 66.0376 70.3752 66.395C69.8322 66.7447 69.5475 66.931 69.3349 67.0831C63.4421 75.6139 59.706 84.7454 57.929 94.9641C58.2214 94.9071 58.3201 95.675 59.2731 95.1314C59.4364 95.0401 59.5921 95.063 59.7515 94.9945C59.8009 94.9793 59.8351 94.9451 59.8579 94.8919C59.9869 94.8653 60.1084 94.8082 60.2072 94.66C60.2261 94.641 60.2451 94.6258 60.2641 94.6182C60.3552 94.5916 60.4312 94.5459 60.4578 94.4205C60.6438 94.2988 60.8299 94.1734 61.0311 94.1544C61.126 94.1468 61.2133 94.0897 61.2513 93.9529C61.4032 93.8883 61.4374 93.759 61.4449 93.6107C61.4715 93.5499 61.4981 93.4853 61.5247 93.4245C61.6044 93.3788 61.6614 93.3066 61.6766 93.204C61.7525 93.0709 61.8322 92.9379 61.9082 92.8086C62.0449 92.7516 62.1246 92.6413 62.1474 92.4779C62.1739 92.4246 62.2043 92.3714 62.2309 92.3144C62.2461 92.3144 62.2537 92.3144 62.2689 92.3144C62.2841 92.303 62.2916 92.2992 62.303 92.2878C62.3106 92.2688 62.3334 92.2384 62.3334 92.2384C62.3334 92.2384 62.3144 92.2688 62.303 92.2878C62.6106 92.3258 62.8612 92.4588 63.0358 92.744C63.3396 93.2344 62.8992 93.318 61.9006 94.66C61.4412 95.2796 60.8185 94.9109 60.7349 95.9715C60.2527 96.1122 59.5655 96.5684 58.7871 96.4619C58.7568 96.4429 58.7302 96.4201 58.6998 96.4011C58.6884 96.2377 58.6087 96.154 58.4758 96.1388C58.4758 96.1388 58.4758 96.1388 58.472 96.135C58.5024 96.0172 58.472 95.9487 58.3733 95.9449C58.2252 95.8841 58.1189 95.7587 58.0126 95.6028C57.8569 95.8233 57.8987 96.0286 57.8531 96.2148C57.8075 96.4011 57.7506 96.5646 57.6822 96.7091C57.4317 98.7011 57.3443 99.7085 57.2456 101.746H57.257ZM78.4398 66.0909C78.2461 66.2011 78.0601 66.3684 77.8702 66.5623C77.6045 66.836 77.202 66.8208 77.6196 66.3646C78.2195 65.7069 78.0942 65.4826 78.3562 65.6613C78.4246 65.7069 78.4891 65.6651 78.5651 65.5054C78.5916 65.4446 78.5992 65.3876 78.6258 65.3267C78.6942 65.1633 78.9144 65.0112 78.8802 65.2089C78.8346 65.4788 78.7625 65.9084 78.4398 66.0909ZM80.9495 65.6043C80.7369 65.8552 80.5167 66.0909 80.3002 66.3304C80.2015 66.4368 80.0952 66.5204 80.0344 66.4786C79.7839 66.2923 79.4042 66.8816 79.3928 66.4102C79.3928 66.2961 79.4497 66.1669 79.5712 66.0528C79.9509 65.7031 80.3344 65.4294 80.6457 65.2203C80.9875 65.091 81.352 65.1253 80.9495 65.6043ZM91.8275 67.7141C91.7934 67.8814 91.6491 67.8966 91.5769 68.0069C91.5276 68.0069 91.4744 68.0069 91.4251 68.0069C91.3605 67.813 91.2011 67.794 91.0188 67.8244L90.8517 67.851C90.8024 67.7256 90.6923 67.6875 90.5898 67.6457C90.4797 67.6001 90.3733 67.6419 90.2936 67.8282C90.2291 67.9803 90.1189 68.0829 90.024 68.2046C89.857 68.4212 89.7203 68.4707 89.5494 68.406C89.2267 68.2806 88.8052 68.3946 88.4977 68.2426C88.4787 68.2312 88.4141 68.292 88.3724 68.3224C88.2964 68.33 88.2205 68.3414 88.1484 68.349C88.1218 67.9422 87.8066 68.1741 87.5788 68.2198C87.5029 68.235 87.427 68.2464 87.3472 68.2616C87.2181 68.4174 87.2371 68.3946 87.3472 68.2616C86.8043 68.3148 86.7056 68.9915 86.3259 68.6379C86.2575 68.5733 86.1968 68.5049 86.0753 68.5391C86.0753 68.5733 86.0905 68.6265 86.0905 68.6265C86.0905 68.6265 86.0297 68.33 85.8323 68.2958C85.6956 68.273 85.6159 68.1779 85.5513 68.0563C85.4981 68.1285 85.4298 68.2806 85.4298 68.2806C85.4298 68.2806 85.4944 68.1285 85.5513 68.0563C85.5855 67.9194 85.6196 67.7788 85.6576 67.6419C85.8513 67.4708 85.9006 67.3302 85.7639 67.2275C85.7639 67.2275 85.7639 67.2313 85.7639 67.2352C85.7715 67.2085 85.7753 67.1781 85.7715 67.1439C85.7639 66.7713 85.7374 66.4558 85.3083 66.5661C84.978 66.6497 84.697 66.8854 84.3933 67.1591C83.8047 67.6875 83.7288 66.9006 84.2452 66.4444C84.8413 65.9198 84.6704 66.4748 85.3729 66.2201C85.5209 66.1669 85.6652 65.9122 85.5513 65.878C85.3273 65.8133 85.2931 65.437 84.9134 65.6309C84.8413 65.6651 84.7767 65.6195 84.7198 65.589C84.4692 65.4598 84.1541 65.4826 83.7972 65.6005C83.463 65.7107 83.1403 65.7791 82.8024 65.9122C82.3885 66.0719 82.043 66.0985 81.7278 66.049C81.4507 66.0072 81.9405 65.4598 82.5518 65.3609C84.2528 65.0872 84.9856 65.2887 86.2196 64.2737C86.7777 63.8137 86.0867 63.981 86.7853 62.7835C86.9789 62.4527 87.0055 62.2969 86.8195 62.2094C86.6182 62.1144 86.4664 61.9319 86.2423 61.9015C85.7791 61.8445 85.5019 61.5479 85.1602 61.3617C85.0615 61.3084 85.1185 61.1602 85.2779 61.0309C85.6994 60.6926 86.2385 60.5823 86.5347 60.4645C86.8688 60.3352 87.0587 60.4645 87.2599 60.5823C87.3434 60.6317 87.4042 60.7268 87.3017 60.9359C87.1992 61.145 87.2713 61.2096 87.3207 61.3122C87.4232 61.5327 87.6662 61.5137 87.8902 61.5289C89.8266 61.6468 89.2722 63.4411 88.3762 63.6692C88.0952 63.7415 87.9244 64.0684 87.7231 64.3079C87.6358 64.4105 87.6472 64.5094 87.6851 64.574C87.7459 64.6767 87.8029 64.7793 87.913 64.8211C88.1142 64.8972 88.3002 65.0036 88.5622 64.9732C88.7559 64.9504 88.8622 65.0454 88.7938 65.3267C88.6344 66.0186 88.9951 65.8666 88.6913 66.2505C88.5015 66.4938 88.4749 66.7523 88.6609 66.7599C88.9115 66.7714 89.1052 66.9196 89.4127 66.8246C90.3316 66.5433 89.6785 67.353 90.3771 67.1819C90.5632 67.1363 90.7416 67.1629 90.9353 67.0147C91.1061 66.8854 91.1593 66.9652 91.1517 67.1211C91.1251 67.7446 91.7668 67.5089 91.8237 67.7065L91.8275 67.7141ZM78.7625 81.1567L78.8346 81.1719C78.8346 81.1719 78.7815 81.1643 78.7625 81.1567C78.66 81.0692 78.6562 81.0654 78.7625 81.1567ZM86.379 68.9421C86.379 68.9421 86.155 68.8204 86.1208 68.714C86.1702 68.8394 86.379 68.9421 86.379 68.9421ZM72.2015 86.9845C72.3268 86.6956 72.4103 86.4257 72.3799 86.1292C72.342 85.7984 72.4559 85.673 72.7596 85.5931C73.1355 85.4905 73.2874 85.3194 73.5418 85.5779C73.8873 85.9239 74.4872 85.8288 74.996 85.3688C75.2618 85.1293 75.539 85.0495 75.8161 84.9963C75.9452 84.9735 76.0022 85.0571 76.0629 85.1635C76.2262 85.4411 76.6628 85.4677 76.9438 85.175C77.426 84.6732 77.9006 84.5895 78.4398 84.5705C78.4094 84.3158 78.4474 84.1029 78.6524 83.814C78.8992 83.468 78.846 83.4148 79.146 83.3312C79.2333 83.3084 79.3206 83.3198 79.4118 83.2399C79.4725 83.1867 79.4991 83.1183 79.4991 83.0423C79.4953 82.913 79.4345 82.9434 79.3472 82.951C78.846 82.9738 78.8384 82.951 79.1194 82.2743C79.2105 82.2553 79.1839 82.339 79.1688 82.4074C79.1194 82.6431 79.2067 82.6925 79.3814 82.5861C79.5105 82.5062 79.594 82.4644 79.556 82.2211C79.5067 81.9132 79.389 81.5862 79.5978 81.1719C79.5978 81.1719 79.5978 81.1719 79.6016 81.1719C79.7345 81.111 79.8674 81.0426 80.0003 80.9856C80.3534 80.8297 80.6306 81.0692 81.0027 80.8829C81.128 80.8183 81.1393 81.0198 81.1545 81.1567C81.1811 81.3771 81.314 81.419 81.5038 81.3353C81.6595 81.2669 81.8114 81.0844 81.8683 81.2365C81.9063 81.3353 81.8304 81.4456 81.7658 81.5482C81.276 82.339 81.2153 82.5062 81.033 82.5518C80.7331 82.6241 80.566 82.9016 80.4293 83.1905C80.5812 83.4909 80.8508 83.5061 81.1697 83.3654C81.1621 83.5137 81.014 83.6809 81.0976 83.7113C81.352 83.8064 81.2532 84.1067 81.2305 84.3462C81.5418 84.4184 81.8304 84.0497 82.1227 84.0953C82.2252 84.1105 82.286 83.9584 82.3012 83.8444C82.3354 83.6239 82.4113 83.4376 82.5821 83.2932C82.6543 83.2323 82.7113 83.1487 82.7226 83.0461C82.7758 82.472 83.1745 82.0918 83.4934 81.7573C83.7744 81.4608 83.9642 81.0996 84.2262 80.8107C84.3173 80.7081 84.3781 80.556 84.3667 80.4381C84.2528 79.2064 85.183 78.8605 85.4754 78.6666C85.7677 78.4727 86.0563 78.2332 86.3525 78.0926C87.1384 77.7124 87.8142 77.1612 88.2471 76.1613C88.4521 76.0777 88.566 76.3248 88.7673 76.2146C88.9875 76.0967 88.9723 75.7584 89.1583 75.5987C89.1849 75.5759 89.2115 75.5493 89.2419 75.5265C89.2064 75.4682 89.2064 75.4682 89.2419 75.5265C89.4963 75.5569 89.6633 75.5265 89.7393 75.6937C89.8722 75.9903 89.6595 76.6517 89.3482 76.8874C88.8014 77.3094 88.585 77.3778 88.4407 77.8378C88.3268 78.1876 88.0952 78.4043 87.8598 78.6134C87.7649 78.697 87.6472 78.7388 87.5902 78.8833C87.4384 78.9289 87.2827 78.9897 87.1346 79.0163C86.5955 79.1076 86.9258 79.4573 86.4588 79.6322C86.0867 79.7691 85.7525 80.0884 85.3918 80.2861C85.2286 80.3773 85.0729 80.5218 84.9514 80.7081C84.754 81.0046 84.9856 81.1947 85.1412 80.9932C85.2931 80.7993 85.4754 80.7347 85.6424 80.6092C85.9348 80.3925 86.0753 80.4724 86.1702 80.7423C86.1019 80.978 85.9728 81.1529 85.8095 81.3239C85.6196 81.5216 85.5779 81.7573 85.7298 81.8409C86.0487 82.0196 86.0563 82.6849 86.5727 82.5709C86.8384 82.51 86.9068 82.6279 86.865 82.9624C86.846 83.1107 86.7587 83.2704 86.8498 83.392C87.0131 83.7418 87.0777 83.7608 87.4194 83.449C87.7763 83.1259 88.1939 83.0156 88.566 82.7419C88.6496 82.6811 88.7521 82.6545 88.828 82.5785C88.9495 82.4606 88.9419 82.2553 88.8128 82.2287C88.4217 82.1489 88.304 82.2363 88.0724 82.3542C88.0117 82.3656 87.9509 82.377 87.8902 82.3884C87.5599 82.2705 87.1878 82.3085 86.8498 82.2325C86.1398 82.0728 86.5955 80.8259 87.1232 80.6358C87.2485 80.5902 87.3472 80.4572 87.4573 80.3545C87.9054 79.9439 88.3306 79.4687 88.8698 79.3395C89.1128 79.2825 89.3216 79.081 89.519 78.8757C90.4227 77.9481 90.8555 77.853 91.1175 77.0395C91.2087 76.7506 91.3605 76.6023 91.5694 76.4959C91.6757 76.4427 91.7782 76.359 91.8807 76.2982C92.6021 75.88 92.5793 76.6023 93.0501 76.6479C93.707 76.7088 93.7146 77.3664 94.4018 77.0167C94.7435 76.8418 95.0891 76.7772 95.4308 76.6821C96.0041 76.5263 96.2585 76.8494 96.1142 77.5489C96.0421 77.9101 96.0876 78.0431 96.3344 78.1648C96.4597 78.2294 96.5964 78.2332 96.7407 78.2218C96.8014 78.4043 96.9343 78.4879 97.09 78.4993C97.781 78.5563 98.0278 79.2558 98.3848 79.8109C98.51 80.0048 98.4683 80.2367 98.3164 80.461C98.2556 80.5484 98.1304 80.594 98.1645 80.7765C98.3658 80.9742 98.6088 81.1567 98.7075 81.5064C98.6353 81.6661 98.7227 81.6927 98.81 81.7193C98.9011 81.7421 98.996 81.7649 99.0872 81.7839C99.1251 81.7687 99.1859 81.7687 99.1859 81.7687C99.1859 81.7687 99.1213 81.7687 99.0872 81.7839C99.1365 81.8676 99.2049 81.9132 99.296 81.9056C99.501 82.1451 99.4555 82.088 99.5428 82.2667C99.5846 82.4454 99.6871 82.51 99.8389 82.472C100.017 82.529 100.184 82.5747 100.393 82.5062C101.122 82.2667 102.671 82.5975 101.787 83.5935C101.699 83.6923 101.601 83.7798 101.51 83.8748C99.8048 83.7227 99.3757 84.293 99.0454 83.8178C98.753 83.3958 98.1569 83.4376 97.9595 83.2665C97.5912 82.951 97.1698 82.8142 96.6875 82.8674C96.0231 82.9396 95.203 82.3314 94.2689 82.8978C94.1057 82.9966 93.9614 82.9966 93.8133 82.9244C92.9362 82.4948 91.8124 83.2361 91.1973 82.7419C90.9808 82.567 90.7075 82.5861 90.4721 82.9282C90.3544 83.1031 90.248 83.1753 90.1076 83.0689C90.0354 83.0156 89.9405 82.9662 89.8684 83.1145C89.8038 83.2475 89.876 83.3236 89.9253 83.411C90.0164 83.5631 90.1683 83.6581 90.1835 83.8862C90.1607 83.9204 90.1417 83.9546 90.1189 83.9927C90.0658 84.0117 90.0316 84.0497 90.0126 84.1181C89.8038 84.3234 89.5532 84.5059 89.7506 84.9469C89.8835 85.2358 90.0848 85.4259 90.343 85.5285C90.3468 85.8174 90.2063 86.0569 90.0012 86.0265C89.4659 85.9429 89.5494 86.4485 89.3368 86.5397C88.885 86.7374 88.4559 87.1746 87.9737 87.0035C87.7003 86.9047 86.865 87.4901 86.5005 87.5586C86.3562 87.5852 86.3259 87.7449 86.2955 87.8779C86.0335 89.0222 84.9742 88.4291 83.8237 89.467C83.4251 89.8243 83.1707 89.7369 82.9201 89.4442C82.3847 88.8207 83.4213 88.4481 82.6657 87.9235C82.1759 87.5814 81.0292 87.4103 80.6495 88.1212C80.604 88.2087 80.5356 88.2923 80.4559 88.2999C80.1825 88.3265 79.9129 88.5622 79.6434 88.5394C79.1574 88.4976 79.2941 89.1134 78.9485 89.0222C78.5233 88.9119 78.0791 89.121 77.6652 89.3301C77.2475 89.543 76.8261 89.5962 76.416 89.8129C76.2831 89.8852 76.154 89.8281 76.0401 89.7787C75.6301 89.2921 75.0985 89.1857 74.4758 89.5012C73.9329 89.7749 73.4241 89.8129 72.9115 89.8319C72.8773 89.8129 72.8432 89.7939 72.809 89.7711C72.809 89.7027 72.7824 89.6799 72.7255 89.7179C72.7255 89.7179 72.6913 89.7255 72.6761 89.7369C72.6571 89.2617 72.547 88.5774 72.3837 88.0832C72.3686 87.8133 72.3686 87.532 72.1635 87.4103C72.1445 87.281 72.1635 87.1366 72.2053 86.9921L72.2015 86.9845ZM69.5513 82.7457C69.5513 82.7457 69.669 82.6469 69.7221 82.5747C69.4867 82.0766 69.7373 81.5444 70.3676 81.1376C70.7587 80.8867 71.146 80.6092 71.4953 80.1986C71.6396 80.0276 72.2319 79.7273 72.4825 79.4345C72.4103 79.4269 72.2698 79.4269 72.2698 79.4269C72.2698 79.4269 72.6533 79.503 73.1051 79.0278C73.1697 78.9593 73.238 78.8947 73.2267 78.8035C73.2191 78.7388 73.1659 78.7464 73.1165 78.7426C72.6002 78.6894 72.5964 78.5069 73.0444 77.8492C73.1811 77.6516 73.2836 77.5641 73.4165 77.5755C74.5859 77.6858 74.753 77.7086 74.6657 77.9709C74.4872 78.5183 73.9291 78.4841 73.6557 78.6134C73.5836 78.6476 73.519 78.7959 73.5874 78.8415C73.6253 78.8643 73.6747 78.8795 73.724 78.8643C74.1075 78.7388 74.6505 78.8833 74.9428 79.0163C75.1023 79.0886 75.2846 78.9821 75.3263 78.7806C75.425 78.2826 75.8313 78.3397 76.0136 78.0317C75.9794 77.8302 75.687 77.9595 75.6832 77.7048C76.0136 77.5375 76.3781 77.625 76.8792 77.0889C77.0919 76.8646 77.3463 76.8798 77.4526 77.0661C77.6956 77.4995 77.912 77.3588 77.9424 77.796C77.9613 78.0774 78.1208 78.1724 78.3828 78.0964C78.5081 78.3321 78.4777 78.6552 78.436 78.9859C78.3448 79.1798 78.4929 79.1266 78.7701 79.138C78.7511 79.1798 78.7473 79.3889 78.7473 79.4307C78.7587 79.9744 78.4777 80.4381 78.098 80.8753C76.6097 81.3125 76.23 81.4038 75.9604 81.1643C75.4326 80.6891 74.4644 81.13 74.0316 81.0692C73.9329 81.054 73.8379 81.1377 73.7696 81.2783C73.743 81.3011 73.7126 81.3353 73.6861 81.3429C73.3709 81.4456 73.0672 81.6395 72.7672 81.8904C72.6078 81.8904 72.4369 81.9208 72.266 82.0386C71.8446 82.32 71.4535 82.434 71.0624 82.4644C70.66 82.4986 70.2043 82.7077 69.8512 82.5975C69.8057 82.5937 69.7601 82.5899 69.7145 82.5861C69.6614 82.6583 69.5437 82.7571 69.5437 82.7571L69.5513 82.7457ZM69.3083 82.8978C69.2741 82.9054 69.2361 82.913 69.2361 82.913C69.2361 82.913 69.2779 82.9054 69.3083 82.8978C69.3652 83.0803 69.4905 83.1297 69.4905 83.1297C69.4905 83.1297 69.369 83.0803 69.3083 82.8978ZM65.3367 83.0689C65.2077 83.2095 65.0444 83.3084 64.9609 83.5022C64.9419 83.5175 64.9267 83.5289 64.9077 83.5441C64.8583 83.6087 64.8128 83.6771 64.7634 83.7417C64.7254 83.852 64.6457 83.9394 64.5774 84.0307C64.528 84.0725 64.4786 84.1143 64.4255 84.1561C64.2812 84.2093 64.1407 84.255 63.9926 84.3196C63.8711 84.3728 63.7762 84.6047 63.9319 84.5933C64.0534 84.5857 64.1749 84.5743 64.2926 84.5629C64.2736 84.4374 64.2964 84.5933 64.3192 84.715C63.8674 85.6121 64.6761 85.1521 64.1255 86.1976C64.0382 86.3649 63.9205 86.4257 63.7914 86.4637C63.556 86.5359 63.351 86.707 63.1232 86.9047C62.7169 87.2544 62.2992 87.5358 61.8892 87.4521C61.3652 87.3419 61.35 87.3761 61.6006 86.6576C61.6538 86.5017 61.6841 86.3421 61.8094 86.2014C61.9917 85.9923 62.0904 85.7794 62.0752 85.5855C62.0562 85.365 62.322 85.2092 62.3676 85.0115C62.4056 84.867 62.4245 84.791 62.4587 84.6465C62.4815 84.4489 62.5346 84.2588 62.7359 84.0649C62.7966 84.0079 62.8308 83.9242 62.8422 83.852C62.8422 83.8444 62.9523 83.5821 62.9523 83.5821C63.0169 83.5137 63.0017 83.4946 62.9523 83.4946C62.9181 83.1943 62.9257 83.1791 63.2143 83.0347C63.8977 82.6887 64.0268 82.2591 64.3837 81.8486C64.4673 81.8524 64.5584 81.7459 64.6419 81.6965C64.7976 81.6509 64.8507 81.514 64.9039 81.3771C64.9571 81.3353 65.0406 81.2935 65.0596 81.2517C65.2266 80.8867 65.5722 80.7157 65.781 80.3963C65.8417 80.3051 65.9101 80.2861 65.9632 80.2975C66.6429 80.4343 66.6657 80.4191 66.3581 81.0882C66.2594 81.3087 66.0809 81.5862 66.2746 81.6813C66.2746 81.6813 66.2746 81.6813 66.2822 81.6813C66.2822 81.6813 66.2784 81.6813 66.2746 81.6813C66.1493 82.1603 65.9974 82.7419 66.1227 82.2591C66.0733 82.2705 66.0278 82.2819 65.9784 82.2933C65.7962 82.5899 65.5494 82.818 65.3254 83.0689H65.3367Z",
    fill: "#09363F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M116.507 51.295C117.175 51.4622 117.794 51.7131 118.402 52.0439C118.865 52.2948 119.37 52.3898 119.879 52.4278C120.612 52.4849 122.073 52.9753 122.745 52.808C122.882 52.7738 122.981 52.8156 123.11 52.922C123.277 53.0589 123.493 53.1007 123.687 53.1882C123.824 53.249 123.885 53.4353 124.006 53.5265C124.067 53.6596 124.181 53.69 124.283 53.7432C124.291 53.8116 124.325 53.823 124.371 53.8002C124.382 53.8306 124.405 53.8496 124.431 53.8534C124.598 54.1918 124.876 54.3401 125.16 54.4161C125.779 54.5758 126.489 55.0814 127.123 55.0509C127.883 55.0129 128.171 55.3399 128.745 55.7086C128.813 55.7505 128.923 55.8037 128.9 55.8911C128.817 56.2409 129.215 56.4499 129.132 56.8035C129.113 56.8909 129.238 56.9784 129.337 56.9898C129.386 57.0506 129.447 57.0772 129.515 57.0772C129.8 57.6437 130.434 57.5866 130.377 58.1721C130.32 58.7613 130.708 58.8526 130.962 59.6357C130.989 59.7155 131.064 59.7079 131.121 59.6851C131.137 59.7155 131.156 59.7307 131.182 59.7345C131.194 59.879 131.148 60.0235 131.224 60.1679C131.334 60.3884 131.524 60.434 131.676 60.434C132.09 60.434 132.538 60.4911 132.807 60.0501C132.891 59.9094 133.024 59.9094 133.153 59.8866C134.402 59.6965 134.516 60.1033 134.82 59.7193C135.116 59.3468 135.579 59.381 135.742 58.5979C135.886 58.6283 136.019 58.6473 136.038 58.4268C136.232 58.1835 136.418 57.9402 136.68 57.8109C136.703 57.7995 136.748 57.7881 136.748 57.7691C136.756 57.3091 137.189 57.2027 137.162 56.7313C137.124 56.028 138.157 56.2941 137.925 55.2182C137.868 54.9483 138.237 54.9711 137.717 54.0283C137.307 53.2908 136.885 53.4315 136.467 53.3478C136.152 53.287 135.955 52.9677 136.016 52.6065C136.042 52.4621 136.073 52.3252 136.061 52.1693C136.194 52.1883 136.323 52.2035 136.452 52.2225C136.49 52.2568 136.559 52.3024 136.559 52.329C136.559 52.4354 136.433 52.4849 136.543 52.6407C136.623 52.7586 136.722 52.7852 136.824 52.8232C137.295 53.0095 137.755 53.1502 138.161 52.9563C138.275 52.903 138.366 52.8612 138.335 52.6673C138.305 52.4925 138.298 52.3062 138.096 52.234C138.043 52.2149 137.952 52.1997 137.952 52.1275C137.956 51.6295 137.679 51.7778 137.515 51.7359C137.056 51.6219 137.242 51.6789 136.722 51.7359C136.543 51.6447 136.471 51.5345 136.623 51.4052C136.669 51.3672 136.726 51.3444 136.779 51.3178C137.215 51.6257 137.052 50.7209 137.462 51.0859C137.876 51.4546 138.233 51.4166 138.578 51.3102C138.753 51.3216 138.7 51.1391 138.7 50.9946C138.685 50.2077 139.11 49.7895 139.171 49.6032C139.307 49.1585 139.649 49.0406 139.991 48.9342C140.025 48.9227 140.074 48.9342 140.09 48.9037C140.317 48.516 140.815 48.668 141.13 48.4742C141.434 48.3867 142.261 48.6072 142.474 48.573C142.835 48.5198 142.945 49.014 143.249 48.8543C143.313 48.8201 143.385 48.8847 143.465 48.9266C143.746 49.071 144.054 49.3143 144.262 49.147C144.304 49.1166 144.38 49.1661 144.448 49.2117C144.999 49.5652 145.474 49.6222 145.929 49.6451C146.153 49.7553 146.237 49.6679 147.099 49.4322C147.148 49.474 147.19 49.4664 147.167 49.417C147.061 49.2079 146.932 49.0254 146.73 48.938C146.863 48.8619 147.095 49.014 147.19 48.8961C147.296 48.9265 147.406 48.957 147.513 48.9912C147.611 49.052 147.664 49.0064 147.737 49.0102C147.805 49.0102 147.919 49.052 147.862 48.8999C147.812 48.7707 147.699 48.6946 147.615 48.6452C147.106 48.3487 146.597 48.0598 146.096 47.8355C146.009 47.7975 145.914 47.7747 145.834 47.6986C145.447 47.3375 143.921 46.9497 143.48 46.695C143.412 46.5315 143.176 46.5277 143.188 46.311C143.195 46.14 143.366 46.2578 143.484 46.292C144.281 46.5201 144.578 46.7026 144.574 46.4669C144.574 46.3719 144.486 46.3377 144.433 46.273C144.232 46.0449 144.054 46.0107 143.871 45.9385C143.4 45.7408 142.907 45.3264 142.429 45.1287C141.198 44.6231 141.213 45.1021 141.157 44.3874C141.157 44.3608 141.13 44.3266 141.115 44.2924C141.058 44.2582 140.963 44.2125 140.963 44.1441C140.963 44.0377 141.065 44.1099 141.157 44.2011C141.388 44.2582 141.654 44.5281 141.874 44.5167C141.961 44.5547 142.049 44.5889 142.132 44.6269C142.231 44.7182 142.322 44.7486 142.402 44.7448C142.463 44.779 142.52 44.8094 142.58 44.8436C142.717 45.1135 142.877 45.2694 143.063 45.258C143.757 45.5355 144.483 46.0259 145.181 46.3757C145.345 46.4593 145.508 46.6152 145.675 46.7406C145.72 46.8091 145.755 46.8281 145.781 46.7976C145.838 46.8243 145.891 46.8509 145.948 46.8775C146.624 47.5047 146.673 47.6112 147.251 47.7709C147.577 47.8621 147.953 48.1738 148.279 48.2879C148.401 48.3297 148.511 48.4704 148.511 48.6262C148.511 48.6871 148.507 48.7441 148.504 48.8391C148.857 49.033 149.195 49.3827 149.532 49.6869C149.715 49.8503 149.848 49.8465 149.996 49.8922C150.387 50.1545 150.554 49.9682 150.865 50.47C150.964 50.6335 151.108 50.6791 151.226 50.7285C151.347 50.8312 151.511 50.8806 151.53 51.1049C151.385 51.0402 150.96 50.7361 151.013 50.9794C151.032 51.0745 151.104 51.1125 151.169 51.1771C151.404 51.4204 151.552 51.3672 151.75 51.485C151.807 51.5611 151.89 51.6219 151.917 51.7055C151.993 51.9564 151.989 51.9526 152.205 52.0743C152.19 51.9374 152.012 51.8728 151.966 51.7245C152.186 51.7664 152.467 52.0097 152.68 52.0553L152.885 52.1731C152.896 51.8538 153.223 52.0819 153.458 52.2188C153.827 52.4316 154.123 52.4849 154.468 52.6597C154.552 52.7015 154.616 52.6902 154.711 52.7776C155.349 53.3364 155.79 53.1806 156.538 53.6824C156.887 53.9181 156.936 53.6215 157.715 54.4389C157.688 54.4503 157.665 54.4617 157.643 54.4731C157.54 54.4427 157.555 54.5339 157.57 54.6328C157.548 54.6214 157.521 54.6138 157.498 54.6024C157.441 54.5263 157.381 54.4655 157.32 54.4199C157.282 54.3553 157.274 54.3667 157.267 54.3857C157.248 54.3857 157.236 54.3895 157.214 54.3819C156.735 54.1462 156.325 54.0663 155.812 53.785C155.315 53.5151 154.776 53.1235 154.317 52.9905C154.005 52.903 154.066 52.5761 152.467 52.3936C152.403 52.386 152.346 52.3936 152.418 52.5305C152.479 52.6445 152.521 52.7814 152.634 52.7548C152.665 52.7472 152.737 52.789 152.779 52.865C152.957 53.2034 153.139 53.2338 153.318 53.306C153.762 53.4885 154.237 53.7584 154.605 53.7622C154.704 53.7622 154.905 53.9447 155.049 54.0207C155.444 54.226 155.809 54.3514 156.188 54.5377C157.176 55.0129 157.464 55.2068 157.567 55.0662C157.597 55.0243 157.696 55.1118 157.768 55.165C158.326 55.5604 158.778 55.7314 159.226 55.8987C159.423 55.9709 159.397 55.7923 159.454 55.7124C159.473 55.6858 159.404 55.5794 159.336 55.5033C159.112 55.2562 159.112 55.1878 159.256 55.2258C159.302 55.2372 159.328 55.2182 159.363 55.2144C159.518 55.26 159.67 55.3057 159.898 55.4767C160.145 55.6668 160.141 55.644 160.285 55.9481C160.281 55.9671 160.278 55.9861 160.274 56.0052C160.076 55.8531 159.868 55.8379 160.061 56.2028C160.152 56.3739 160.274 56.4423 160.38 56.5146C160.464 56.5678 160.551 56.6248 160.593 56.6058C160.802 56.7465 160.942 56.7655 161.109 56.8377C161.261 57.0658 161.39 57.1723 161.428 57.0848C161.458 57.0164 161.523 57.0088 161.625 57.0354C161.762 57.0734 161.58 56.7541 161.762 56.8415C161.793 56.8567 161.686 56.7123 161.618 56.6552C161.432 56.5032 161.284 56.4119 161.219 56.469C161.052 56.4081 160.817 56.2181 160.623 56.104C160.452 55.7847 160.737 55.9709 160.714 55.8341C160.741 55.8417 160.764 55.8531 160.79 55.8607C160.862 55.9291 160.896 55.9405 160.893 55.8949C160.965 55.8455 161.196 56.009 161.227 55.8797C160.748 55.4843 160.414 55.3095 160.107 55.1992C160.076 55.1688 160.061 55.1612 160.054 55.1726C159.959 55.1118 159.879 55.0814 159.822 55.0852C159.628 54.9065 159.526 54.8989 159.442 54.9141C159.195 54.9483 158.884 54.5758 158.216 54.3324C158.079 54.283 157.893 54.0397 157.775 54.0055C157.506 53.9295 157.138 53.6101 156.83 53.4391C156.659 53.2224 156.553 53.2832 156.39 53.0969C156.253 52.8612 156.534 53.0703 156.412 52.865C156.367 52.789 156.321 52.7662 156.268 52.732C155.976 52.5305 155.98 52.5305 155.93 52.2149C156.386 52.6673 156.724 52.8042 157.088 52.9943C157.324 53.1197 158.755 54.0055 159.021 53.785C159.139 53.69 159.328 53.7356 159.598 53.8839C159.716 53.8192 159.818 53.747 160.118 53.9105C159.731 53.5075 159.435 53.2832 159.127 52.922C159.116 52.9106 159.097 52.8916 159.089 52.8878C158.728 52.6711 158.208 52.1275 157.87 51.9868C157.65 51.8956 157.403 51.7587 157.263 51.8044C157.134 51.8462 156.898 51.7435 156.671 51.6523C156.583 51.5611 156.519 51.5193 156.473 51.5269C156.333 51.4318 156.223 51.3786 156.329 51.6029C156.055 51.4318 155.999 51.3634 155.949 51.1467C156.185 51.2874 156.287 51.2151 156.5 51.3178C156.644 51.39 156.435 50.9262 156.834 51.2759C156.978 51.4014 157.088 51.4622 157.164 51.428C156.944 51.2303 156.811 51.1619 156.659 51.0517C156.496 50.9338 156.329 50.8045 156.177 50.7133C155.55 50.3293 155.353 50.0936 154.799 49.8693C154.685 49.8237 154.563 49.7439 154.419 49.5994C153.386 48.5844 152.786 48.7783 152.054 48.113C150.208 46.4327 146.761 45.1516 143.989 44.4559C143.385 44.3038 142.736 44.0529 142.117 43.9122C142.072 43.9008 142.011 43.8742 141.984 43.8932C141.658 44.1555 140.906 43.6309 140.697 43.7792C140.652 43.8096 140.652 43.8856 140.754 43.9578C140.716 44.1023 140.652 44.0301 140.033 43.8514C139.683 43.6689 139.657 43.6043 139.478 43.6157C137.614 43.0341 137.048 42.6273 136.847 42.9466C136.828 42.9504 136.802 42.9732 136.786 42.9618C136.316 42.5208 135.864 42.8098 135.7 42.6995C135.693 42.6995 135.689 42.6995 135.678 42.7033C135.617 42.6767 135.568 42.6805 135.541 42.7413C135.457 42.7413 135.374 42.7413 135.294 42.7413C135.203 42.6805 135.101 42.6425 135.055 42.4904C135.055 42.4676 135.063 42.4524 135.078 42.4486C135.256 42.5018 135.123 42.1635 135.059 42.3041C134.911 42.2661 134.759 42.2243 134.611 42.1863C134.603 42.0913 134.577 41.9848 134.489 41.9848C134.421 41.9848 134.455 42.0836 134.482 42.1597C134.349 42.1445 134.212 42.1293 134.079 42.1141C133.901 41.9696 133.711 41.9354 133.536 41.7111C133.365 41.4944 133.176 41.559 132.989 41.8099C132.921 41.7909 132.853 41.7681 132.784 41.7491C132.784 41.4868 132.663 41.4564 132.519 41.464C130.191 40.8785 130.905 41.0382 129.284 40.8823C129.041 40.8595 128.779 40.7873 128.528 40.7227C126.66 40.2323 124.629 40.179 122.681 40.179C122.37 40.179 122.054 40.2133 121.739 40.2361C121.428 40.0802 120.824 40.0954 120.562 40.2627C120.429 40.3159 120.293 40.3121 120.16 40.3159C119.913 40.2437 119.708 40.4528 119.48 40.5098C119.127 40.9508 118.683 40.601 117.02 41.08C116.887 41.137 116.959 41.1941 117.012 41.2245C117.138 41.3043 117.331 41.2549 117.373 41.4982C117.358 41.5096 117.301 41.5628 117.289 41.578C117.225 41.7111 117.221 41.8442 117.255 41.9772C117.198 42.0076 117.183 42.0608 117.183 42.1293C117.145 42.1407 117.107 42.1483 117.069 42.1597C117.031 42.1407 116.997 42.1179 116.963 42.0988C116.97 41.886 116.887 41.924 116.781 42.0114C116.458 41.8251 116.446 41.8099 116.446 41.8099C116.314 41.7567 116.606 41.4982 116.382 41.4868C116.234 41.4792 116.101 41.5362 115.831 41.7529C115.896 41.8974 116.059 41.7415 116.135 41.8632C116.052 42.0114 115.945 42.0722 115.831 42.0228C115.653 41.943 115.444 42.0304 115.273 41.9202C115.228 41.8898 115.121 41.8898 115.087 41.9316C114.859 42.2395 114.651 42.0494 114.434 42.0608C114.419 42.0418 114.4 42.038 114.377 42.0418C114.168 41.7605 112.976 41.9886 112.509 42.0608C112.372 42.0799 112.224 42.1217 112.091 42.2433C111.693 42.3231 111.568 42.2357 111.021 42.5855C111.203 42.7451 111.321 42.6501 111.776 42.7071C111.803 42.7337 111.826 42.7793 111.86 42.7793C112.217 42.7831 112.513 43.0036 112.889 42.9466C113.405 42.8706 113.212 43.2736 113.553 43.1937C113.606 43.2089 113.663 43.2203 113.717 43.2355C114.085 43.1633 114.073 43.8704 114.518 43.7069C114.681 43.6461 114.681 43.7906 114.704 43.9122C114.772 44.262 114.533 44.3532 114.377 44.2126C114.229 44.0757 114.203 43.8514 113.952 43.9198C113.8 43.9616 113.773 44.1555 113.846 44.2164C114.218 44.5319 114.544 44.3988 114.571 45.3834C114.533 45.3911 114.191 45.4633 114.157 45.4557C114.157 45.4671 114.157 45.4747 114.157 45.4861C113.979 45.9651 114.552 45.9879 114.165 46.4555C114.423 46.3947 114.609 46.2882 114.643 45.9499C114.814 45.8016 114.977 45.9575 115.152 45.8777C115.25 45.832 115.334 46.0563 115.19 46.14C114.996 46.2464 114.939 46.4669 114.871 46.6798C114.916 46.6456 114.966 46.6152 115.011 46.581C115.133 46.6076 115.144 46.6114 115.011 46.581C114.966 46.6152 114.916 46.6456 114.871 46.6798C114.677 46.9687 114.673 46.9725 114.863 47.174C114.901 47.2158 114.958 47.2386 114.947 47.3147C114.932 47.4173 114.859 47.4591 114.787 47.4743C114.624 47.5086 114.457 47.539 114.313 47.501C114.252 47.3413 114.385 47.3071 114.415 47.2196C114.461 47.098 114.438 47.0067 114.343 46.9877C114.051 46.9345 113.762 46.9725 113.474 47.2044C113.363 47.2919 113.401 47.4667 113.508 47.4515C113.785 47.4097 113.891 47.2652 114.081 47.5352C114.556 48.2233 115.087 47.615 115.231 48.2309C115.292 48.4894 115.429 48.5768 115.676 48.478C115.919 48.3791 116.128 48.5388 116.382 48.6034C116.143 49.09 116.264 49.417 116.595 49.7059C116.071 49.8427 115.995 50.3446 115.896 50.8236C115.877 50.9072 115.904 51.0098 116.014 50.9376C116.435 50.9034 116.61 50.9528 116.925 50.9186C117.768 50.8312 117.578 50.3826 118.087 50.2115C118.337 50.1279 118.406 50.1773 118.478 50.4928C118.508 50.6259 118.573 50.7475 118.558 50.8996C117.874 50.9072 117.21 51.1885 116.507 51.2607V51.295ZM115.209 43.9312C115.197 43.8704 115.209 43.7221 115.209 43.7221C115.209 43.7221 115.194 43.8704 115.209 43.9312ZM115.061 44.8398C115.142 44.8348 115.142 44.8348 115.061 44.8398V44.8398ZM115.334 47.136C115.311 47.1512 115.288 47.1816 115.266 47.1854C115.243 47.1854 115.205 47.1626 115.205 47.1474C115.212 47.0866 115.25 47.0676 115.288 47.079C115.307 47.0828 115.319 47.117 115.33 47.1398L115.334 47.136ZM116.162 47.4249C116.162 47.4249 116.12 47.5086 116.116 47.5694C116.116 47.5086 116.162 47.4249 116.162 47.4249ZM116.629 45.9575C116.629 45.9575 116.617 45.9765 116.61 45.9917C116.617 45.9803 116.621 45.9727 116.629 45.9575ZM117.445 47.8127L117.411 47.7823C117.411 47.7823 117.434 47.8051 117.445 47.8127ZM117.665 48.094L117.65 48.113C117.65 48.113 117.661 48.0978 117.665 48.094ZM158.277 53.3706C158.197 53.2946 158.201 53.3022 158.277 53.3706V53.3706ZM157.327 52.9563C157.327 52.9563 157.365 53.0247 157.384 53.0551C157.453 53.0969 157.586 53.1768 157.586 53.1768C157.586 53.1768 157.453 53.1007 157.384 53.0551C157.365 53.0209 157.327 52.9563 157.327 52.9563ZM157.069 52.6179C157.069 52.6179 157.187 52.6711 157.236 52.6787C157.368 52.7497 157.368 52.7497 157.236 52.6787C157.187 52.6749 157.069 52.6179 157.069 52.6179ZM155.528 52.7738C155.661 52.8726 155.923 53.0551 155.923 53.0551C155.923 53.0551 155.661 52.8764 155.528 52.7738ZM155.004 52.3214C154.992 52.253 154.981 52.1807 154.966 52.1123C154.981 52.0857 154.996 52.0629 155.011 52.0363C155.167 52.1427 155.258 52.1161 155.387 52.1769C155.516 52.2378 155.588 52.3404 155.543 52.4202L155.307 52.3518C155.148 52.2416 155.182 52.4583 155.004 52.3214ZM154.442 50.7817C154.461 50.8274 154.487 50.9148 154.487 50.9148C154.487 50.9148 154.461 50.8274 154.442 50.7779V50.7817ZM154.719 50.7589C154.818 50.6943 154.916 50.6335 155.14 50.7627C155.175 50.7931 155.213 50.8198 155.247 50.8502C155.345 50.9604 155.433 50.9794 155.539 51.1125C155.509 51.1315 155.55 51.2037 155.592 51.2798C155.421 51.2341 155.144 51.0098 155.102 51.1961C155.091 51.2531 154.916 51.1391 154.784 50.93C154.806 50.8996 154.784 50.8464 154.715 50.7551C154.442 50.6132 154.442 50.6132 154.715 50.7551L154.719 50.7589ZM154.313 52.0667H154.335C154.335 52.0667 154.328 52.0743 154.313 52.0667C154.225 52.0021 154.218 51.9983 154.313 52.0667ZM153.269 50.5993C153.174 50.4814 152.969 50.2571 152.969 50.2571C152.969 50.2571 153.17 50.4776 153.269 50.5993C153.504 50.7171 153.485 50.7095 153.269 50.5993ZM153.72 51.3786C153.72 51.3786 153.834 51.428 153.884 51.4318C153.838 51.4318 153.72 51.3786 153.72 51.3786ZM153.375 50.892C153.375 50.892 153.458 50.911 153.523 50.9604C153.462 50.9148 153.375 50.892 153.375 50.892ZM150.068 47.8849C150.068 47.8849 150.44 48.0902 150.653 48.3031C150.436 48.0864 150.068 47.8849 150.068 47.8849ZM144.236 48.056C144.236 48.056 144.274 48.0712 144.297 48.0826L144.236 48.056ZM138.544 49.4398C138.556 49.3181 138.635 49.147 138.635 49.147C138.635 49.147 138.559 49.3181 138.544 49.4398ZM138.134 49.9872C138.146 49.9606 138.146 49.9606 138.134 49.9872V49.9872ZM137.865 50.1621C137.865 50.1621 137.865 50.1621 137.868 50.1583L137.865 50.1621ZM136.6 43.2051C136.559 42.9846 136.631 42.9428 136.794 43.0531C136.802 43.1215 136.813 43.1899 136.866 43.2507C136.855 43.2773 136.84 43.304 136.828 43.3306C136.752 43.2888 136.676 43.2469 136.6 43.2051ZM136.912 52.4164C136.866 52.1807 137.01 52.2796 137.101 52.2872C137.071 52.386 136.991 52.405 136.912 52.4164ZM136.942 55.2182C136.684 55.1878 136.684 55.1878 136.942 55.2182V55.2182ZM135.598 53.2224V53.2262C135.598 53.2262 135.598 53.2262 135.598 53.2224ZM135.271 54.8723C135.351 54.7772 135.355 54.7696 135.271 54.8723V54.8723ZM135.408 52.9753C135.408 52.9753 135.408 52.9753 135.412 52.9753C135.412 52.9753 135.412 52.9753 135.408 52.9753ZM135.325 52.4506C135.373 52.3265 135.373 52.3265 135.325 52.4506V52.4506ZM120.767 49.512C120.756 49.5766 120.832 49.6146 120.832 49.6146C120.832 49.6146 120.76 49.5766 120.767 49.512ZM120.285 50.0708C120.334 50.0176 120.456 49.9644 120.456 49.9644C120.456 49.9644 120.334 50.0138 120.285 50.0708ZM118.223 49.2535C118.804 49.6983 118.839 49.7249 118.223 49.2535V49.2535ZM119.837 48.1358C119.837 48.1358 119.799 48.1966 119.788 48.2347C119.799 48.2004 119.837 48.1358 119.837 48.1358ZM119.681 50.3902C119.719 50.4776 119.852 50.5536 119.852 50.5536C119.848 50.5536 119.719 50.4776 119.681 50.3902ZM119.101 50.1051C119.101 50.1051 119.446 50.048 119.621 50.0214C119.75 50.0404 119.883 50.0632 120.012 50.0822C119.53 50.0062 119.097 50.1013 119.097 50.1013L119.101 50.1051ZM118.839 48.9418C118.88 48.9722 118.968 49.0216 118.968 49.0216C118.968 49.0216 118.88 48.976 118.839 48.9418ZM118.994 41.7491C118.956 41.7339 118.865 41.7377 118.865 41.7377C118.865 41.7377 118.952 41.7377 118.994 41.7491ZM118.683 49.8732C118.683 49.8732 118.402 50.029 118.254 49.8922C118.174 49.7249 117.95 49.6717 117.95 49.6717C117.95 49.6717 118.174 49.7249 118.254 49.8884C118.402 50.0214 118.683 49.8693 118.683 49.8693V49.8732Z",
    fill: "#09363F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M125.832 128.483C125.92 128.643 125.996 128.795 126.166 128.814C126.17 128.821 126.174 128.821 126.178 128.829C126.759 129.909 126.603 129.707 126.968 129.825C126.994 129.954 127.055 130.03 127.165 130.053C127.192 130.22 127.26 130.35 127.381 130.433C127.385 130.57 127.446 130.654 127.552 130.684C127.552 130.684 127.552 130.684 127.552 130.688C127.526 131.159 127.784 131.41 128.038 131.661C128.042 132.247 128.646 131.98 128.623 132.52C128.6 133.129 128.76 133.733 128.555 134.341C128.312 135.056 128.885 135.562 128.547 136.421C128.456 136.649 128.494 136.835 128.665 136.93C129.261 137.253 128.779 138.177 129.166 138.322C129.166 138.322 129.17 138.325 129.174 138.329C129.227 138.584 129.31 138.812 129.53 138.903C129.557 139.143 129.561 139.409 129.796 139.508C129.88 139.736 129.978 139.964 129.944 140.23C129.853 140.918 130.506 140.553 130.651 141.112C130.7 141.306 130.84 141.344 130.992 141.332C131.406 141.298 131.816 141.359 132.23 141.26C132.553 141.313 132.788 141.545 132.997 141.804C133.453 142.37 133.263 141.625 134.296 142.454C134.603 142.701 134.911 142.948 135.169 143.256C135.886 144.104 134.789 145.423 135.613 146.301C135.864 146.571 136.065 146.909 136.281 147.214C136.3 147.556 136.289 147.921 136.57 148.073C136.57 148.354 136.688 148.479 136.912 148.464C137.007 148.692 137.2 148.768 137.367 148.879C137.451 149.206 137.561 149.544 137.705 149.783C138.051 150.354 138.776 151.456 139.41 151.152C139.702 151.011 139.896 151.198 140.128 151.262C140.215 151.604 140.291 151.947 140.09 152.38C140.04 152.49 140.025 152.65 140.052 152.745C140.181 153.186 140.34 153.596 140.697 153.775C140.75 153.775 140.803 153.779 140.86 153.783C140.993 154.174 141.278 154.034 141.893 153.999C141.901 154.132 141.98 154.159 142.079 154.159C142.223 154.159 142.364 154.186 142.512 154.174C142.827 154.148 142.952 154.304 142.926 154.718C142.85 155.832 143.624 155.493 144.194 155.36C144.315 155.429 144.448 155.254 144.577 155.186C144.877 155.026 144.881 155.022 144.942 155.364C144.893 155.57 144.843 155.775 144.79 155.98C144.574 156.06 144.361 156.132 144.19 156.026C143.879 155.832 143.511 156.877 143.799 156.847C144.046 156.82 144.217 156.972 144.467 156.919C144.547 156.946 144.589 157.014 144.608 157.113C144.608 157.14 144.615 157.151 144.634 157.155C144.589 157.451 144.471 157.786 144.627 157.968C144.593 158.128 144.68 158.12 144.786 158.139C144.877 158.326 145.037 158.227 145.432 158.219C145.424 158.425 145.424 158.622 145.61 158.622C145.572 159.09 145.341 159.147 145.151 159.333C144.934 159.394 144.718 159.451 144.502 159.508C143.947 159.652 143.826 160.466 143.997 160.641C144.27 160.915 144.801 160.648 144.733 161.34C144.65 162.2 145.618 161.61 145.079 162.515C144.615 163.294 144.35 163.359 144.24 163.842C144.11 164.404 143.632 164.747 142.797 165.435C142.709 165.507 142.607 165.556 142.588 165.701C142.577 165.803 142.645 165.807 142.713 165.788C143.727 165.496 143.978 165.997 144.24 165.541C144.289 165.522 144.334 165.503 144.384 165.48C144.475 165.511 144.513 165.689 144.718 165.355C145.026 165.169 145.337 164.891 145.648 164.762C145.861 164.671 146.153 164.442 146.396 164.116C146.692 164.02 146.985 163.827 147.285 163.374C147.33 163.306 147.406 163.253 147.467 163.188C147.955 162.676 148.407 162.091 148.822 161.432C148.914 161.287 148.921 161.223 148.895 161.158C148.777 160.839 149.221 160.736 149.274 160.42C149.327 160.097 149.506 159.744 149.688 159.386C149.756 159.249 149.798 159.132 149.756 159.056C149.939 158.504 149.901 158.474 149.362 158.717L149.354 158.698C149.392 158.611 149.396 158.554 149.354 158.531C149.365 158.466 149.381 158.405 149.392 158.341C149.426 158.299 149.475 158.253 149.498 158.212C149.813 157.588 149.817 158.132 150.091 157.809C150.197 157.683 150.265 157.577 150.193 157.493C150.007 157.269 149.889 156.988 150.056 156.432C150.406 155.288 149.472 156.455 149.453 155.931C149.453 155.828 149.388 155.782 149.335 155.79C149.335 155.79 149.377 155.703 149.377 155.699C149.612 155.497 149.544 155.33 149.578 155.155C149.608 154.999 149.57 154.87 149.673 154.684C149.722 154.596 149.783 154.52 149.855 154.513C149.939 154.505 149.908 154.581 149.863 154.68C149.703 155.018 149.81 155.205 149.836 155.425C149.863 155.646 150.425 155.383 150.383 155.151C150.292 154.627 150.478 153.927 150.531 153.296C150.539 153.22 150.573 153.121 150.558 153.064C150.409 152.49 150.755 151.76 151.059 151.046C151.138 150.859 151.211 150.65 151.097 150.605C150.782 150.475 150.907 149.977 150.831 149.643C150.793 149.487 150.842 149.266 150.709 149.183C150.656 149.152 150.66 149.065 150.66 148.985C150.649 148.168 150.516 147.385 150.823 146.396C151.028 145.921 151.169 145.472 150.952 145.142C150.918 145.092 150.93 144.993 150.918 144.914C150.975 144.769 151.025 144.625 151.123 144.495C151.203 144.393 151.237 144.283 151.188 144.199C151.055 143.975 151.146 143.621 151.116 143.336C150.93 141.534 151.306 140.165 151.393 139.717C151.416 139.61 151.495 139.489 151.454 139.397C151.195 138.842 151.332 138.352 151.617 136.375C151.773 136.098 151.757 135.938 151.841 135.451C151.864 135.413 151.871 135.379 151.864 135.341C151.955 135.246 152.073 135.181 152.126 135.037C152.748 134.474 152.71 134.17 153.895 133.387C154.054 133.368 154.18 133.239 154.297 133.091C154.742 132.851 155.213 132.566 155.592 132.167C155.835 131.787 156.2 131.562 156.424 131.156C156.481 131.129 156.519 131.083 156.53 131.011C156.545 130.992 156.553 130.973 156.56 130.954C156.602 130.889 156.682 130.81 156.678 130.76C156.636 129.928 157.198 129.829 158.531 126.959C158.831 126.316 159.101 125.655 159.541 125.103C159.621 125.001 159.697 124.871 159.738 124.742C160.05 123.78 161.234 123.4 160.862 123.127C160.862 122.803 161.083 122.526 161.128 122.21C161.295 121.967 161.409 121.811 161.174 121.724C161.124 121.252 160.843 121.051 160.532 120.891C160.49 120.808 160.448 120.728 160.403 120.644C160.71 120.591 160.866 120.188 161.136 120.047C161.147 120.04 161.166 120.013 161.166 120.002C161.177 119.576 161.265 119.104 161.166 118.736C161.045 118.272 160.786 117.884 160.809 117.329C160.821 117.074 160.661 117.014 160.513 117.002C159.719 116.945 160.05 115.607 159.514 115.5C159.169 115.428 159.116 115.037 158.956 114.755C158.941 114.729 158.926 114.664 158.937 114.645C159.222 114.219 158.937 113.782 159.055 113.349C159.161 112.969 158.99 112.615 159.066 112.227C159.207 111.497 159.75 111.178 159.962 110.228C160.023 109.95 160.24 109.84 160.41 109.692C160.502 109.616 160.593 109.619 160.672 109.699C161.227 110.269 161.333 110.334 161.181 110.642C161.109 110.786 161.06 110.95 161.185 111.064C161.322 111.189 161.515 111.315 161.652 111.148C161.827 110.935 162.092 110.889 162.218 110.608C162.449 110.087 163.619 110.547 163.858 109.502C163.987 108.939 164.705 108.935 165.02 108.741C165.662 108.35 164.929 107.852 165.707 107.084C165.999 106.795 166.246 106.437 166.463 106.057C166.679 106.004 166.69 105.704 166.835 105.563C167.302 105.59 167.522 105.647 167.978 105.381C169.101 104.719 169.288 105.251 169.998 104.366C172.321 101.457 171.767 103.993 173.513 103.229C174.265 102.902 175.013 102.586 175.719 102.202C176.293 101.887 176.828 101.488 177.439 101.305C177.546 101.275 177.644 101.195 177.713 101.089C178.047 100.583 178.199 100.83 178.673 100.271C179.33 99.4995 178.176 99.2752 179.137 97.5721C179.376 97.1501 179.664 96.7852 179.923 96.4012C179.869 96.3404 179.82 96.1959 179.82 96.1959C179.82 96.1959 179.873 96.3404 179.923 96.4012C180.109 96.3138 180.211 96.1351 180.283 95.9184L180.363 95.8157C180.382 95.8043 180.393 95.7891 180.405 95.7663C180.538 95.7131 180.674 95.6675 180.8 95.6028C181.27 95.3595 180.652 95.0136 181.031 94.7475C181.289 94.5688 181.578 94.4358 181.635 94.01C181.658 93.8313 181.927 93.9187 181.943 93.6944C182.265 93.569 182.277 93.1508 182.535 93.2192C182.58 93.2306 182.611 93.1926 182.596 93.1432C182.398 92.6072 182.782 92.3753 182.74 91.9305C182.74 91.9267 182.74 91.9229 182.74 91.9191C182.903 91.5617 182.732 91.71 183.082 91.4173C183.321 91.5275 183.499 91.4211 183.708 91.4363C183.83 92.4133 183.89 92.5425 183.439 92.8923C183.025 92.8391 182.945 92.9607 183.055 93.4853C183.017 93.5348 182.945 93.5728 182.945 93.6374C182.937 94.3331 182.311 94.6677 182.25 95.1391C182.205 95.4774 182.151 95.8081 181.95 96.0476C181.935 96.0666 181.912 96.1009 181.916 96.1275C181.981 96.4962 181.886 96.6597 181.574 96.7015C181.369 96.7281 181.32 97.0589 181.233 97.2756C181.16 97.458 181.354 97.6139 181.487 97.7165C181.635 97.8344 181.673 97.6937 181.715 97.5759C181.916 97.0094 182.497 96.7433 182.774 96.5038C183.169 96.1579 182.402 95.7473 183.006 95.3063C183.203 95.1619 183.378 94.9908 183.644 94.9452C183.947 94.8919 184.171 94.6448 184.304 94.3255C184.285 94.3027 184.262 94.2609 184.243 94.2533C184.069 94.2038 183.894 94.181 183.788 93.9149C183.689 93.6678 183.818 93.5766 183.894 93.4473C184.012 93.242 184.186 93.1204 184.373 93.0177C184.669 92.8505 184.441 92.7478 184.972 91.2044C184.995 91.136 185.022 91.0637 185.018 90.9801C182.926 82.263 179.433 74.4393 174.334 67.0679C173.817 66.7334 173.35 66.319 173.027 66.3874C173.327 66.7182 173.506 66.7448 173.817 67.0717C173.217 66.8094 172.492 66.3646 171.706 65.8362C171.645 65.7754 171.596 65.7374 171.55 65.7108C171.501 65.6765 171.452 65.6423 171.402 65.6119C171.194 65.4256 171.057 65.3458 171.068 65.4789C171.053 65.5093 170.989 65.4789 170.92 65.437C170.685 65.1899 170.673 65.1861 170.749 65.399C170.711 65.38 170.67 65.361 170.632 65.342C170.465 65.2394 170.392 65.228 170.279 65.0721C170.157 64.9048 170.256 64.9314 170.294 64.9048C170.351 64.8592 170.29 64.7642 170.1 64.6007C170.074 64.5779 170.043 64.5475 170.024 64.5361C169.515 64.2471 168.6 63.4526 168.672 63.7339C168.532 63.7529 168.312 63.6693 168.171 63.6997C168.118 63.7111 168.023 63.6807 167.924 63.6313C167.233 63.2777 167.431 63.6047 166.561 63.061C165.829 62.601 165.282 62.5706 165.179 62.3273C165.069 62.0688 164.891 61.9434 164.682 61.7609C165.138 61.8217 165.248 61.8825 165.187 61.7609C165.157 61.6963 165.096 61.624 165.05 61.6012C164.819 61.4834 164.587 61.202 164.348 60.9816C164.086 60.7383 163.809 60.5292 163.695 60.6394C163.626 60.7078 163.478 60.6318 163.262 60.4873C163.387 60.3847 163.178 60.0768 163.068 59.8297C163.045 59.746 163 59.6548 162.932 59.5521L162.909 59.5255C162.829 59.4533 162.753 59.4001 162.692 59.3849C162.59 59.2138 162.449 59.1074 162.328 58.9895C162.085 58.7589 161.925 58.5282 161.849 58.2976C161.868 58.2596 161.857 58.1836 161.918 58.1874C162.138 58.2938 161.853 58.0239 161.751 57.8452C161.58 57.5411 161.356 57.3282 161.139 57.1799C160.657 56.8606 160.213 56.6211 159.814 56.488C159.37 56.3398 159.013 56.1155 158.717 56.0661C158.797 56.1725 158.933 56.3208 159.074 56.431C159.135 56.5147 159.195 56.5603 159.252 56.5831C159.347 56.6743 159.442 56.7656 159.537 56.8606C159.59 56.9366 159.647 56.9937 159.704 57.0165C160.012 57.3054 160.278 57.4765 160.486 57.5031C160.612 57.6057 160.741 57.6589 160.862 57.8604C160.98 58.0581 161.155 58.1303 161.303 58.3432C161.303 58.5599 160.714 58.2216 161.007 58.8298C160.684 58.7614 160.528 58.6892 160.627 58.9287C160.619 58.9287 160.612 58.9363 160.604 58.9439C160.57 58.9325 160.509 58.9097 160.509 58.9135C160.657 59.2632 160.441 59.1834 160.274 59.1454C159.613 58.9933 160.145 59.3963 159.666 59.2024C159.552 59.0846 159.45 59.0275 159.374 59.0313C158.941 59.0579 158.626 59.0313 159.093 59.613C159.298 59.8677 159.317 59.9247 159.173 59.9627C159.063 59.9931 158.987 60.0882 158.823 60.035C158.728 60.0007 158.626 59.9817 158.516 59.8373C158.379 59.6586 158.501 59.6472 158.482 59.5445C158.459 59.4419 158.428 59.3317 158.307 59.2556C158.212 59.1948 158.204 59.2708 158.193 59.3317C158.155 59.3279 158.117 59.3241 158.075 59.3203C157.821 59.134 157.711 58.826 157.513 58.5903C157.411 58.29 157.305 57.9897 157.202 57.6932C157.35 57.7768 157.464 57.7806 157.574 57.7882C157.988 58.1684 158.212 58.1341 158.383 57.9973C158.664 58.0809 158.987 58.2178 159.082 58.0239C159.157 57.8718 159.389 57.8528 159.146 57.4042C159.07 57.2446 159.032 57.0849 158.846 56.9214C158.425 56.3664 157.984 55.9368 157.525 55.6403C157.213 55.2829 157.096 55.3514 156.64 55.1271C156.185 54.8153 155.805 54.6405 155.653 54.9294C155.342 54.7583 155.03 54.591 154.715 54.4238C154.123 54.0018 153.842 54.2185 153.5 53.9752C153.462 53.9372 153.424 53.8991 153.386 53.8611C153.143 53.6444 153.003 53.6748 152.858 53.7053C152.164 53.519 151.769 53.2491 151.442 53.4125C151.347 53.462 151.203 53.4354 151.082 53.443C150.926 53.4658 150.93 53.5 151.119 53.7775C151.093 53.7775 151.066 53.7775 151.04 53.7775C150.945 53.6939 150.873 53.6749 150.823 53.7205C150.535 53.6406 150.432 53.9258 150.125 53.8231C149.878 53.9638 149.57 53.9638 149.179 53.7889C148.951 53.6863 148.777 53.7395 148.591 53.7471C148.428 53.8725 148.154 53.8155 148.021 54.0056C147.964 54.0854 147.82 53.9486 147.736 53.96C147.588 53.9752 147.395 53.8307 147.25 53.8573L147.231 53.8459C147.231 53.8535 147.231 53.8573 147.231 53.8649C147.205 53.8877 147.178 53.9105 147.152 53.9334C146.989 53.8421 146.81 53.7205 146.799 53.979C146.791 54.1158 146.67 54.0322 146.594 54.0398C146.4 54.055 146.222 54.0968 146.263 54.4124C146.29 54.6101 146.123 54.5796 146.089 54.6975C146.214 54.9484 146.48 54.8229 146.556 55.1347C146.582 55.2487 146.559 55.3286 146.484 55.34C146.115 55.3894 145.827 55.6479 145.367 55.511C145.041 55.416 144.805 55.5452 144.593 55.7277C144.209 55.7125 143.867 55.8076 143.53 55.9178C143.412 55.8874 143.34 55.8266 143.302 55.9368C143.211 55.9596 143.1 55.9558 143.078 56.0889C143.085 56.1231 143.082 56.1763 143.1 56.1915C143.427 56.5185 143.662 57.0431 144.091 57.1647C144.232 57.2027 144.376 57.2712 144.509 57.4042C144.555 57.6285 144.646 57.7616 144.824 57.7274C145.91 57.8642 145.815 56.7542 146.905 57.2256C147.167 57.9669 146.521 57.9251 146.521 58.3508C146.389 58.3014 146.252 58.252 146.119 58.2064C146.104 58.1988 146.096 58.1912 146.081 58.1836C146.073 58.195 146.07 58.1988 146.062 58.2102C146.058 58.2254 146.051 58.2444 146.047 58.2596C145.998 58.2368 145.99 58.2596 146.005 58.3166C145.971 58.3432 145.937 58.3698 145.903 58.3965C145.675 58.3432 145.603 58.4687 145.656 58.7462C145.637 58.7842 145.618 58.8222 145.599 58.8565C145.462 58.845 145.303 58.8184 145.341 58.9933C145.363 59.0998 145.443 59.153 145.515 59.1834C145.675 59.2556 145.751 59.3545 145.808 59.5788C145.865 59.8069 145.903 59.9589 145.58 59.8867C145.906 60.1034 146.024 60.0045 146.13 59.8981C146.506 59.5217 146.351 59.8981 147.33 59.5674C147.486 59.6282 147.653 59.651 147.74 59.9209C147.418 60.0045 147.068 60.0502 146.852 60.3467C146.552 60.1908 146.575 60.4455 146.548 60.7497C147.152 60.6432 147.74 60.6964 148.302 60.6812C148.371 60.6812 148.409 60.6356 148.428 60.5596C148.45 60.5596 148.473 60.5596 148.496 60.552C148.625 60.59 148.758 60.628 148.849 60.5672C149.031 60.4417 149.251 60.4873 149.51 60.6356C149.612 60.6964 149.726 60.7306 149.775 60.6584C149.912 60.4645 150.144 60.4227 150.322 60.2973C151.051 59.7726 151.894 59.6548 153.045 60.3049C153.413 60.514 153.724 60.4759 154.009 60.4265C154.134 60.4037 154.1 60.2136 153.925 60.0273C153.656 59.7422 153.379 59.4457 153.079 59.3659C152.82 59.2974 152.559 59.2822 152.308 58.8565C151.898 58.75 151.514 58.271 151.119 58.0125C150.903 57.8718 150.717 57.7084 150.523 57.5221C150.451 57.4537 150.402 57.3738 150.391 57.2864C150.353 56.9518 151.287 57.4461 151.579 57.6285C151.89 57.8224 152.183 57.9517 152.456 57.9783C152.634 58.0581 152.779 58.0543 152.919 58.0467C153.048 58.0505 153.101 57.9631 153.101 57.8148C153.101 57.6399 153.086 57.4917 152.855 57.2978C152.289 56.834 152.855 56.9366 152.714 56.4652C152.475 56.3854 152.562 56.2485 152.714 56.4576C152.767 56.4804 152.82 56.4918 152.874 56.5337C153.587 57.0887 153.048 57.4613 153.591 57.716C154.009 57.9137 153.842 57.7084 154.316 57.6019C154.354 57.5943 154.392 57.5715 154.358 57.4917C154.294 57.3358 154.153 57.2978 153.811 57.0849C153.622 56.967 153.363 56.6971 153.375 56.5641C153.379 56.5071 153.432 56.5033 153.485 56.5489C154.446 57.3586 154.829 56.431 155.429 57.4156C155.342 57.4422 155.224 57.3928 155.099 57.3244C155.057 57.2826 155.038 57.2826 155.038 57.3244C155.038 57.332 155.034 57.332 155.03 57.3396C154.859 57.6057 154.939 57.7958 155.364 58.1189C156.143 58.7082 154.427 58.3546 156.078 59.4419C156.352 59.6206 156.602 59.9095 156.872 60.092C156.883 60.0692 156.902 60.0768 156.921 60.111C156.925 60.1224 156.921 60.13 156.917 60.1414C156.97 60.2783 156.86 60.3695 157.035 60.5292C157.176 60.6584 157.301 60.6736 157.396 60.6432C157.468 60.6204 157.472 60.4987 157.643 60.5976C157.692 60.8447 157.567 60.9017 157.407 60.8675C157.039 60.7953 156.815 61.0006 156.447 60.9435C156.272 60.9169 156.226 61.0652 156.276 61.2971C155.972 61.2629 155.691 61.0652 155.68 61.3389C155.702 61.5442 155.828 61.605 155.957 61.662C156.097 61.7495 156.223 61.7761 156.333 61.7647C156.583 61.7875 156.845 61.8445 157.058 61.7799C157.54 61.6278 157.662 62.2171 158.341 62.5212C158.341 62.5212 158.341 62.5212 158.345 62.525C158.44 62.6809 158.539 62.7569 158.645 62.7531C158.888 62.8443 159.021 62.9318 158.979 62.7227C159.021 62.6162 159.093 62.5744 159.26 62.6695C159.423 62.7607 159.579 62.8063 159.735 62.8672C159.898 62.928 159.917 62.7873 159.693 62.5364C159.681 62.5212 159.666 62.506 159.651 62.4984C159.23 62.2627 159.078 61.8445 158.888 61.4568C158.812 61.3009 158.683 61.1222 158.698 60.9777C158.846 61.0462 158.998 61.1906 159.142 61.3009C159.226 61.3617 159.321 61.4454 159.344 61.5556C159.389 61.7837 159.552 61.9168 159.716 62.0802C160.186 62.5478 160.631 62.8824 161.082 63.023C161.785 63.2359 162.005 64.0799 162.389 64.1977C162.742 64.308 163.095 64.7109 163.444 64.9808C163.718 65.1937 163.987 65.4751 164.26 65.726C164.409 66.0301 164.652 66.2468 164.872 66.4825C165.248 66.8893 165.745 67.9575 165.24 67.8131C164.876 67.7066 164.625 67.5317 164.576 67.8929C164.553 68.0564 164.625 68.7559 164.002 68.4403C163.262 68.0678 163.152 68.3567 162.992 68.3035C162.32 68.0792 161.944 68.3909 161.523 68.657C161.477 68.6836 161.424 68.714 161.36 68.695C160.657 68.4935 160.589 69.0638 159.97 68.7521C159.636 68.5848 159.325 68.524 159.021 68.4821C158.599 68.4251 158.55 68.5544 158.713 69.1208C159.006 70.1282 158.28 69.7519 158.026 70.0104C157.867 70.1739 158.007 70.5084 158.25 70.5008C158.368 70.5008 158.501 70.5312 158.558 70.6947C158.592 70.7935 158.565 70.8772 158.497 70.8696C158.284 70.8505 158.212 71.014 158.117 71.1699C157.988 71.3752 157.745 71.3029 157.517 71.014C157.381 70.8429 157.267 70.6757 157.084 70.6148C156.86 70.5426 156.781 70.3221 156.815 70.1472C156.872 69.8621 156.841 69.539 156.834 69.2311C156.826 68.9345 157.308 68.5544 156.708 68.3111C155.573 67.8473 154.78 66.9197 154.632 66.5433C154.518 66.0149 154.632 65.3268 155.057 65.342C155.133 65.342 155.201 65.3192 155.262 65.2888C155.721 65.0721 155.528 65.1177 154.704 64.0381C154.351 63.5743 155.045 63.4678 154.548 62.8748C154.415 62.7151 154.529 62.62 154.571 62.5212C154.78 62.0042 154.039 61.7077 153.508 61.7153C153.014 61.7229 152.498 61.6735 151.913 61.3655C151.727 61.2667 151.545 61.2401 151.404 61.2971C151.085 61.4225 150.709 61.4606 150.52 61.8255C150.406 62.046 150.045 62.0004 149.396 61.8787C149.255 61.8521 149.202 61.8749 149.297 62.0992C149.612 62.8558 149.532 63.2435 149.046 63.4412C148.758 63.559 148.538 64.1407 147.361 63.1941C147.152 63.0268 146.947 62.8596 146.825 62.5516C146.7 62.2323 146.442 62.027 146.252 61.7609C146.123 61.5784 145.971 61.5898 145.952 61.7609C145.891 62.2551 145.2 62.6657 145.071 63.2283C145.018 63.4602 144.714 63.4146 144.695 63.7111C144.479 63.6959 144.464 63.905 144.441 64.1065C144.414 64.1407 144.391 64.1749 144.365 64.2091C144.198 64.2737 144.205 64.4866 144.202 64.6767C144.194 64.9314 144.061 65.0265 143.932 65.1671C143.602 65.5169 143.093 65.5055 142.732 65.8058C142.539 65.9655 141.961 65.5093 141.791 66.2126C141.737 66.4369 141.601 66.5661 141.396 66.6041C140.758 66.7258 140.583 67.182 140.864 68.0373C140.932 68.2464 141.081 68.4365 140.819 68.5125C140.731 68.5392 140.758 68.6532 140.811 68.7521C140.925 68.9535 141.001 69.174 141.175 69.3451C141.403 69.5694 141.388 69.7025 141.183 69.8697C141.16 69.8887 141.119 69.8849 141.103 69.9115C140.644 70.8277 139.702 69.6911 139.497 70.3944C139.41 70.6947 139.345 70.9684 139.14 71.2003C139.015 71.341 139.076 71.7287 138.894 71.9226C138.818 72.0024 138.867 72.1849 138.939 72.3142C139.239 72.8616 139.444 73.1771 139.706 72.8996C139.862 72.7361 140.116 72.7856 140.245 72.5537C140.401 72.2723 140.803 72.7628 141.031 72.8464C141.684 73.0859 141.065 72.1507 141.589 72.3066C142.026 72.4358 142.417 72.2724 142.842 72.3446C143.063 72.3826 143.279 72.3826 143.499 72.4738C143.643 72.5309 143.792 72.5689 143.86 72.3902C143.989 72.0443 143.681 71.8618 142.747 70.4856C142.428 70.0142 142.151 69.5048 141.772 69.1018C141.692 69.0182 141.65 68.9041 141.631 68.7863C142.246 68.8281 142.823 69.079 143.378 69.596C144.653 70.7859 145.846 69.9686 148.484 70.7137C148.788 70.7973 149.058 70.9836 149.263 71.3486C149.57 71.9074 150.223 71.493 150.941 72.6753C150.793 72.8008 150.671 72.6335 150.546 72.5461C149.658 71.934 148.762 71.474 147.839 71.4436C147.763 71.4436 147.687 71.4246 147.615 71.436C147.433 71.4664 147.288 71.5766 147.292 71.8238C147.292 72.0557 147.482 72.1279 147.623 72.2495C147.942 72.5309 148.257 72.6677 148.595 72.6297C148.31 72.8654 147.926 72.6069 147.558 72.6525C147.904 73.1049 147.96 73.5041 147.729 73.8614C147.535 73.774 147.573 73.1657 147.22 73.4661C146.947 73.698 146.651 73.7968 146.26 73.6561C146.085 73.5915 145.876 73.5877 146.066 73.9603C146.18 74.1884 145.895 74.2872 145.747 74.1123C144.855 73.0403 144.832 72.9376 144.672 73.4356C144.494 73.9831 144.327 73.9869 144.802 74.2644C145.519 74.6788 146.214 75.2072 146.966 75.4619C147.076 75.4999 147.19 75.5683 147.292 75.5721C147.862 75.5912 148.086 76.5187 148.758 76.553C148.929 76.5606 149.107 76.6024 149.157 76.3515C149.206 76.1044 149.111 75.8116 148.898 75.6178C148.735 75.4733 148.553 75.3669 148.416 75.1464C148.731 75.0969 149.453 75.3478 149.715 75.5912C150.193 76.0435 150.242 75.9067 152.016 76.8989C152.551 77.1992 153.018 78.4614 152.388 78.5602C152.281 78.5754 152.171 78.5944 152.205 78.7769C152.293 79.2331 152.657 78.8111 153.557 79.1495C153.618 79.1723 153.717 79.1761 153.736 79.2179C154.039 79.9098 154.556 79.7273 154.962 79.9896C155.11 80.0847 155.216 80.1455 155.266 80.3508C155.296 80.4838 155.334 80.6397 155.414 80.7385C156.002 81.4799 156.279 82.4303 156.807 83.202C157.221 83.8064 156.769 84.1182 156.765 84.4223C156.762 84.6542 156.769 84.8519 157.012 85.0154C157.369 85.2549 157.662 85.6882 158.091 85.7377C158.208 85.7491 158.387 85.9087 158.455 86.0494C158.675 86.4942 158.956 86.4676 159.241 86.4562C159.64 86.9352 159.993 87.4978 160.494 87.7905C160.9 88.03 161.132 88.4406 161.36 88.8778C161.546 89.2313 161.58 89.5849 161.515 89.9384C161.477 90.1513 161.458 90.387 161.375 90.5657C161.136 91.0751 161.098 91.7024 160.923 92.2574C160.722 92.8885 160.802 93.5652 161.014 94.2457C161.022 94.3635 161.056 94.4548 161.162 94.4852C161.177 94.508 161.193 94.5308 161.212 94.5498C161.219 94.5764 161.234 94.5954 161.257 94.603C161.299 94.6258 161.341 94.6486 161.379 94.6676C161.447 94.9109 161.606 95.0288 161.777 95.0706C162.176 95.1733 162.567 95.1847 162.939 95.1238C162.958 95.0174 162.916 94.9566 162.878 94.9528C162.26 94.8501 162.229 94.2039 162.127 93.7363C162.78 92.4247 162.92 92.3144 162.78 91.7366C162.635 91.1321 162.962 90.3452 163.395 90.2007C163.767 90.0753 164.078 90.9421 164.507 90.3528C164.724 90.0525 165.05 90.0373 165.377 90.0297C165.529 90.1361 165.677 90.2882 165.84 90.1817C166.034 90.2008 166.098 90.1932 166.785 90.387C167.051 90.4631 167.116 90.5657 167.12 90.904C167.12 90.9763 167.101 91.0447 167.104 91.1169C167.116 91.3336 167.245 91.4857 167.37 91.3945C167.776 91.0941 168.471 91.8849 168.722 91.3602C168.809 91.3488 168.87 91.3032 168.874 91.1854C168.912 91.174 168.95 91.1664 168.988 91.155C169.102 91.2728 169.208 91.2956 169.299 91.1816C169.299 91.1816 169.299 91.1816 169.303 91.1854C169.508 91.1854 169.572 91.212 169.641 91.1207C169.868 91.1055 169.846 91.0751 170.578 91.2196C170.647 91.2614 170.719 91.3032 170.787 91.3412C171.737 92.4589 171.68 91.8697 172.879 93.1622C172.986 93.3561 172.989 93.5614 173.001 93.7629C172.864 94.3255 172.876 94.8387 173.225 95.3748C173.441 95.7055 173.445 96.1085 173.502 96.4848C173.422 96.884 173.825 97.6329 173.468 98.2412C173.403 98.2792 173.343 98.3362 173.346 98.435C173.369 99.1612 172.921 99.4159 172.879 99.6364C172.716 100.492 172.093 100.682 171.554 101.005C171.19 101.225 170.442 100.655 169.698 100.412C168.555 100.036 169.504 98.7012 168.031 98.2564C167.499 98.0967 166.96 97.8572 166.406 97.918C166.246 97.937 166.049 97.8572 165.973 98.0929C165.715 98.8912 166.527 98.6327 166.512 99.9139C166.512 100.172 166.66 100.389 166.706 100.636C166.808 101.187 167.021 101.704 167.089 102.263C167.116 102.461 167.199 102.613 167.302 102.773C167.457 103.016 167.366 103.278 167.139 103.225C166.615 103.107 166.083 103.313 165.555 103.077C165.248 102.94 164.914 103.016 164.591 103.024C164.492 103.024 164.416 103.088 164.378 103.214C164.139 103.286 164.154 103.324 164.101 103.594C163.323 103.563 162.977 104.259 163.429 104.723C163.55 104.848 163.645 105 163.755 105.137C163.778 105.833 163.668 106.251 163.812 106.871C164.124 108.205 162.954 108.996 162.586 109.441C161.747 110.46 160.957 108.186 159.632 109.49C159.127 109.988 159.055 110.254 158.77 109.973C158.504 109.714 158.375 109.273 158.026 109.118C157.912 109.068 157.946 108.832 157.931 108.673C157.783 107.103 156.564 108.239 155.213 106.544C155.045 106.335 154.802 106.221 154.594 106.551C154.32 106.791 154.423 107.198 154.324 107.513C154.218 107.491 154.108 107.464 154.001 107.441L153.975 107.422C153.868 107.262 153.937 107.065 153.906 106.89C153.857 106.609 153.606 106.639 153.568 106.844C153.538 107.031 153.458 107.183 153.39 107.35C153.299 107.312 153.208 107.312 153.117 107.342C152.604 107.392 152.502 107.49 152.41 108.027C152.179 108.35 151.886 108.361 151.594 108.274C150.337 107.897 150.398 109.156 149.54 108.566C149.426 108.487 149.316 108.399 149.202 108.315C149.16 107.855 149.149 107.833 148.872 108.008C148.625 108.163 148.348 107.989 148.116 108.198C147.896 108.232 147.824 108.448 147.816 108.73C147.774 108.76 147.736 108.794 147.695 108.825C147.471 108.897 147.319 108.707 147.152 108.582C147.125 108.388 147.152 108.141 146.916 108.137C146.7 108.137 146.651 108.68 147.019 108.76C147.049 108.768 147.083 108.772 147.114 108.779C147.114 108.848 147.114 108.92 147.11 108.988C146.525 109.273 146.13 109.878 145.69 110.406C145.458 110.395 145.306 110.536 145.139 110.76C144.653 111.41 143.708 113.265 142.565 112.775C141.76 112.429 141.122 112.775 139.406 114.208C139.023 114.527 138.666 114.858 138.727 115.523C138.749 115.774 138.613 115.964 138.521 116.17C138.404 116.31 138.351 116.538 138.161 116.58C138.092 116.614 138.039 116.671 138.005 116.755C137.603 116.842 137.333 117.158 137.143 117.591C136.919 118.101 136.661 118.587 136.483 119.123C135.966 119.659 135.545 119.431 134.341 120.097C134.17 120.192 134.007 120.313 133.821 120.363C133.179 120.522 133.639 121.423 132.557 121.427C132.522 121.427 132.488 121.446 132.458 121.454C132.222 121.431 132.025 121.53 131.869 121.762C131.653 121.785 131.436 121.781 131.235 121.921C130.878 121.94 130.518 121.982 130.161 121.906C129.948 121.861 129.747 121.929 129.565 122.062C127.848 123.305 128.604 123.123 127.237 124.092C126.671 124.491 126.109 123.742 125.825 124.944C125.32 126.156 125.248 127.343 125.87 128.491L125.832 128.483ZM141.608 68.7711C141.551 68.7635 141.494 68.7597 141.441 68.7445C141.384 68.7292 141.297 68.6912 141.308 68.6152C141.324 68.5011 141.418 68.5468 141.483 68.6038C141.532 68.6456 141.567 68.714 141.608 68.7711ZM158.766 78.047C158.801 78.3853 158.185 77.8911 157.438 77.9558C157.172 77.9786 156.887 77.9443 156.595 77.7505C156.515 77.6288 156.431 77.511 156.352 77.3893C156.329 77.1308 156.439 77.0244 156.636 77.1232C157.02 77.3133 157.384 77.3171 157.753 77.4007C158.056 77.4692 158.349 77.663 158.641 77.8645C158.702 77.9063 158.759 77.9672 158.766 78.0432V78.047ZM160.035 78.9252C160.365 78.9366 160.278 79.1723 160.809 79.4004C160.923 79.4498 161.037 79.5638 161.151 79.6551C161.356 79.8223 161.322 80.0124 161.166 80.0352C160.661 80.1113 160.429 79.7615 160.08 79.6703H160.054C159.947 79.5676 159.833 79.522 159.719 79.5106C159.328 79.1419 158.869 79.0582 158.485 78.6629C158.482 78.6933 158.463 78.7541 158.463 78.7541C158.463 78.7351 158.478 78.6933 158.485 78.6629C158.573 78.1839 159.211 78.891 160.038 78.9214L160.035 78.9252ZM161.728 76.686C161.158 76.9787 161.045 76.743 161.257 77.6706C161.303 77.8645 161.272 77.9444 161.124 77.9139C160.562 77.7923 161.003 78.5716 160.718 78.5754C160.559 78.5754 160.331 78.3929 160.205 77.9177C160.145 77.682 160.031 77.4882 159.871 77.3095C159.746 77.2144 159.621 77.1232 159.495 77.0282C159.344 77.0852 159.211 77.1992 159.013 77.1498C158.785 76.6822 158.926 76.4351 159.138 76.226C159.252 76.112 159.355 75.9865 159.533 75.9979C159.7 76.0093 159.761 76.2146 159.871 76.3363C160.076 76.5606 160.372 76.5187 160.304 76.2716C160.228 75.9941 160.331 76.0207 160.464 76.0397C160.866 76.0968 161.405 76.2412 161.724 76.6898L161.728 76.686ZM162.172 76.8647C162.157 76.4579 162.157 76.4579 162.449 76.5149C162.795 76.5834 163.156 76.7887 163.49 76.9825C163.733 77.1232 164.025 77.4539 164.093 77.8493C164.017 77.8493 163.964 77.8835 164.01 77.9976C164.333 78.8567 164.5 79.0354 164.541 79.8604C164.564 80.3014 164.317 80.461 164.014 80.2557C163.657 80.0124 163.304 79.3624 163.387 79.0012C163.497 78.5222 163.296 78.0888 162.992 77.6288C162.844 77.2905 162.62 77.2677 162.408 77.2068C162.328 77.0928 162.252 76.9787 162.172 76.8609V76.8647ZM166.318 76.6366C166.318 76.6366 166.318 76.667 166.311 76.6708C166.258 76.6746 166.212 76.629 166.167 76.572C165.961 76.5378 165.749 76.4655 165.597 76.5834C165.51 76.6518 165.373 76.6062 165.236 76.5226C165.008 76.3781 164.777 76.2754 164.545 76.1006C164.344 75.9447 164.131 75.7698 163.923 75.7166C163.9 75.8421 164.074 76.0207 163.964 76.0664C163.63 76.2108 163.372 76.5187 162.814 76.15C162.529 75.9599 162.168 75.747 161.929 75.9865C161.861 76.055 161.77 75.9219 161.728 75.804C161.614 75.4847 161.747 75.2946 161.774 75.0551C161.793 74.8879 161.963 74.9715 162.085 74.9867C162.647 75.0589 162.381 74.4317 162.704 74.4393C163.323 74.4545 163.964 74.7928 164.606 75.3022C165.335 75.8801 165.817 75.8991 166.174 76.5606C166.223 76.5834 166.273 76.61 166.326 76.6328L166.318 76.6366ZM148.428 59.1188C148.428 59.1188 148.188 59.191 148.158 59.3583C148.211 59.4191 148.264 59.4761 148.317 59.5369C148.264 59.4761 148.211 59.4191 148.162 59.3583C148.192 59.191 148.431 59.1188 148.431 59.1188H148.428ZM149.403 57.6247C149.403 57.716 149.396 57.8072 149.392 57.8985C149.21 57.868 149.012 57.7616 148.826 57.735C148.659 57.7122 148.473 57.6932 148.257 57.4118C148.469 57.3358 148.735 57.4917 148.876 57.3206C149.081 57.0659 149.13 57.1077 149.407 57.6247H149.403ZM149.87 58.9591C149.912 59.1378 149.787 59.0655 149.578 59.0275C149.487 59.0047 149.441 58.9971 149.35 58.9743C149.297 58.9325 149.225 58.8907 149.244 58.8146C149.32 58.5105 149.783 58.5713 149.87 58.9553V58.9591ZM153.026 56.2713C152.896 56.2105 152.786 56.1991 152.634 56.1763C152.608 55.876 152.805 55.9862 152.915 55.9672C153.139 55.9292 153.227 56.3626 153.026 56.2713ZM158.516 60.5216C158.516 60.571 158.516 60.609 158.512 60.6432C158.474 60.8333 158.037 60.7078 157.95 60.4835C157.905 60.3695 158.083 60.2783 158.242 60.3353C158.315 60.3619 158.394 60.3885 158.516 60.5216Z",
    fill: "#09363F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M147.718 60.0763C147.718 60.0763 147.835 60.0158 147.891 59.9856C147.835 60.0196 147.718 60.0763 147.718 60.0763Z",
    fill: "url(#paint1_linear_35_119664)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M153.28 54.1233C153.359 54.146 153.397 54.1573 153.473 54.18C153.409 54.1611 153.344 54.1422 153.28 54.1233Z",
    fill: "url(#paint2_linear_35_119664)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M156.264 55.1911C156.022 55.0398 156.044 55.055 156.264 55.1911V55.1911Z",
    fill: "url(#paint3_linear_35_119664)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M173.198 102.115C173.198 102.115 173.187 102.1 173.176 102.088C173.183 102.1 173.198 102.115 173.198 102.115Z",
    fill: "url(#paint4_linear_35_119664)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M149.141 156.467C149.141 156.467 149.122 156.44 149.111 156.429L149.141 156.467Z",
    fill: "url(#paint5_linear_35_119664)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M144.293 165.351C144.327 165.248 144.331 165.237 144.293 165.351V165.351Z",
    fill: "url(#paint6_linear_35_119664)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M140.519 151.627C140.625 151.494 140.64 151.475 140.519 151.627V151.627Z",
    fill: "url(#paint7_linear_35_119664)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M166.429 61.6659C166.717 61.6203 167.036 61.9815 167.105 61.761C167.021 61.6431 166.911 61.4873 166.953 61.4721C167.051 61.4378 166.998 61.2516 167.078 61.2097C166.945 60.9702 166.691 60.7649 166.512 60.5407C166.444 60.5064 166.372 60.4418 166.3 60.3354C166.288 60.3278 166.273 60.3164 166.269 60.3088C166.243 60.2707 166.246 60.2669 166.277 60.2897C166.569 60.3772 166.911 60.5673 167.401 60.9969C167.712 61.339 167.921 61.5101 167.94 61.4112C167.951 61.3504 167.989 61.4112 168.084 61.5025C168.414 61.818 168.373 61.856 168.43 62.183C168.506 62.3008 168.616 62.4795 168.661 62.4148C168.692 62.3692 168.851 62.4415 168.661 62.1791C168.631 62.1373 168.627 62.1107 168.654 62.1221C168.771 62.1792 169.428 62.3654 169.572 62.6391C169.683 62.8482 169.804 62.8863 169.918 62.9927C169.815 62.8292 170.036 62.9813 170.218 63.0649C170.461 63.179 170.761 63.3957 171.194 63.8062C170.955 63.4565 170.989 63.4223 171.319 63.696C171.418 63.7758 171.57 63.9241 171.532 63.8367C171.585 63.8024 171.794 63.9469 171.908 63.9925C171.953 64.0115 172.002 64.0381 172.052 64.0686C172.58 64.7148 172.838 65.0456 173.343 65.7108C173.328 65.6994 173.312 65.6918 173.297 65.6804C173.316 65.6956 173.335 65.7109 173.354 65.7261C173.487 65.9047 173.555 65.9922 173.688 66.1708C173.559 66.0872 173.335 65.9313 172.974 65.6842C172.902 65.6348 172.819 65.5702 172.716 65.4599C172.682 65.4371 172.648 65.4105 172.614 65.3877C172.348 65.2547 171.946 64.9429 171.657 64.7947C171.566 64.7414 171.471 64.6882 171.38 64.6388C171.528 64.7871 171.619 64.8327 171.721 64.9011C172.143 65.1824 173.388 65.9884 173.852 66.3913C173.928 66.494 173.965 66.5434 174.038 66.646C174.026 66.646 174.015 66.6461 174.003 66.6422C173.772 66.5966 173.757 66.5548 172.564 65.8059C172.709 66.0568 172.712 66.167 172.447 66.0036C171.873 65.65 171.3 65.3155 170.647 64.8555C170.613 64.8327 170.575 64.8137 170.541 64.7909C170.385 64.73 170.127 64.4563 169.96 64.3689C169.77 64.2738 169.55 64.1066 169.303 63.8899C168.555 63.2284 168.316 63.4451 168.171 63.3691C166.649 62.5897 166.634 62.5935 166.524 62.4034C166.41 62.2134 166.573 62.297 166.622 62.2704C166.63 62.2704 166.603 62.2286 166.577 62.1639C166.387 62.0689 166.193 61.9511 166.068 61.9587C165.988 61.9625 165.897 61.875 165.795 61.742C165.449 61.2782 166.208 61.7039 166.429 61.6697V61.6659Z",
    fill: "#09363F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M168.501 62.7943C168.423 62.6809 168.423 62.6809 168.501 62.7943L168.52 62.8094C168.52 62.8094 168.509 62.8019 168.501 62.7943Z",
    fill: "url(#paint8_linear_35_119664)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.737 63.0799C168.681 63.0446 168.681 63.0446 168.737 63.0799V63.0799Z",
    fill: "url(#paint9_linear_35_119664)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M158.056 99.2105C158.318 99.2827 158.58 99.2789 158.839 99.2371C158.93 99.2523 159.025 99.2675 159.116 99.2827C159.237 99.4196 159.363 99.412 159.435 99.2485C159.795 98.4312 160.817 98.5452 160.752 97.6784C160.783 97.6708 160.813 97.6594 160.843 97.6518C161.094 97.7013 161.246 97.515 161.394 97.3211C161.61 97.3401 161.793 97.3629 161.971 97.6366C162.237 98.0282 163.027 98.0548 163.353 97.7583C163.543 97.5834 163.699 97.3705 163.999 97.5226C164.139 97.5948 164.226 97.3819 164.154 97.1804C163.964 96.652 162.787 96.3783 162.343 96.3327C162.081 96.3061 161.819 96.3099 161.553 96.2947C161.413 96.2871 161.261 96.2642 161.151 96.3631C160.703 96.7585 160.114 96.6064 159.613 96.8003C159.59 96.8079 159.556 96.7775 159.503 96.7508C159.53 96.5646 159.67 96.5722 159.765 96.5113C160.186 96.23 160.38 95.6408 160.24 95.0705C160.232 94.9603 160.221 94.8462 160.213 94.736C160.346 94.5915 160.3 94.4281 160.205 94.257C160.243 94.2114 160.281 94.1696 160.319 94.1239C160.319 94.1239 160.323 94.1201 160.327 94.1163C160.384 93.9947 160.327 93.8996 160.259 93.8046C160.042 93.9301 159.822 94.0555 159.606 94.181C159.826 94.0555 160.042 93.9301 160.259 93.8046C160.186 93.2648 159.849 93.7894 159.476 93.7438C159.344 93.7286 159.158 93.6677 159.15 93.9148C159.142 94.1658 159.34 94.1429 159.465 94.2C159.461 94.2684 159.457 94.333 159.454 94.4015C159.165 94.5725 159.245 94.8957 159.214 95.1922C159.07 95.2796 159.013 95.4355 158.99 95.637C158.926 96.1692 158.937 96.1274 158.349 95.8195C158.33 95.7016 158.311 95.5838 158.292 95.4659C158.383 95.4507 158.474 95.4165 158.565 95.4203C158.732 95.4279 158.831 95.3481 158.861 95.1466C158.869 95.0895 158.896 95.0363 158.896 94.9793C158.899 94.7816 159.093 94.6676 159.017 94.4471C158.953 94.257 158.766 94.2798 158.649 94.162C158.159 93.6715 157.772 94.6752 158.212 94.6448C158.288 94.641 158.364 94.5991 158.436 94.7512C158.406 95.0021 158.178 95.1466 158.178 95.4393C157.973 95.561 157.848 95.8575 157.532 95.751C157.373 95.6978 157.327 95.9677 157.373 96.1274C157.407 96.2452 157.536 96.1844 157.616 96.1274C157.882 96.4036 157.944 96.7331 157.802 97.1158C158.269 97.1006 158.721 97.0854 159.23 97.0702C158.755 98.4844 157.794 97.6784 157.764 98.4274C157.445 98.4046 157.13 98.3817 156.91 98.7391C156.864 98.8113 156.765 98.8455 156.788 98.9634C156.83 99.1611 157.054 99.1231 157.214 99.1193C157.495 99.2979 157.779 99.2713 158.064 99.2257L158.056 99.2105Z",
    fill: "url(#paint10_linear_35_119664)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4027 127.301C64.4482 127.453 64.4748 127.612 64.6267 127.749C64.7937 127.905 64.7672 127.666 64.8887 127.719C65.0102 127.841 64.976 127.924 64.9874 128.015C65.0253 128.244 65.0102 128.456 65.2835 128.711C65.3253 128.753 65.3633 128.833 65.386 128.894C65.7126 129.711 66.2707 130.513 66.6998 131.319C67.125 132.117 67.6718 132.904 68.0742 133.699C68.2679 134.079 68.5337 134.444 68.7994 134.809C68.9361 134.999 69.0918 135.178 69.2285 135.121C69.2589 135.136 69.2892 135.151 69.3196 135.166C69.3576 135.197 69.3955 135.227 69.4335 135.257C69.5968 135.345 70.0372 135.805 70.4701 135.626C71.0738 135.619 70.4055 134.509 70.4777 133.923C70.5156 133.615 70.265 133.212 69.9651 132.878C69.6727 132.558 69.4943 132.197 69.2513 131.866C69.1184 131.68 69.0804 131.479 69.0918 131.323C69.145 130.559 69.0007 130.064 68.4539 129.152C68.3704 129.015 68.2831 128.996 68.1881 128.935C67.5389 128.513 66.6238 128.126 65.8113 127.027C65.7619 126.719 65.6215 126.476 65.3139 126.308C65.1962 126.244 65.0785 126.118 64.9608 126.02C64.9038 125.848 64.8811 125.681 64.7823 125.503C64.6191 125.217 64.4482 125.149 64.3571 125.331C64.228 125.586 64.171 125.883 64.3267 126.301C64.3229 126.582 64.4178 126.917 64.3837 127.175C64.3799 127.209 64.3913 127.259 64.4065 127.305L64.4027 127.301ZM65.7961 128.513C65.8341 128.483 65.9062 128.415 65.9062 128.415C65.9062 128.415 65.8341 128.479 65.7961 128.513C65.8239 128.602 65.8239 128.602 65.7961 128.513Z",
    fill: "url(#paint11_linear_35_119664)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M106.658 68.1096C106.446 68.2655 106.225 68.2617 106.009 68.2883C105.158 68.3947 104.991 67.8055 104.498 67.9423C104.091 68.0526 103.932 67.7941 103.811 67.4215C103.735 67.1896 103.822 66.9729 103.89 66.7562C104.179 65.84 103.085 66.3305 103.799 65.5093C104.221 65.0227 104.68 65.0835 105.124 65.0227C105.47 64.9771 105.792 65.0341 105.8 65.5853C105.808 66.0187 106.643 65.4941 106.727 65.9085C106.772 66.1366 106.776 66.3913 106.616 66.627C106.525 66.76 106.328 66.8133 106.351 67.0338C106.37 67.2314 106.518 67.3113 106.609 67.4443C106.647 67.4975 106.704 67.5204 106.746 67.5698C106.916 67.7637 106.886 67.9423 106.654 68.1134L106.658 68.1096Z",
    fill: "#09363F"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M162.362 56.701C162.127 56.4843 162.016 56.4881 161.868 56.4159C161.773 56.3703 161.728 56.4083 161.781 56.5185C161.872 56.6972 161.868 56.8036 161.99 57.0013C162.085 57.104 162.161 57.1572 162.214 57.1686C162.278 57.2826 162.354 57.3739 162.453 57.4347C163.531 58.081 163.717 58.2445 163.63 58.0164C163.577 57.8757 163.661 57.9137 163.774 57.9859C163.926 58.081 164.071 58.1646 164.226 58.2673C164.572 58.4954 164.762 58.503 165.027 58.6246C165.157 58.6854 165.24 58.674 165.119 58.4535C164.974 58.2977 164.876 58.2407 164.803 58.214C164.617 58.1456 164.374 58.0049 164.268 58.0582C164.226 58.0772 164.15 58.043 164.01 57.8339C163.991 57.8035 163.926 57.735 163.904 57.7198C163.634 57.5336 163.281 57.1762 163.057 57.0812C162.882 57.0051 162.601 56.7618 162.499 56.8112C162.487 56.8188 162.411 56.7542 162.362 56.7086V56.701ZM163.277 57.3397C163.342 57.3815 163.364 57.3511 163.482 57.4689C163.44 57.4841 163.353 57.4043 163.277 57.3397ZM163.231 57.3017C163.243 57.3169 163.254 57.3321 163.266 57.3435C163.311 57.3853 163.319 57.4005 163.285 57.3777C163.277 57.3701 163.25 57.3283 163.231 57.3017Z",
    fill: "#09363F"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.5 100.974C156.181 100.765 155.87 100.952 155.558 100.838C154.784 100.549 154.886 101.834 154.552 101.104C154.469 100.925 154.396 100.659 154.214 100.697C153.739 100.796 153.261 100.404 152.79 100.674C152.441 100.876 152.13 100.172 152.646 100.035C153.212 99.8872 153.823 98.8836 154.696 99.1763C155.543 99.4614 155.38 99.0166 155.858 99.1003C155.957 99.1193 156.063 99.1459 156.09 99.2827C156.116 99.4006 156.025 99.4424 155.964 99.507C155.718 99.7846 155.718 99.7846 155.972 100.191C155.828 100.241 155.657 100.115 155.646 100.313C155.634 100.541 155.801 100.533 155.93 100.522C156.124 100.503 156.39 100.408 156.781 100.389C156.902 100.381 157.043 100.488 156.952 100.648C156.849 100.83 156.637 101.07 156.488 100.974H156.5Z",
    fill: "url(#paint12_linear_35_119664)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0107 66.186C70.3676 65.9388 70.922 65.5511 71.3245 65.2241C71.446 65.1253 71.5485 65.0607 71.6966 64.9048C71.7497 64.8478 71.8143 64.7832 71.8484 64.7679C72.0497 64.6729 72.418 64.2889 72.6799 64.0951C72.7863 64.0152 72.9267 63.8708 73.0103 63.7415C73.2305 63.4146 72.5053 64.0989 72.8432 63.6161C72.9647 63.4412 72.8204 63.5552 72.7217 63.6275C72.7141 63.6275 72.7027 63.6275 72.6913 63.6313C72.7293 63.5704 72.7217 63.5552 72.6572 63.6009C72.6268 63.6123 72.6002 63.6275 72.5698 63.6389C72.704 63.4336 72.7015 63.3778 72.5622 63.4716C72.5622 63.4716 72.5319 63.4792 72.5205 63.4868C72.5243 63.4754 72.5205 63.4792 72.4977 63.4982C72.4445 63.5362 72.3876 63.5704 72.3344 63.6085C71.9927 63.7301 72.342 63.3956 72.118 63.5248C71.7307 63.9924 71.5371 64.2281 71.1612 64.7071C71.1916 64.7185 71.2257 64.7337 71.2637 64.7451C71.389 64.7794 70.8802 65.2888 70.3221 65.7906C70.2006 65.9502 70.1398 66.0301 70.0221 66.1898L70.0107 66.186ZM72.2357 63.886C72.2395 63.8442 72.3952 63.6655 72.3952 63.6655C72.3952 63.6655 72.2433 63.8442 72.2357 63.886Z",
    fill: "#09363F"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M168.718 60.8067C168.43 60.6318 167.94 60.2212 167.499 59.8715C167.446 59.8297 167.37 59.7613 167.313 59.689C167.222 59.575 167.158 59.5217 167.063 59.4343C166.907 59.2936 166.672 59.0542 166.584 58.9401C166.455 58.7652 166.683 58.9667 166.736 58.9819C166.751 58.9857 166.808 59.0351 166.846 59.0618C166.941 59.1226 167.066 59.2252 167.203 59.3393C168.399 60.3429 168.187 60.1452 168.604 60.6128C168.764 60.7928 168.802 60.8574 168.718 60.8067Z",
    fill: "#09363F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M159.587 54.7431C159.484 54.7127 159.363 54.6405 159.211 54.4922C159.157 54.4428 159.101 54.3896 159.07 54.325C159.032 54.2413 159.078 54.2527 159.131 54.2793C159.773 54.6215 159.883 54.7621 159.792 54.5759C159.67 54.3326 159.59 54.4314 159.438 54.2717C159.731 54.2527 160.179 54.5264 160.581 54.7355C160.722 54.7774 160.9 54.8876 161.09 55.0093C161.261 55.1195 161.344 55.2449 161.398 55.3818C161.409 55.3932 161.42 55.4008 161.432 55.4122C161.443 55.4236 161.458 55.4502 161.458 55.4502C160.524 55.4084 160.103 54.8914 159.594 54.7393L159.587 54.7431Z",
    fill: "#09363F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M159.029 93.4093C158.865 93.7552 158.398 93.1318 158.634 92.8809C159.066 92.4247 160.152 91.9989 160.069 92.7744C159.989 93.5347 159.366 92.6794 159.025 93.4093H159.029Z",
    fill: "url(#paint13_linear_35_119664)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M162.742 58.5218C162.712 58.5218 162.666 58.4951 162.628 58.4837C162.355 58.2366 162.347 58.2328 162.419 58.4267C162.457 58.5332 162.438 58.5978 162.537 58.7499C162.671 59.0286 162.853 59.2352 163.084 59.3695C163.209 59.4646 163.338 59.5786 163.448 59.628C163.573 59.7269 163.695 59.8219 163.82 59.9208C164.128 60.1146 164.371 60.2325 164.504 60.1374C164.872 59.8713 165.35 60.4568 165.639 60.3085C165.715 60.2021 165.145 59.7079 165.073 59.8447C164.955 59.7915 164.656 59.7307 164.523 59.533C164.344 59.2669 164.891 59.6584 164.823 59.495C164.788 59.4151 164.716 59.3733 164.652 59.3087C164.295 58.9551 164.021 58.7879 163.763 58.6548C163.672 58.6092 163.589 58.575 163.497 58.537C163.053 58.172 162.666 57.9021 162.415 57.9211C162.358 57.9249 162.294 57.9173 162.377 58.0656C162.453 58.2024 162.544 58.3051 162.651 58.3507C162.651 58.3203 162.647 58.2899 162.643 58.2594C162.658 58.2671 162.685 58.267 162.685 58.267C162.685 58.267 162.662 58.2671 162.643 58.2594C162.643 58.2899 162.647 58.3203 162.651 58.3507C162.727 58.4267 162.825 58.5142 162.738 58.5104L162.742 58.5218Z",
    fill: "#09363F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5645 64.3231C73.6063 64.3916 73.4658 64.6159 73.238 64.7641C73.1696 64.8059 73.1089 64.8401 73.0443 64.8782C73.0443 64.882 73.0405 64.8858 73.0367 64.8896C72.9456 64.9352 72.8279 65.0188 72.771 65.0226C72.6836 65.0264 72.4558 65.1633 72.5621 64.9922C72.6988 64.7717 72.8962 64.6881 73.0671 64.5474C73.238 64.4068 73.5189 64.2395 73.5683 64.3269L73.5645 64.3231Z",
    fill: "#09363F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M158.007 62.9507C158.098 63.0686 158.091 63.1408 158.011 63.156C157.707 63.2168 157.187 62.8709 156.811 62.3387C157.084 62.2817 157.419 62.4907 157.737 62.6618C157.821 62.7074 157.924 62.8443 158.003 62.9469L158.007 62.9507Z",
    fill: "#09363F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M159.511 100.526C159.636 100.537 159.788 100.526 159.833 100.716C159.887 100.936 159.735 101.028 159.617 101.111C159.253 101.366 158.865 101.298 158.474 101.184C158.307 101.134 158.318 100.868 158.436 100.822C158.873 100.651 158.842 100.457 159.515 100.526H159.511Z",
    fill: "url(#paint14_linear_35_119664)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M147.087 70.7174C147.137 70.7136 147.209 70.763 147.273 70.9151C147.045 70.9645 146.867 71.1546 146.658 71.2154C146.43 71.2801 145.698 71.5804 145.572 71.2458C145.53 71.1318 145.584 71.0786 145.644 71.0292C146.054 70.6946 146.594 70.7706 147.087 70.7136V70.7174Z",
    fill: "url(#paint15_linear_35_119664)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9116 48.1472C96.904 48.0217 96.6762 48.2726 96.699 48.1016C96.7141 47.9989 96.8242 47.9267 96.8698 47.8316C96.9533 47.71 97.0141 47.5769 96.9154 47.5845C96.5205 47.615 96.3876 47.6111 95.427 48.284C94.9828 48.5958 95.1536 48.0407 94.8005 48.3601C94.7853 48.4057 94.7625 48.4931 94.7625 48.4931C94.7625 48.4931 94.7891 48.4057 94.8005 48.3601C94.6373 48.3296 94.417 48.8695 94.2727 48.5349C94.2538 48.5159 94.2348 48.4931 94.2158 48.4741C93.8551 48.4209 93.2628 48.9227 92.978 49.147C93.016 49.0596 93.0008 49.0329 92.9514 49.0367C92.8072 49.0063 92.7806 48.8163 92.5755 48.8847C92.511 48.9075 92.4578 48.9113 92.3743 49.0215C91.9946 49.242 91.6149 49.4587 91.2352 49.6906C90.9619 49.8579 91.0036 49.4473 90.5822 49.9225C90.4607 50.0594 90.3885 50.0556 90.3126 50.0784C89.8532 50.2115 89.2609 50.6562 88.7711 50.8881C88.6724 50.9338 88.5243 51.082 88.3838 51.1999C88.9191 51.2569 89.7545 50.987 90.4531 50.4966C90.7075 50.3825 90.9619 50.2723 91.2163 50.162C91.1403 50.2609 91.0302 50.3407 90.9998 50.4624C90.9201 50.5384 90.8404 50.6182 90.7606 50.6943C90.7492 50.7209 90.7379 50.7513 90.7303 50.7779C91.034 50.6372 91.0606 50.6258 90.7303 50.7779C90.7379 50.7513 90.7492 50.7247 90.7606 50.6943C90.6657 50.6905 90.5214 50.8881 90.3847 51.063C90.3746 51.0884 90.3746 51.0884 90.3847 51.063C90.2708 51.1086 90.1683 51.1314 90.0203 51.2949C89.857 51.4394 89.6975 51.5078 89.5305 51.7093C89.1356 51.9222 89.2533 51.8423 89.1204 51.9754C89.1432 52.1845 89.4089 52.002 89.5722 51.9906C89.6671 52.2035 89.9329 51.8385 90.1531 51.6333C90.4797 51.5344 90.5784 51.5648 90.8518 51.3785C90.9619 51.2151 90.8518 51.1505 91.0036 50.9946C91.4327 50.5612 91.2694 50.584 91.8124 50.3445C92.0478 50.2533 92.1123 50.4434 92.3212 50.4015C92.287 50.6981 92.5186 50.6448 92.6819 50.6981C92.7502 50.7171 92.7502 50.8463 92.7768 50.93C92.8451 51.1314 92.8831 51.1504 93.1717 50.9261C93.54 50.641 93.9007 50.3635 94.25 50.2038C94.679 50.1126 94.8271 49.3561 95.5143 49.0101C95.6017 48.9759 95.6852 48.9189 95.7497 48.782C95.7649 48.782 95.7839 48.7668 95.7991 48.744C95.8485 48.7212 95.9016 48.6984 95.951 48.6756C96.2357 48.7174 96.7179 48.5007 96.9192 48.151L96.9116 48.1472ZM90.1797 51.2645C90.2253 51.2379 90.2253 51.2379 90.1797 51.2645V51.2645ZM92.7844 49.1204C92.53 49.3371 92.549 49.3181 92.7844 49.1204V49.1204ZM94.9106 49.223C94.9106 49.223 94.9106 49.223 94.9106 49.2154C94.9106 49.2154 94.9106 49.2154 94.9106 49.223ZM95.9775 48.5958L95.932 48.611C95.932 48.611 95.9624 48.5996 95.9775 48.5958ZM96.3079 48.0673C96.3079 48.0673 96.2889 48.0749 96.2775 48.0787L96.3079 48.0673ZM96.5813 48.2384C96.5813 48.2384 96.5623 48.2612 96.5547 48.2726C96.5509 48.2688 96.5433 48.2612 96.5395 48.2574C96.5737 48.2118 96.5623 48.2194 96.5813 48.2384Z",
    fill: "#09363F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M157.502 53.7242C157.365 53.6329 157.24 53.3744 157.35 53.4086C157.529 53.4618 157.779 53.5949 157.931 53.7051C158.045 53.785 158.132 53.9104 158.182 54.0321C158.273 54.2564 158.11 54.1385 157.498 53.728L157.502 53.7242Z",
    fill: "#09363F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M165.407 58.3583C165.316 58.4419 164.952 58.1758 164.621 57.9553C164.796 57.9743 164.921 57.9439 165.172 58.077C165.217 58.0998 165.274 58.1302 165.366 58.2366C165.457 58.3469 165.426 58.3469 165.411 58.3621L165.407 58.3583Z",
    fill: "#09363F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M151.575 100.754C151.556 101.005 151.366 100.963 151.04 100.982C150.801 100.971 150.618 101.005 150.448 100.902C150.296 100.815 150.262 100.617 150.375 100.507C150.569 100.313 151.613 100.245 151.579 100.754H151.575Z",
    fill: "url(#paint16_linear_35_119664)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M104.953 63.3308C104.991 62.6541 104.38 63.0115 104.414 62.4603C104.532 61.8444 105.344 62.734 105.272 63.213C105.215 63.5931 104.938 63.5817 104.953 63.3308Z",
    fill: "url(#paint17_linear_35_119664)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M104.505 63.4375C104.35 63.5629 104.266 63.677 104.338 63.9013C104.407 64.1104 104.262 64.2016 104.103 64.2282C104.046 64.2282 103.993 64.2282 103.936 64.2282C104.004 64.5399 104.418 64.4221 104.369 64.6882C104.353 64.7718 104.304 64.8593 104.247 64.8593C103.951 64.8593 103.659 65.2318 103.4 65.0722C103.233 65.2584 103.476 65.4447 103.252 65.593C103.199 65.6044 103.142 65.612 103.089 65.6234C102.823 66.1594 102.687 65.4789 102.003 66.3001C101.935 66.532 101.84 66.7639 101.825 67.0034C101.825 67.0034 101.829 67.0072 101.832 67.011C102.675 66.9007 102.907 66.8019 102.884 67.1478C102.869 67.3683 102.755 67.4482 102.596 67.4406C102.558 67.4862 102.516 67.5318 102.478 67.5812C102.47 67.8473 102.679 67.9234 102.747 68.1249C102.823 68.1249 102.899 68.1249 102.975 68.1249C103.23 68.1477 103.116 68.524 102.88 68.5278C102.694 68.5278 102.497 68.4176 102.372 68.6989C102.261 68.9384 102.413 68.984 103.066 69.6417C103.108 69.6835 103.165 69.7291 103.127 69.8204C103.093 69.9078 103.013 69.9496 102.968 69.9154C102.679 69.7215 102.345 69.7405 102.003 69.7938C101.935 69.8052 101.851 69.7558 101.813 69.6949C101.673 69.4706 101.46 69.5086 101.244 69.5429C101.027 69.5771 100.815 69.5733 100.598 69.6227C100.086 69.7368 99.615 69.5999 99.0986 69.7443C98.8024 69.828 98.5746 69.6151 98.3468 69.463C98.3164 69.444 98.2899 69.3604 98.3051 69.33C98.4835 68.9916 98.3278 68.8206 98.2367 68.6001C98.0583 68.1515 98.4303 67.8359 98.8974 67.7295C99.4289 67.6078 99.5163 66.5016 100.355 66.1404C100.91 65.9009 100.579 65.3611 101.498 64.8137C102.03 64.4943 101.551 64.3499 101.35 63.7454C101.191 63.2664 101.612 63.3843 102.254 63.255C102.406 63.2246 102.626 63.3082 102.706 63.0573C102.804 62.7304 102.516 62.8596 102.36 62.6962C102.163 62.6353 102.197 62.3844 102.174 62.1905C102.144 61.9586 102.39 61.8028 102.455 61.9853C102.709 62.719 103.575 61.9092 103.689 62.43C103.738 62.5365 103.788 62.6429 103.841 62.7532C103.947 62.7418 103.993 62.8102 104 62.9319C104 62.9319 104 62.9319 104 62.9357C104.156 62.9585 104.3 63.0193 104.467 62.9965C104.718 62.9623 104.714 63.2816 104.521 63.4337L104.505 63.4375Z",
    fill: "#09363F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M166.448 59.5254C167.355 60.2819 166.573 59.1908 167.37 59.9436C167.591 60.1527 167.799 60.3389 168.001 60.5062C168.061 60.6279 167.822 60.4188 167.902 60.5556C168.365 61.0308 168.597 61.1981 168.741 61.1905C169.033 61.3159 169.516 61.6885 169.846 61.8938C169.565 61.5897 169.504 61.6049 169.28 61.3654C169.504 61.5669 169.538 61.5022 169.945 61.9584C170.005 62.0269 170.07 62.0801 170.123 62.1219C170.207 62.1903 170.282 62.2549 170.366 62.3196C170.419 62.3614 170.476 62.3994 170.529 62.4412C170.738 62.6579 170.841 62.7301 170.985 62.8556C171.065 62.9696 171.22 63.1103 171.368 63.2548C171.478 63.3878 171.532 63.4525 171.642 63.5855C171.551 63.5209 171.418 63.4144 171.266 63.2776C171.251 63.27 171.236 63.2586 171.217 63.251C171.201 63.308 170.947 63.0571 170.639 62.8138C170.617 62.8252 170.476 62.6959 170.457 62.7073C170.419 62.6579 170.381 62.6047 170.339 62.5553C170.294 62.5173 170.245 62.4754 170.199 62.4374C170.222 62.4792 170.222 62.5059 170.328 62.6123C170.396 62.6807 170.438 62.7111 170.457 62.7111C170.643 62.9696 170.45 62.829 170.294 62.7263C169.891 62.4564 169.409 62.0953 168.874 61.6429C167.389 60.396 167.025 60.4758 166.095 59.5254C165.525 58.9437 165.984 59.149 166.436 59.5254H166.448Z",
    fill: "#09363F"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M161.713 55.032C161.534 54.9408 161.352 54.8457 161.162 54.7469C161.075 54.7013 160.9 54.4618 161.018 54.515C161.174 54.5872 161.367 54.6861 161.565 54.8267C161.607 54.8571 161.648 54.8838 161.701 54.956C161.743 55.0168 161.751 55.051 161.713 55.032Z",
    fill: "#09363F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M155.934 62.7036C155.976 62.8367 155.85 62.9925 155.729 62.9583C155.528 62.9013 155.023 62.1866 155.49 62.3006C155.672 62.3539 155.892 62.5515 155.934 62.6998V62.7036Z",
    fill: "#09363F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M108.397 89.4747C108.632 89.7826 108.868 90.0943 108.925 90.5961C108.329 90.5961 108.424 89.9081 108.162 89.6115C108.15 89.5963 108.184 89.4861 108.215 89.4557C108.276 89.3948 108.352 89.4139 108.397 89.4747Z",
    fill: "url(#paint18_linear_35_119664)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M165.821 59.438C165.681 59.3924 165.487 59.2555 165.221 59.0503C165.312 58.9362 165.453 59.0388 165.821 59.438Z",
    fill: "#09363F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M154.734 97.5569C154.734 97.2946 154.905 97.3022 155.034 97.2642C155.129 97.2376 155.262 97.2946 155.251 97.4352C155.235 97.6177 155.129 97.7622 154.981 97.804C154.848 97.8382 154.783 97.7013 154.734 97.5569Z",
    fill: "url(#paint19_linear_35_119664)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M168.969 60.9474C168.934 60.9208 168.893 60.8714 168.874 60.8448C168.832 60.7801 168.896 60.8333 168.976 60.9056C169.045 60.936 169.17 61.0424 169.398 61.2553C169.348 61.2591 169.174 61.1223 168.969 60.9474Z",
    fill: "url(#paint20_linear_35_119664)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M146.112 60.974C145.812 60.9018 145.846 60.4075 146.112 60.4532C146.461 60.514 146.461 61.0576 146.112 60.974Z",
    fill: "#09363F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M156.648 96.9677C156.511 96.9449 156.412 96.8346 156.393 96.6522C156.408 96.291 156.819 96.2644 156.826 96.7016C156.826 96.8537 156.8 96.9981 156.648 96.9715V96.9677Z",
    fill: "url(#paint21_linear_35_119664)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M118.706 40.8064C118.303 40.8559 117.897 40.9091 117.494 40.9661C117.604 40.7228 117.745 40.7646 118.706 40.8064Z",
    fill: "url(#paint22_linear_35_119664)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M114.112 45.1935C114.093 45.2961 114.009 45.3114 113.944 45.3038C113.842 45.2923 113.732 45.2695 113.747 45.0985C113.755 45.0072 113.827 44.9616 113.906 44.9502C113.982 45.0148 114.146 44.9806 114.108 45.1935H114.112Z",
    fill: "url(#paint23_linear_35_119664)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M148.602 62.236C148.617 62.3272 148.56 62.369 148.485 62.35C148.371 62.3196 148.245 62.2626 148.196 62.0915C148.154 61.9509 148.249 61.9509 148.336 61.9623C148.447 62.0079 148.572 62.0497 148.602 62.236Z",
    fill: "#09363F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M112.726 56.7162C113.037 57.2484 113.511 57.2218 114.016 57.0887C114.039 57.0697 114.066 57.0583 114.092 57.0507C114.78 57.2028 114.571 56.682 116.04 56.6439C116.124 56.6439 116.222 56.6744 116.287 56.5565C116.295 56.4843 116.257 56.4615 116.215 56.4463C116.006 56.3588 116.021 56.2258 116.184 56.0509C116.511 55.6973 116.864 55.9216 117.293 55.7278C116.777 55.397 116.367 55.6631 116.389 55.3704C116.412 55.0739 116.754 55.2145 117.115 55.2412C117.399 55.264 117.696 55.2145 117.517 54.9598C117.46 54.88 117.399 54.785 117.324 54.7507C116.097 54.1957 116.382 54.4542 115.885 54.6823C115.748 54.6823 115.634 54.7279 115.531 54.8762C115.33 55.1689 115.14 55.2183 114.973 54.9598C114.844 54.7584 114.723 54.7127 114.537 54.823C114.305 54.9598 114.123 54.7089 113.903 54.804C113.846 54.8154 113.792 54.8268 113.735 54.8382C113.523 54.8002 113.318 54.7698 113.09 54.8344C112.338 55.0435 112.224 54.3592 111.735 54.7279C111.613 54.8192 111.488 54.8838 111.355 54.899C111.313 54.9028 111.264 54.9028 111.226 54.9332C110.93 55.1575 110.637 55.3932 110.341 55.6251C110.337 55.6289 110.333 55.6327 110.33 55.6403C110.083 55.8266 110.121 56.0737 110.273 56.1573C110.531 56.3018 110.759 56.5033 111.028 56.6249C111.1 56.6554 111.173 56.6021 111.233 56.5261C111.302 56.5337 111.366 56.5375 111.435 56.4843C111.427 56.4957 111.419 56.4995 111.412 56.5071C111.446 56.5679 111.495 56.5869 111.56 56.5641C111.571 56.5641 111.575 56.5641 111.586 56.5641C111.617 56.72 111.735 56.6896 111.864 56.6668C112.053 56.777 112.126 56.8796 112.353 56.8416C112.486 56.7694 112.403 56.7998 112.729 56.72L112.726 56.7162ZM111.784 56.1041C111.543 56.1548 111.543 56.1548 111.784 56.1041V56.1041ZM114.024 55.8798L114.047 55.9369C114.047 55.9369 114.035 55.895 114.024 55.8798ZM113.23 56.1003C113.23 56.1003 113.42 56.26 113.436 56.4463C113.42 56.2562 113.23 56.1003 113.23 56.1003ZM113.177 56.3816C113.177 56.3816 113.181 56.4577 113.177 56.4957C113.181 56.4539 113.177 56.3816 113.177 56.3816Z",
    fill: "#09363F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M162.29 57.5636C162.214 57.4615 162.346 57.5296 162.411 57.6279C162.486 57.7451 162.365 57.6657 162.29 57.5636Z",
    fill: "url(#paint24_linear_35_119664)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M164.598 57.2597C164.241 56.9517 163.942 56.7275 163.653 56.5298C163.52 56.4385 163.41 56.3853 163.288 56.3169C163.03 56.2256 162.662 55.8417 162.487 55.8569C162.396 55.8645 162.172 55.6896 162.032 55.6364C161.865 55.5756 161.941 55.7885 161.834 55.8037C161.796 55.8075 161.944 55.9633 162.009 56.0051C162.324 56.2142 162.681 56.4879 162.81 56.4309C162.852 56.4119 162.932 56.4537 163.076 56.5982C163.163 56.7465 162.981 56.5716 163.034 56.678C163.273 56.8681 163.471 56.9936 163.661 57.0924C163.531 56.9023 163.433 56.8833 163.364 56.7997C163.304 56.7198 163.3 56.7046 163.315 56.7084C163.372 56.7237 163.467 56.7959 163.554 56.8643C163.938 57.157 164.238 57.3243 164.549 57.5182C164.682 57.6018 164.431 57.2749 164.503 57.2711C164.652 57.3623 164.781 57.4726 164.595 57.2635L164.598 57.2597ZM163.08 56.2827C163.08 56.2827 163.08 56.2979 163.083 56.3055L163.08 56.2827Z",
    fill: "#09363F"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2893 56.8718C93.2893 56.8718 93.3044 56.8415 93.312 56.8264C93.3233 56.8264 93.3309 56.8302 93.3422 56.834C93.312 56.8907 93.3271 56.8793 93.2893 56.8718Z",
    fill: "url(#paint25_linear_35_119664)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3487 58.7424C83.3298 58.7916 83.3071 58.8407 83.2882 58.8899C83.2429 58.871 83.2693 58.8181 83.3487 58.7424Z",
    fill: "url(#paint26_linear_35_119664)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1834 82.054C66.1644 82.1224 66.1454 82.1908 66.1265 82.2592C66.0771 82.2707 66.0315 82.2821 65.9822 82.2935C66.0163 82.1794 66.0847 82.1034 66.1834 82.054Z",
    fill: "url(#paint27_linear_35_119664)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7549 79.2217C78.7549 79.2519 78.7549 79.2859 78.7549 79.32C78.7247 79.3011 78.7285 79.2671 78.7549 79.2217Z",
    fill: "url(#paint28_linear_35_119664)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M159.697 76.8836C159.875 76.9786 159.845 77.1573 159.875 77.3094C159.75 77.2143 159.625 77.1231 159.499 77.028C159.533 76.9292 159.579 76.8189 159.701 76.8836H159.697Z",
    fill: "url(#paint29_linear_35_119664)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4592 79.1037C91.5047 78.8148 91.4971 78.5487 91.4516 78.2826C91.406 78.0164 91.5731 77.7009 91.7325 77.6477C91.9224 77.5831 92.3894 77.8302 92.0705 78.446C91.9604 78.6551 91.8313 78.8566 91.7705 79.0885C91.8616 79.2254 91.9945 79.2824 92.1426 79.309C92.2375 79.3242 92.3286 79.404 92.2641 79.5295C91.8275 80.3544 92.3135 81.149 91.7174 81.1262C90.92 81.0957 91.1858 80.2784 91.1402 80.0503C91.0681 79.6815 91.2086 79.3774 91.4592 79.0999V79.1037Z",
    fill: "url(#paint30_linear_35_119664)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4863 85.2852C80.4863 85.2852 80.4863 85.2852 80.4977 85.2852C80.604 85.2776 80.7179 85.2814 80.7141 85.4372C80.7141 85.787 80.2547 85.5969 80.0383 85.8212C79.632 86.2432 79.2903 85.9809 78.9182 86.0569C78.8574 86.0683 78.8195 86.0151 78.8309 85.9314C78.865 85.7071 80.0497 85.4182 80.4863 85.2852Z",
    fill: "url(#paint31_linear_35_119664)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5252 86.5359C74.6429 86.5625 74.6012 86.7564 74.4683 86.8704C74.3392 86.9768 74.2101 87.0035 74.0848 86.9844C73.7279 86.9312 73.4051 86.8362 73.4127 86.304C73.5912 86.3762 73.781 86.437 74.0013 86.38C74.2215 86.323 74.343 86.4978 74.5214 86.5397L74.5252 86.5359Z",
    fill: "url(#paint32_linear_35_119664)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3685 80.0467C96.4065 80.271 95.761 80.5409 95.7686 80.1227C95.8104 79.792 96.3192 79.7502 96.3685 80.0467Z",
    fill: "url(#paint33_linear_35_119664)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4125 86.2963C73.3861 86.2925 73.3861 86.3076 73.3861 86.319C73.3861 86.319 73.3861 86.3114 73.3823 86.3076C73.3823 86.3001 73.3747 86.2811 73.3785 86.2811C73.4012 86.2585 73.4163 86.2622 73.4163 86.2963H73.4125Z",
    fill: "url(#paint34_linear_35_119664)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9038 83.5442C64.8544 83.6088 64.8089 83.6772 64.7595 83.7419C64.7785 83.6544 64.8279 83.5898 64.9038 83.5442Z",
    fill: "url(#paint35_linear_35_119664)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2656 132.585C59.1782 132.585 59.0947 132.566 59.0112 132.524L58.3353 132.174C58.062 132.034 57.9556 131.699 58.0961 131.425C58.2366 131.152 58.5707 131.045 58.8441 131.186L59.52 131.536C59.7933 131.676 59.8997 132.011 59.7592 132.284C59.6604 132.475 59.4668 132.585 59.2656 132.585Z",
    fill: "#CCEDE8"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3991 82.3884H85.1489C82.6506 82.3884 80.623 84.4147 80.623 86.92V96.7661C80.623 99.2676 82.6506 101.298 85.1489 101.298H87.5144L90.1494 104.362C90.5557 104.837 91.2885 104.837 91.6985 104.362L94.3336 101.298H96.3953C98.8936 101.298 100.921 99.2676 100.921 96.7661V86.92C100.921 84.4185 98.8974 82.3884 96.3953 82.3884H96.3991Z",
    fill: "#30CFB0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9241 91.7329C92.5241 91.7329 93.8211 90.424 93.8211 88.8094C93.8211 87.1949 92.5241 85.886 90.9241 85.886C89.3241 85.886 88.0271 87.1949 88.0271 88.8094C88.0271 90.424 89.3241 91.7329 90.9241 91.7329Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4144 96.7092V97.6634H85.1528V96.7092C85.1528 94.5955 86.8614 92.8848 88.9725 92.8848H89.5724C89.7243 92.8848 89.8648 92.9646 89.9369 93.0977L90.552 94.1773C90.7153 94.4586 91.1215 94.4586 91.2848 94.1773L91.8999 93.0977C91.9758 92.9646 92.1163 92.8848 92.2644 92.8848H92.5871C94.6982 92.8848 96.4068 94.5993 96.4068 96.7092H96.4144Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6619 103.921C110.493 69.1549 144.661 57.3243 161.01 83.8824",
    stroke: "#30CFB0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M161.01 85.2927C161.788 85.2927 162.419 84.6613 162.419 83.8823C162.419 83.1034 161.788 82.4719 161.01 82.4719C160.232 82.4719 159.602 83.1034 159.602 83.8823C159.602 84.6613 160.232 85.2927 161.01 85.2927Z",
    fill: "#30CFB0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8669 105.331C99.6449 105.331 100.276 104.7 100.276 103.921C100.276 103.142 99.6449 102.51 98.8669 102.51C98.0889 102.51 97.4583 103.142 97.4583 103.921C97.4583 104.7 98.0889 105.331 98.8669 105.331Z",
    fill: "#30CFB0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M227.251 111.707H173.513C171.855 111.707 170.51 113.053 170.51 114.714V166.294C170.51 167.955 171.855 169.301 173.513 169.301H227.251C228.909 169.301 230.254 167.955 230.254 166.294V114.714C230.254 113.053 228.909 111.707 227.251 111.707Z",
    fill: "#F5F5F5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M176.642 151.16H174.683V151.726H176.642V151.16Z",
    fill: "#09363F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 154.182H179.121V154.748H181.627V154.182Z",
    fill: "#09363F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M190.356 154.182H187.85V154.748H190.356V154.182Z",
    fill: "#09363F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M199.085 154.182H196.579V154.748H199.085V154.182Z",
    fill: "#09363F"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M207.811 154.182H205.305V154.748H207.811V154.182Z",
    fill: "#09363F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M216.54 154.182H214.034V154.748H216.54V154.182Z",
    fill: "#09363F"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M225.269 154.182H222.763V154.748H225.269V154.182Z",
    fill: "#09363F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M176.642 143.602H174.683V144.168H176.642V143.602Z",
    fill: "#09363F"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M176.642 129.384H174.683V129.95H176.642V129.384Z",
    fill: "#09363F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M176.642 122.237H174.683V122.803H176.642V122.237Z",
    fill: "#09363F"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M176.745 136.493H174.785V137.059H176.745V136.493Z",
    fill: "#09363F"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M225.2 151.726C225.2 151.726 225.128 151.734 224.991 151.737C224.847 151.737 224.642 151.741 224.373 151.745C223.822 151.749 223.025 151.756 222 151.764C219.934 151.772 216.953 151.783 213.274 151.794C205.901 151.802 195.725 151.81 184.486 151.821C182.151 151.821 179.858 151.821 177.663 151.821H177.572V151.73C177.584 142.093 177.595 133.611 177.603 127.529C177.614 124.499 177.625 122.066 177.629 120.382C177.637 119.549 177.641 118.903 177.644 118.458C177.644 118.245 177.652 118.078 177.652 117.96C177.652 117.85 177.66 117.789 177.66 117.789C177.66 117.789 177.667 117.846 177.667 117.96C177.667 118.078 177.671 118.245 177.675 118.458C177.675 118.903 177.682 119.549 177.69 120.382C177.698 122.062 177.705 124.495 177.717 127.529C177.724 133.608 177.736 142.089 177.747 151.73L177.656 151.639C179.85 151.639 182.14 151.639 184.479 151.639C195.718 151.65 205.893 151.658 213.267 151.665C216.946 151.677 219.926 151.688 221.992 151.696C223.017 151.703 223.814 151.711 224.365 151.715C224.631 151.718 224.836 151.722 224.984 151.722C225.124 151.722 225.193 151.73 225.193 151.73L225.2 151.726Z",
    fill: "#09363F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M225.755 136.774C225.755 136.828 215.416 136.866 202.662 136.866C189.908 136.866 179.566 136.824 179.566 136.774C179.566 136.725 189.905 136.683 202.662 136.683C215.42 136.683 225.755 136.725 225.755 136.774Z",
    fill: "#09363F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M225.755 129.665C225.755 129.718 215.416 129.756 202.662 129.756C189.908 129.756 179.566 129.715 179.566 129.665C179.566 129.616 189.905 129.574 202.662 129.574C215.42 129.574 225.755 129.616 225.755 129.665Z",
    fill: "#09363F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M225.755 122.518C225.755 122.571 215.416 122.609 202.662 122.609C189.908 122.609 179.566 122.568 179.566 122.518C179.566 122.469 189.905 122.427 202.662 122.427C215.42 122.427 225.755 122.469 225.755 122.518Z",
    fill: "#09363F"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M225.755 143.887C225.755 143.94 215.416 143.978 202.662 143.978C189.908 143.978 179.566 143.937 179.566 143.887C179.566 143.838 189.905 143.796 202.662 143.796C215.42 143.796 225.755 143.838 225.755 143.887Z",
    fill: "#09363F"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M180.04 150.194V143.887L183.966 137.782L186.632 139.831L192.103 131.323L195.33 133.596L199.818 125.75L203.463 128.723L208.934 118.314L214.823 129.95L219.592 124.13L225.204 122.522V150.198H180.044L180.04 150.194Z",
    fill: "#A9EBDB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M225.755 120.279C225.755 120.279 225.72 120.283 225.656 120.287C225.584 120.287 225.489 120.291 225.363 120.294C225.098 120.294 224.718 120.302 224.224 120.31C223.218 120.313 221.764 120.325 219.919 120.332L219.961 120.313C218.708 121.956 217.143 124.001 215.347 126.35L215.325 126.381H215.287C211.934 126.385 208.008 126.392 203.736 126.396L203.812 126.354C202.294 128.89 200.653 131.623 198.956 134.448C197.301 137.2 195.702 139.865 194.187 142.382L194.119 142.5L194.039 142.389C191.757 139.249 189.646 136.341 187.782 133.775H187.907C185.53 137.478 183.571 140.534 182.201 142.674C181.517 143.731 180.978 144.564 180.61 145.134C180.427 145.412 180.287 145.624 180.188 145.777C180.093 145.921 180.036 145.993 180.036 145.993C180.036 145.993 180.078 145.913 180.169 145.765C180.264 145.609 180.401 145.393 180.572 145.111C180.932 144.533 181.46 143.697 182.128 142.629C183.488 140.481 185.428 137.413 187.782 133.691L187.843 133.596L187.907 133.687C189.779 136.25 191.894 139.15 194.187 142.283L194.039 142.29C195.55 139.774 197.149 137.109 198.801 134.353C200.498 131.528 202.142 128.795 203.661 126.263L203.687 126.221H203.736C208.008 126.229 211.934 126.232 215.287 126.236L215.23 126.267C217.041 123.925 218.613 121.891 219.877 120.256L219.892 120.237H219.919C221.764 120.249 223.218 120.256 224.224 120.26C224.714 120.268 225.098 120.272 225.363 120.275C225.489 120.275 225.584 120.279 225.656 120.283C225.72 120.283 225.755 120.287 225.755 120.291V120.279Z",
    fill: "#09363F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M189.297 136.174C189.542 136.174 189.741 135.983 189.741 135.748C189.741 135.513 189.542 135.322 189.297 135.322C189.052 135.322 188.853 135.513 188.853 135.748C188.853 135.983 189.052 136.174 189.297 136.174Z",
    fill: "#09363F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M203.065 128.167C203.065 128.403 202.867 128.593 202.62 128.593C202.373 128.593 202.176 128.403 202.176 128.167C202.176 127.932 202.373 127.742 202.62 127.742C202.867 127.742 203.065 127.932 203.065 128.167Z",
    fill: "#09363F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M213.418 126.305C213.418 126.54 213.221 126.73 212.974 126.73C212.727 126.73 212.53 126.54 212.53 126.305C212.53 126.069 212.727 125.879 212.974 125.879C213.221 125.879 213.418 126.069 213.418 126.305Z",
    fill: "#09363F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M184.851 161.743C184.851 163.268 183.567 164.507 181.984 164.507C180.401 164.507 179.117 163.271 179.117 161.743C179.117 160.215 180.401 158.979 181.984 158.979C183.567 158.979 184.851 160.215 184.851 161.743Z",
    fill: "#A9EBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M222.766 159.892H189.103V160.926H222.766V159.892Z",
    fill: "#E1E1E1"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M203.08 162.473H189.103V163.507H203.08V162.473Z",
    fill: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_119664",
    x1: 153.31,
    y1: 50.9339,
    x2: 90.5299,
    y2: 158.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#CCEDE8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#CCEDE8",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CCEDE8",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#CCEDE8",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CCEDE8",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#CCEDE8",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_119664",
    x1: 147.808,
    y1: 40.5674,
    x2: 147.808,
    y2: 141.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_119664",
    x1: 153.378,
    y1: -1.45066,
    x2: 153.378,
    y2: 408.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_119664",
    x1: 156.177,
    y1: 9.36593,
    x2: 156.177,
    y2: 349.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_119664",
    x1: 173.187,
    y1: 30.9348,
    x2: 173.187,
    y2: 190.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_119664",
    x1: 149.126,
    y1: 75.9254,
    x2: 149.126,
    y2: 178.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35_119664",
    x1: 144.281,
    y1: 52.9633,
    x2: 144.281,
    y2: 185.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35_119664",
    x1: 140.56,
    y1: 32.8818,
    x2: 140.56,
    y2: 193.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_35_119664",
    x1: 168.467,
    y1: 42.8,
    x2: 168.467,
    y2: 176.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_35_119664",
    x1: 168.775,
    y1: 20.4122,
    x2: 168.775,
    y2: 300.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_35_119664",
    x1: 160.475,
    y1: 27.1433,
    x2: 160.475,
    y2: 194.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_35_119664",
    x1: 67.4781,
    y1: 39.4151,
    x2: 67.4781,
    y2: 180.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_35_119664",
    x1: 154.681,
    y1: 24.7861,
    x2: 154.681,
    y2: 197.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_35_119664",
    x1: 159.321,
    y1: 30.2838,
    x2: 159.321,
    y2: 189.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_35_119664",
    x1: 159.097,
    y1: 25.8998,
    x2: 159.097,
    y2: 195.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_35_119664",
    x1: 146.415,
    y1: 36.4991,
    x2: 146.415,
    y2: 165.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_35_119664",
    x1: 150.941,
    y1: 22.452,
    x2: 150.941,
    y2: 199.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_35_119664",
    x1: 104.847,
    y1: 29.5157,
    x2: 104.847,
    y2: 179.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_35_119664",
    x1: 108.541,
    y1: 22.0418,
    x2: 108.541,
    y2: 199.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_35_119664",
    x1: 154.992,
    y1: 25.2093,
    x2: 154.992,
    y2: 196.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_35_119664",
    x1: 169.132,
    y1: 38.2975,
    x2: 169.132,
    y2: 244.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_35_119664",
    x1: 156.606,
    y1: 25.0895,
    x2: 156.606,
    y2: 196.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_35_119664",
    x1: 118.102,
    y1: 27.5424,
    x2: 118.102,
    y2: 188.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_35_119664",
    x1: 113.933,
    y1: 29.5571,
    x2: 113.933,
    y2: 170.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_35_119664",
    x1: 162.35,
    y1: 38.5722,
    x2: 162.35,
    y2: 186.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_35_119664",
    x1: 93.3158,
    y1: 35.518,
    x2: 93.3158,
    y2: 164.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_35_119664",
    x1: 83.3071,
    y1: 39.784,
    x2: 83.3071,
    y2: 164.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_35_119664",
    x1: 66.0847,
    y1: 35.1645,
    x2: 66.0847,
    y2: 189.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_35_119664",
    x1: 78.7436,
    y1: 35.5665,
    x2: 78.7436,
    y2: 179.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_35_119664",
    x1: 159.685,
    y1: 28.7845,
    x2: 159.685,
    y2: 193.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_35_119664",
    x1: 91.7022,
    y1: 28.2838,
    x2: 91.7022,
    y2: 190.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_35_119664",
    x1: 79.7725,
    y1: 22.4749,
    x2: 79.7725,
    y2: 204.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_35_119664",
    x1: 74.005,
    y1: 42.5547,
    x2: 74.005,
    y2: 169.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_35_119664",
    x1: 96.0724,
    y1: 25.4782,
    x2: 96.0724,
    y2: 194.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_35_119664",
    x1: 73.3936,
    y1: 34.2126,
    x2: 73.3936,
    y2: 185.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_35_119664",
    x1: 64.8317,
    y1: 36.542,
    x2: 64.8317,
    y2: 186.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#09363F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09363F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationImg);
export default __webpack_public_path__ + "static/media/monetizationImg.26295f4e8a81024d4b9f7bf6d0fc4861.svg";
export { ForwardRef as ReactComponent };